var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagEsp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2358 2973)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_452",
    "data-name": "Ret\\xE2ngulo 452",
    width: 102.853,
    height: 59.993,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_453",
    "data-name": "Ret\\xE2ngulo 453",
    width: 2.724,
    height: 3.199,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_ESP",
    transform: "translate(-2358 -2973)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_espanha",
    transform: "translate(2349 2973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_442",
    "data-name": "Ret\\xE2ngulo 442",
    width: 102.853,
    height: 59.993,
    transform: "translate(0 0)",
    fill: "#b5002a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_443",
    "data-name": "Ret\\xE2ngulo 443",
    width: 102.853,
    height: 30.002,
    transform: "translate(0 14.992)",
    fill: "#f4c327"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_786",
    "data-name": "Grupo 786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_785",
    "data-name": "Grupo 785",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6239",
    "data-name": "Caminho 6239",
    d: "M466.279,15.894a.222.222,0,0,1-.1-.021,1.106,1.106,0,0,1-.144-.113l-.07-.055L465.9,15.6a.261.261,0,0,1,.113-.418,1.458,1.458,0,0,1,.186-.072s.1-.048.137-.06a1.2,1.2,0,0,0,.156-.036l.072-.029a.308.308,0,0,1,.1-.019.779.779,0,0,1,.139-.029c.06,0,.154.009.185.009s.156.009.2.009.214-.015.263-.015.084,0,.144,0a.756.756,0,0,1,.168.055c.029.012.192.069.239.086a2.549,2.549,0,0,1,.288.079.423.423,0,0,1,.137.132,1.041,1.041,0,0,1,.055.125.181.181,0,0,1,0,.134c-.019.027-.06.1-.06.1l-.079.12-.089.079a.192.192,0,0,1-.12.053,8.126,8.126,0,0,0-.952-.1,6.526,6.526,0,0,0-.9.1",
    transform: "translate(-446.288 10.671)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6240",
    "data-name": "Caminho 6240",
    d: "M468.142,15.917h0a7.358,7.358,0,0,0-.951-.094,6.879,6.879,0,0,0-.9.094.655.655,0,0,1-.245-.137l-.156-.158a.431.431,0,0,1-.055-.264.332.332,0,0,1,.175-.185,1.536,1.536,0,0,1,.2-.075.847.847,0,0,1,.137-.053l.151-.033.137-.048.173-.039.281.033v-.015l.377-.009.144.012v-.012a.557.557,0,0,1,.168.051c.029.009.19.065.25.086a1.818,1.818,0,0,1,.281.084.523.523,0,0,1,.151.132l.035.135.019-.009a.63.63,0,0,1,0,.142l-.137.225-.1.079a.206.206,0,0,1-.132.058m-.951-.134a6.875,6.875,0,0,1,.867.093l.084.012a.175.175,0,0,0,.108-.053l.161-.2.06-.213-.048-.122a.34.34,0,0,0-.137-.123.861.861,0,0,0-.187-.053c-.149-.043-.31-.1-.339-.117a.66.66,0,0,0-.156-.048l-.408.012-.37-.019-.156.015v.017l-.166.048-.156.039a.556.556,0,0,0-.132.051,1.552,1.552,0,0,0-.192.065.349.349,0,0,0-.161.177.311.311,0,0,0,.048.228l.065.108c.115.077.192.153.221.165.091.024.641-.087.995-.087",
    transform: "translate(-446.294 10.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6241",
    "data-name": "Caminho 6241",
    d: "M466.525,15.161c0-.161.072-.3.168-.3s.156.135.156.3-.072.3-.156.3-.168-.129-.168-.3",
    transform: "translate(-445.791 10.621)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6242",
    "data-name": "Caminho 6242",
    d: "M466.7,15.466c-.1,0-.185-.135-.185-.314,0-.348.353-.348.353,0,0,.178-.072.314-.168.314m0-.59c-.077,0-.156.123-.156.276,0,.307.3.307.3,0,0-.153-.067-.276-.144-.276",
    transform: "translate(-445.799 10.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6243",
    "data-name": "Caminho 6243",
    d: "M466.581,15.149c0-.147.029-.269.072-.269s.077.122.077.269-.036.276-.077.276-.072-.12-.072-.276",
    transform: "translate(-445.751 10.633)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6244",
    "data-name": "Caminho 6244",
    d: "M466.66,15.445c-.061,0-.089-.149-.089-.29s.029-.285.089-.285.1.141.1.285-.031.29-.1.29",
    transform: "translate(-445.758 10.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6245",
    "data-name": "Caminho 6245",
    d: "M466.557,14.9a.108.108,0,0,1,.113-.1.1.1,0,0,1,.108.1.1.1,0,0,1-.108.106.111.111,0,0,1-.113-.106",
    transform: "translate(-445.769 10.574)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6246",
    "data-name": "Caminho 6246",
    d: "M466.748,14.957v.072h-.173v-.072h.06V14.8h-.079v-.06h.079v-.072h.07v.072h.074v.06h-.074v.161Z",
    transform: "translate(-445.768 10.478)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6247",
    "data-name": "Caminho 6247",
    d: "M466.844,14.957v.072h-.312v-.072h.121V14.8h-.077v-.06h.077v-.072h.072v.072h.072v.06h-.072v.161Z",
    transform: "translate(-445.786 10.478)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6248",
    "data-name": "Caminho 6248",
    d: "M466.675,15.02a.117.117,0,0,1-.125-.117.113.113,0,0,1,.089-.113l-.06.113c0,.1.192.1.192,0l-.06-.113a.114.114,0,0,1,.084.113.112.112,0,0,1-.12.117",
    transform: "translate(-445.774 10.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6249",
    "data-name": "Caminho 6249",
    d: "M467.037,15.851h-.569l-.012-.137-.029-.147-.031-.182c-.161-.207-.305-.348-.352-.317a.112.112,0,0,1,.058-.081c.139-.087.42.113.648.439a.7.7,0,0,0,.053.1h.474a.415.415,0,0,1,.06-.1c.209-.326.49-.526.634-.439a.1.1,0,0,1,.065.081c-.053-.031-.2.11-.353.317l-.029.182-.031.147-.012.137Z",
    transform: "translate(-446.135 10.694)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6250",
    "data-name": "Caminho 6250",
    d: "M467.623,15.879H466.46l-.089-.487c-.161-.207-.276-.3-.317-.3l.017-.019c.12.036.276.245.329.312l.072.475,1.12-.015.072-.454c.053-.072.216-.293.317-.326l.041.029c-.089-.012-.178.093-.341.309Zm-.826-.338c-.252-.365-.479-.554-.629-.554l-.072.045.072-.077c.161,0,.4.194.586.473l.353.06Zm.514-.093c.209-.317.438-.494.582-.494l.017.041-.017-.009c-.144,0-.384.189-.551.458Z",
    transform: "translate(-446.128 10.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6251",
    "data-name": "Caminho 6251",
    d: "M467.45,15.485c.185-.336.442-.533.563-.466l-.024.026c-.1-.06-.341.147-.538.441m-.814-.015c-.216-.278-.473-.485-.562-.425l-.019-.026c.115-.058.377.13.581.451",
    transform: "translate(-446.128 10.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6252",
    "data-name": "Caminho 6252",
    d: "M466.154,15.737a.507.507,0,0,0-.062-.132,3.324,3.324,0,0,1,.911-.11,3.4,3.4,0,0,1,.917.11,1.174,1.174,0,0,0-.068.108c-.018.043-.048.1-.048.1a2.7,2.7,0,0,0-.8-.1,3.169,3.169,0,0,0-.827.1.637.637,0,0,1-.022-.075",
    transform: "translate(-446.1 11.072)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6253",
    "data-name": "Caminho 6253",
    d: "M466.186,15.847l-.012-.017.012-.01-.036-.072a.451.451,0,0,0-.072-.125,3.04,3.04,0,0,1,.934-.141,3.644,3.644,0,0,1,.92.12l-.06.134h-.017l.053-.129a4.6,4.6,0,0,0-.9-.089,3.8,3.8,0,0,0-.9.1.211.211,0,0,1,.065.113l.012.072a2.815,2.815,0,0,1,.826-.1,3.746,3.746,0,0,1,.58.041c-.173,0-.365-.012-.58-.012a2.665,2.665,0,0,0-.814.106Z",
    transform: "translate(-446.111 11.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6254",
    "data-name": "Caminho 6254",
    d: "M466.978,15.936a3.566,3.566,0,0,0,.724-.072c.079-.021.127-.06.12-.1a.1.1,0,0,0-.053-.043,2.832,2.832,0,0,0-.791-.1,2.966,2.966,0,0,0-.8.1.113.113,0,0,0-.048.043c-.005.041.042.081.12.1a3.721,3.721,0,0,0,.73.072",
    transform: "translate(-446.076 11.163)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6255",
    "data-name": "Caminho 6255",
    d: "M466.983,15.962a3.481,3.481,0,0,1-.736-.079c-.09-.024-.139-.062-.126-.117a2.753,2.753,0,0,1,1.665-.051c.06.106.012.144-.072.168a3.327,3.327,0,0,1-.73.079m0-.312a3.053,3.053,0,0,0-.8.089c-.042.063,0,.1.072.117a5.64,5.64,0,0,0,1.442,0c.072-.021.113-.053.108-.082a2.247,2.247,0,0,0-.827-.123",
    transform: "translate(-446.081 11.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6256",
    "data-name": "Caminho 6256",
    d: "M467.941,15.562l-.072-.057a.255.255,0,0,1-.156.026c-.084-.014-.113-.117-.113-.117a.277.277,0,0,1-.173.07.165.165,0,0,1-.12-.07.3.3,0,0,1-.162.055c-.066-.007-.138-.1-.138-.1a.318.318,0,0,1-.155.1.185.185,0,0,1-.132-.07.168.168,0,0,1-.132.091.211.211,0,0,1-.173-.072.324.324,0,0,1-.12.11.217.217,0,0,1-.144-.034.387.387,0,0,1-.029.05c-.007.021-.036.027-.036.027l.018.051a3.613,3.613,0,0,1,.9-.1,3.416,3.416,0,0,1,.9.106Z",
    transform: "translate(-446.105 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6257",
    "data-name": "Caminho 6257",
    d: "M467.9,15.65a3.4,3.4,0,0,0-.9-.111,3.484,3.484,0,0,0-.892.108l.036-.129c-.024-.009-.007,0,0,0l.005-.027.115.039h.024v-.007a.409.409,0,0,0,.113-.1.237.237,0,0,0,.156.069c.173-.033.137-.084.143-.084.031,0,.072.057.132.057a.241.241,0,0,0,.144-.1c.036,0,.1.087.161.1a.291.291,0,0,0,.151-.053c.024,0,.07.06.13.069a.317.317,0,0,0,.168-.069c.024,0,.048.1.12.11l.168-.024-.012.015.012.036a.807.807,0,0,0-.139.005.182.182,0,0,1-.149-.118.226.226,0,0,1-.156.077.215.215,0,0,1-.142-.077.189.189,0,0,1-.139.057.265.265,0,0,1-.161-.1.185.185,0,0,1-.144.1.256.256,0,0,1-.144-.065c0,.021-.029.072-.113.087a.271.271,0,0,1-.185-.079.143.143,0,0,1-.067.091c.175.005.42-.019.666-.019a3.584,3.584,0,0,1,.892.1v.007l.007,0,.018,0-.012.012-.005,0Z",
    transform: "translate(-446.093 10.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6258",
    "data-name": "Caminho 6258",
    d: "M467.1,15.3l.036.014a.055.055,0,0,0-.012.043.128.128,0,0,0,.132.125.143.143,0,0,0,.132-.082l.018-.048.006.048c0,.058.07.106.13.106a.132.132,0,0,0,.132-.125v-.019l.042-.039.024.055a.124.124,0,0,0-.019.057.135.135,0,0,0,.132.12.157.157,0,0,0,.108-.06l.024-.036V15.5c0,.046.012.084.06.089,0,0,.042.007.108-.048a1.136,1.136,0,0,0,.089-.089l.005.053a.407.407,0,0,1-.113.127.265.265,0,0,1-.113.036.149.149,0,0,1-.079-.072.181.181,0,0,1-.1.022.187.187,0,0,1-.173-.106.169.169,0,0,1-.132.065.185.185,0,0,1-.149-.067.219.219,0,0,1-.137.05.2.2,0,0,1-.156-.084.2.2,0,0,1-.156.084.169.169,0,0,1-.13-.05.206.206,0,0,1-.156.067.182.182,0,0,1-.139-.065.165.165,0,0,1-.167.106.153.153,0,0,1-.091-.022.151.151,0,0,1-.084.072.291.291,0,0,1-.113-.036.458.458,0,0,1-.12-.127l.006-.053a.826.826,0,0,0,.1.089.153.153,0,0,0,.113.048c.036-.005.048-.043.048-.089v-.043l.036.036a.114.114,0,0,0,.1.06.131.131,0,0,0,.132-.12.158.158,0,0,0-.012-.057l.024-.055.029.039v.019a.13.13,0,0,0,.139.125.126.126,0,0,0,.132-.106l.006-.048c.006,0,.019.048.019.048a.137.137,0,0,0,.125.082.127.127,0,0,0,.132-.125.093.093,0,0,0-.006-.043Z",
    transform: "translate(-446.203 10.933)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6259",
    "data-name": "Caminho 6259",
    d: "M468.042,15.676l-.053-.029.041.017v-.017l.012.017.1-.045a.335.335,0,0,0,.1-.125c-.127.106-.18.106-.187.106h-.012l-.07-.1a.142.142,0,0,1-.252-.057.19.19,0,0,0,.144.089l.036-.034.108-.034.046.127.1-.058a.65.65,0,0,0,.091-.089.185.185,0,0,1-.091.2Zm-1.855,0-.118-.033a.47.47,0,0,1-.127-.135v-.029l.031.015a.479.479,0,0,0,.106.125l.067-.027-.1-.041a.6.6,0,0,0-.055-.048l.173.084.043-.091.029.01a.121.121,0,0,1-.029.081l.065-.01c.156.024.229-.014.246-.07a.223.223,0,0,0,.293-.012c.127.065.228.057.288-.031a.22.22,0,0,0,.293.031c.108.081.221.081.281.009a.248.248,0,0,0,.185.1l.019.007c-.12.012-.18-.031-.2-.089-.017.094-.209.082-.286,0-.038.081-.216.065-.288-.036-.024.1-.2.117-.288.036-.029.086-.214.093-.293.005,0,.067-.072.108-.155.108a.829.829,0,0,0-.175.048m.168-.117-.1-.051.1.021a.112.112,0,0,0,.113-.1l.043-.12c.077.249.257.2.274.087a.043.043,0,0,0,.024.009c-.017.144-.293.117-.293-.027-.017.127-.077.183-.161.183",
    transform: "translate(-446.208 10.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6260",
    "data-name": "Caminho 6260",
    d: "M467.02,15.52a3.26,3.26,0,0,0-.91.111.032.032,0,0,1-.042-.022c-.006-.012.005-.029.018-.038a3.339,3.339,0,0,1,.934-.115,3.393,3.393,0,0,1,.935.115c.012.009.024.026.017.038a.028.028,0,0,1-.036.022,3.3,3.3,0,0,0-.916-.111",
    transform: "translate(-446.118 11.045)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6261",
    "data-name": "Caminho 6261",
    d: "M467.924,15.656h-.012a3.884,3.884,0,0,0-1.819,0,.479.479,0,0,1,.144-.087,4.736,4.736,0,0,1,1.687.057v.019l.007-.007Zm.012-.051A3.113,3.113,0,0,0,467,15.48a4.083,4.083,0,0,0-.681.057,2.183,2.183,0,0,1,.681-.087,3.393,3.393,0,0,1,.935.115Z",
    transform: "translate(-446.1 11.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6262",
    "data-name": "Caminho 6262",
    d: "M466.421,15.59a.053.053,0,0,1,.048-.051.049.049,0,0,1,.053.051c0,.024-.017.045-.053.045a.049.049,0,0,1-.048-.045",
    transform: "translate(-445.865 11.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6263",
    "data-name": "Caminho 6263",
    d: "M466.7,15.609h-.125c-.019,0-.043-.015-.043-.036s.024-.033.043-.033h.233a.035.035,0,0,1,.036.033.038.038,0,0,1-.036.036Z",
    transform: "translate(-445.786 11.104)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6264",
    "data-name": "Caminho 6264",
    d: "M466.337,15.64l-.077.009c-.024.007-.036-.009-.048-.029a.042.042,0,0,1,.036-.039l.077-.012.084-.015a.056.056,0,0,1,.053.034.038.038,0,0,1-.036.038Z",
    transform: "translate(-446.015 11.114)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6265",
    "data-name": "Caminho 6265",
    d: "M466.092,15.663l.036-.06.077.012-.041.072Z",
    transform: "translate(-446.1 11.149)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6266",
    "data-name": "Caminho 6266",
    d: "M466.763,15.59a.06.06,0,0,1,.06-.051.053.053,0,0,1,.048.051.049.049,0,0,1-.048.045c-.029,0-.06-.021-.06-.045",
    transform: "translate(-445.621 11.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6267",
    "data-name": "Caminho 6267",
    d: "M467.008,15.64l.077.009a.032.032,0,0,0,.043-.029c.012-.015,0-.036-.024-.039l-.084-.012-.084-.015a.051.051,0,0,0-.048.034.037.037,0,0,0,.031.038Z",
    transform: "translate(-445.531 11.114)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6268",
    "data-name": "Caminho 6268",
    d: "M467.192,15.668l-.024-.065-.084.005.043.072Z",
    transform: "translate(-445.392 11.149)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6269",
    "data-name": "Caminho 6269",
    d: "M466.937,15.834a3.241,3.241,0,0,1-.754-.081,3.355,3.355,0,0,1,.754-.077,3.4,3.4,0,0,1,.755.077,3.284,3.284,0,0,1-.755.081",
    transform: "translate(-446.036 11.202)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6270",
    "data-name": "Caminho 6270",
    d: "M466.937,15.859h0a2.872,2.872,0,0,1-.754-.081,2.873,2.873,0,0,1,1.509-.031,1.926,1.926,0,0,1-.755.111m0-.168a3.279,3.279,0,0,0-.754.087,6.812,6.812,0,0,0,.754.05,2.981,2.981,0,0,0,.755-.081,7.461,7.461,0,0,0-.755-.057",
    transform: "translate(-446.036 11.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6271",
    "data-name": "Caminho 6271",
    d: "M467.186,15.421a.043.043,0,0,0-.018-.051.057.057,0,0,0-.048.033c-.007.024,0,.046.024.048s.029-.005.042-.029",
    transform: "translate(-445.368 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6272",
    "data-name": "Caminho 6272",
    d: "M466.845,15.355a.051.051,0,0,0-.024-.048c-.019,0-.036.015-.036.045s.007.043.024.043.029-.019.036-.039",
    transform: "translate(-445.607 10.938)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6273",
    "data-name": "Caminho 6273",
    d: "M466.433,15.355a.034.034,0,0,1,.024-.048c.017,0,.029.015.036.045s-.012.043-.029.043-.031-.019-.031-.039",
    transform: "translate(-445.86 10.938)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6274",
    "data-name": "Caminho 6274",
    d: "M466.094,15.421a.037.037,0,0,1,.019-.051.076.076,0,0,1,.041.033c0,.024,0,.046-.017.048s-.036-.005-.043-.029",
    transform: "translate(-446.103 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6275",
    "data-name": "Caminho 6275",
    d: "M466.666,15.142l-.1.06.072.168.029.012.024-.012.072-.168Z",
    transform: "translate(-445.763 10.82)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6276",
    "data-name": "Caminho 6276",
    d: "M466.491,15.315l.048.069.156-.048.023-.026-.023-.019-.156-.048Z",
    transform: "translate(-445.816 10.892)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6277",
    "data-name": "Caminho 6277",
    d: "M466.845,15.315l-.053.069-.144-.048-.024-.026.024-.019.144-.048Z",
    transform: "translate(-445.721 10.892)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6278",
    "data-name": "Caminho 6278",
    d: "M466.271,15.184l-.084.072.1.141.034.009.012-.021.043-.165Z",
    transform: "translate(-446.033 10.85)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6279",
    "data-name": "Caminho 6279",
    d: "M466.134,15.376l.065.06.144-.079.019-.029-.024-.021-.175-.015Z",
    transform: "translate(-446.07 10.927)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6280",
    "data-name": "Caminho 6280",
    d: "M466.482,15.318l-.036.075-.161-.019-.019-.021.012-.027.144-.072Z",
    transform: "translate(-445.976 10.901)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6281",
    "data-name": "Caminho 6281",
    d: "M466.131,15.376l-.012.077-.173.012-.024-.009.005-.024.12-.108Z",
    transform: "translate(-446.222 10.951)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6282",
    "data-name": "Caminho 6282",
    d: "M466.232,15.335a.056.056,0,0,1,.06-.053.054.054,0,0,1,.053.053.055.055,0,0,1-.053.06.057.057,0,0,1-.06-.06",
    transform: "translate(-446.001 10.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6283",
    "data-name": "Caminho 6283",
    d: "M467.053,15.184l.089.072-.106.141L467,15.4l-.024-.021-.029-.165Z",
    transform: "translate(-445.487 10.85)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6284",
    "data-name": "Caminho 6284",
    d: "M467.2,15.376l-.053.06L467,15.357l-.019-.029.024-.021.161-.015Z",
    transform: "translate(-445.464 10.927)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6285",
    "data-name": "Caminho 6285",
    d: "M466.86,15.318l.012.075.173-.019.024-.021-.012-.027-.149-.072Z",
    transform: "translate(-445.551 10.901)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6286",
    "data-name": "Caminho 6286",
    d: "M467.192,15.376l.012.077.168.012.017-.009v-.024l-.125-.108Z",
    transform: "translate(-445.314 10.951)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6287",
    "data-name": "Caminho 6287",
    d: "M466.588,15.3a.056.056,0,0,1,.06-.053c.029,0,.065.026.065.053a.068.068,0,0,1-.065.06.059.059,0,0,1-.06-.06",
    transform: "translate(-445.746 10.897)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6288",
    "data-name": "Caminho 6288",
    d: "M466.944,15.335c0-.027.036-.053.065-.053a.057.057,0,1,1,0,.113.065.065,0,0,1-.065-.06",
    transform: "translate(-445.492 10.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6289",
    "data-name": "Caminho 6289",
    d: "M465.977,15.474s-.048-.053-.072-.084a.866.866,0,0,0-.084-.039.078.078,0,0,1,.067-.038.056.056,0,0,1,.053.029v-.024a.046.046,0,0,1,.041.036.15.15,0,0,1,.007.087.225.225,0,0,1-.012.033",
    transform: "translate(-446.295 10.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6290",
    "data-name": "Caminho 6290",
    d: "M465.914,15.393a.073.073,0,0,1,.065,0,.078.078,0,0,1,.019.065.06.06,0,0,1-.072-.009c-.012-.015-.024-.041-.012-.06",
    transform: "translate(-446.232 10.995)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6291",
    "data-name": "Caminho 6291",
    d: "M467.331,15.474s.048-.053.077-.084a.508.508,0,0,1,.084-.039.078.078,0,0,0-.072-.038.055.055,0,0,0-.053.029l-.005-.024a.056.056,0,0,0-.043.036.343.343,0,0,0-.012.087.107.107,0,0,0,.024.033",
    transform: "translate(-445.233 10.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6292",
    "data-name": "Caminho 6292",
    d: "M467.355,15.393a.073.073,0,0,0-.065,0c-.012.024-.024.053-.012.065a.045.045,0,0,0,.06-.009.039.039,0,0,0,.017-.06",
    transform: "translate(-445.257 10.995)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_444",
    "data-name": "Ret\\xE2ngulo 444",
    width: 2.646,
    height: 0.698,
    transform: "translate(19.585 27.074)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6293",
    "data-name": "Caminho 6293",
    d: "M468.542,16.526h-2.675l-.029-.725,2.675-.024ZM468.5,15.8l-2.634.024.024.674,2.61-.019Z",
    transform: "translate(-446.282 11.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6294",
    "data-name": "Caminho 6294",
    d: "M466.021,16.6a.064.064,0,0,1,.048-.012h1.987c.024,0,.041,0,.053.012a.168.168,0,0,1-.113-.158.176.176,0,0,1,.125-.159.459.459,0,0,1-.06.009h-1.992a.233.233,0,0,1-.061-.005h.012a.164.164,0,0,1,.108.156.168.168,0,0,1-.108.158",
    transform: "translate(-446.16 11.637)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6295",
    "data-name": "Caminho 6295",
    d: "M468.109,16.621l-.005,0,.005-.019-.005.019-.024-.01-.024,0H466.1l1.915-.043a.208.208,0,0,1-.053-.127.215.215,0,0,1,.089-.156c0,.05-.042.1-.042.156a.142.142,0,0,0,.106.134c.012.009.019.012.012.027s-.012.017-.024.017m-2.04-.021a.887.887,0,0,0,.048-.158.15.15,0,0,0-.079-.127h-.012l-.017-.005h.017l.007-.019-.007.019.012.005.725-.017-.67.017c.036.009.065.067.065.127a.174.174,0,0,1-.089.158",
    transform: "translate(-446.16 11.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6296",
    "data-name": "Caminho 6296",
    d: "M466.1,16.463h1.987c.072,0,.125.041.125.1s-.053.093-.125.093H466.1c-.071,0-.125-.036-.125-.093s.054-.1.125-.1",
    transform: "translate(-446.187 11.764)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6297",
    "data-name": "Caminho 6297",
    d: "M468.091,16.683H466.1a.133.133,0,0,1-.144-.117c0-.065.06-.113.144-.113h1.987c.084,0,.144.048.144.113a.133.133,0,0,1-.144.117m-1.987-.189v.144h1.987c.053,0,.1-.031.1-.072Z",
    transform: "translate(-446.195 11.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6298",
    "data-name": "Caminho 6298",
    d: "M466.1,16.2h1.993c.067,0,.12.039.12.084s-.053.074-.12.074H466.1c-.071,0-.125-.033-.125-.074s.054-.084.125-.084",
    transform: "translate(-446.187 11.575)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6299",
    "data-name": "Caminho 6299",
    d: "M468.1,16.389H466.1c-.084,0-.144-.046-.144-.1s.06-.1.144-.1H468.1c.079,0,.144.041.144.1s-.065.1-.144.1m-1.993-.158,1.993.111c.048,0,.1-.034.1-.053Z",
    transform: "translate(-446.195 11.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6300",
    "data-name": "Caminho 6300",
    d: "M469.251,23.115a1,1,0,0,1-.467-.1.993.993,0,0,0-.456-.1,1.03,1.03,0,0,0-.466.1,1.024,1.024,0,0,1-.466.1.963.963,0,0,1-.466-.108,1.145,1.145,0,0,0-.457-.093.919.919,0,0,0-.454.1,1.077,1.077,0,0,1-.479.1V23.4a1.152,1.152,0,0,0,.479-.1,1,1,0,0,1,.454-.1,1.176,1.176,0,0,1,.457.091.944.944,0,0,0,.466.108,1.1,1.1,0,0,0,.466-.1,1.136,1.136,0,0,1,.922,0,1.007,1.007,0,0,0,.467.1Z",
    transform: "translate(-446.494 16.373)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6301",
    "data-name": "Caminho 6301",
    d: "M469.286,23.437h-.022a.927.927,0,0,1-.474-.111,1.153,1.153,0,0,0-.905,0,1.173,1.173,0,0,1-.963,0,1.134,1.134,0,0,0-.892,0,1,1,0,0,1-.477.111l-.028-.314A1.548,1.548,0,0,0,466.02,23a1.178,1.178,0,0,1,.931,0,1.1,1.1,0,0,0,.91,0,1.21,1.21,0,0,1,.947,0,1,1,0,0,0,.456.1l.022.31Zm-2.8-.494a1,1,0,0,0-.456.1,1.043,1.043,0,0,1-.477.1l.022.266a1.5,1.5,0,0,0,.444-.12,1.15,1.15,0,0,1,.931-.005,1.115,1.115,0,0,0,.91.005,1.167,1.167,0,0,1,.947,0,1.045,1.045,0,0,0,.43.1v-.266a.767.767,0,0,1-.448-.081,1.152,1.152,0,0,0-.905,0,1.2,1.2,0,0,1-.963-.007.994.994,0,0,0-.436-.093",
    transform: "translate(-446.505 16.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6302",
    "data-name": "Caminho 6302",
    d: "M469.251,23.281a1.045,1.045,0,0,1-.467-.1,1.04,1.04,0,0,0-.456-.1,1.053,1.053,0,0,0-.466.1,1.1,1.1,0,0,1-.466.1.926.926,0,0,1-.466-.108,1.209,1.209,0,0,0-.457-.089,1,1,0,0,0-.454.1,1.153,1.153,0,0,1-.479.1v.286a1.153,1.153,0,0,0,.479-.1.937.937,0,0,1,.454-.1,1.016,1.016,0,0,1,.457.1,1.054,1.054,0,0,0,.466.1,1.151,1.151,0,0,0,.466-.1,1.084,1.084,0,0,1,.922,0,1.053,1.053,0,0,0,.467.1Z",
    transform: "translate(-446.494 16.495)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6303",
    "data-name": "Caminho 6303",
    d: "M469.286,23.6h-.022a.962.962,0,0,1-.474-.111,1.1,1.1,0,0,0-.905.012,1.187,1.187,0,0,1-.963-.012,1.12,1.12,0,0,0-.892,0,1.045,1.045,0,0,1-.477.111l-.028-.312a1.467,1.467,0,0,0,.494-.12,1.143,1.143,0,0,1,.931-.005,1.122,1.122,0,0,0,.91.005,1.16,1.16,0,0,1,.947,0,1,1,0,0,0,.456.1l.022.309Zm-2.8-.489a1.1,1.1,0,0,0-.456.093,1,1,0,0,1-.477.111l.022.261a1.46,1.46,0,0,0,.444-.127,1.172,1.172,0,0,1,.931,0,1.129,1.129,0,0,0,.91.007,1.181,1.181,0,0,1,.947-.007.906.906,0,0,0,.43.1v-.266a.7.7,0,0,1-.448-.084,1.145,1.145,0,0,0-.905,0,1.179,1.179,0,0,1-.963,0,.993.993,0,0,0-.436-.093",
    transform: "translate(-446.505 16.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6304",
    "data-name": "Caminho 6304",
    d: "M469.251,23.451a1.069,1.069,0,0,1-.467-.1,1.038,1.038,0,0,0-.456-.1,1.051,1.051,0,0,0-.466.1,1.123,1.123,0,0,1-.466.1,1.054,1.054,0,0,1-.466-.1.994.994,0,0,0-.457-.1.918.918,0,0,0-.454.1,1.153,1.153,0,0,1-.479.1v.288a1.126,1.126,0,0,0,.479-.1,1,1,0,0,1,.454-.1,1.145,1.145,0,0,1,.457.093.983.983,0,0,0,.466.108,1,1,0,0,0,.466-.1,1.053,1.053,0,0,1,.466-.1,1.015,1.015,0,0,1,.456.1.966.966,0,0,0,.467.1Z",
    transform: "translate(-446.494 16.611)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6305",
    "data-name": "Caminho 6305",
    d: "M469.286,23.77h-.022a1.068,1.068,0,0,1-.474-.1,1.11,1.11,0,0,0-.905,0,1.18,1.18,0,0,1-.963-.009,1.172,1.172,0,0,0-.892,0,1.03,1.03,0,0,1-.477.11l-.028-.31a1.383,1.383,0,0,0,.494-.127,1.179,1.179,0,0,1,.931,0,1.129,1.129,0,0,0,.91.007,1.188,1.188,0,0,1,.947-.007.962.962,0,0,0,.456.106l.022.307Zm-2.8-.49a1.1,1.1,0,0,0-.456.093,1.045,1.045,0,0,1-.477.111l.022.262a1.559,1.559,0,0,0,.444-.122,1.178,1.178,0,0,1,.931-.007,1.089,1.089,0,0,0,.91.009,1.174,1.174,0,0,1,.947,0,.969.969,0,0,0,.43.1V23.46a.744.744,0,0,1-.448-.087,1.1,1.1,0,0,0-.905.012,1.187,1.187,0,0,1-.963-.012.994.994,0,0,0-.436-.093",
    transform: "translate(-446.505 16.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6306",
    "data-name": "Caminho 6306",
    d: "M469.251,23.9a.863.863,0,0,1-.454-.1,1.142,1.142,0,0,0-.468-.1,1.077,1.077,0,0,0-.466.1,1.047,1.047,0,0,1-.466.1.891.891,0,0,1-.466-.111,1.207,1.207,0,0,0-.457-.093,1.05,1.05,0,0,0-.454.1,1.054,1.054,0,0,1-.479.108v-.281a1.1,1.1,0,0,0,.479-.111,1.025,1.025,0,0,1,.454-.1,1.145,1.145,0,0,1,.457.094.983.983,0,0,0,.466.108,1.024,1.024,0,0,0,.466-.1,1.053,1.053,0,0,1,.466-.1,1.115,1.115,0,0,1,.468.1.911.911,0,0,0,.454.1Z",
    transform: "translate(-446.494 16.732)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6307",
    "data-name": "Caminho 6307",
    d: "M469.286,23.938h-.022a1,1,0,0,1-.474-.1,1.131,1.131,0,0,0-.905,0,1.123,1.123,0,0,1-.963-.012,1.18,1.18,0,0,0-.892.005.952.952,0,0,1-.477.111l-.028-.305a1.587,1.587,0,0,0,.494-.129,1.186,1.186,0,0,1,.931-.007,1.1,1.1,0,0,0,.91.01,1.121,1.121,0,0,1,.947,0,1.029,1.029,0,0,0,.456.094l.022.312Zm-2.8-.494a1.064,1.064,0,0,0-.456.1,1,1,0,0,1-.477.11l.022.264a1.371,1.371,0,0,0,.444-.129,1.224,1.224,0,0,1,.931,0,1.07,1.07,0,0,0,.91.007,1.217,1.217,0,0,1,.947,0,.982.982,0,0,0,.43.1v-.266a.794.794,0,0,1-.448-.079,1.131,1.131,0,0,0-.905,0,1.179,1.179,0,0,1-.963-.009.947.947,0,0,0-.436-.1",
    transform: "translate(-446.505 16.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6308",
    "data-name": "Caminho 6308",
    d: "M469.251,24.071a.9.9,0,0,1-.454-.1,1.2,1.2,0,0,0-.468-.1,1.131,1.131,0,0,0-.466.1,1.024,1.024,0,0,1-.466.1.891.891,0,0,1-.466-.111,1.279,1.279,0,0,0-.457-.089,1.167,1.167,0,0,0-.454.089.992.992,0,0,1-.479.111V23.79a1.076,1.076,0,0,0,.479-.113,1.029,1.029,0,0,1,.454-.091,1.176,1.176,0,0,1,.457.087.908.908,0,0,0,.466.11,1.047,1.047,0,0,0,.466-.1,1.08,1.08,0,0,1,.466-.093,1.142,1.142,0,0,1,.468.093.876.876,0,0,0,.454.1Z",
    transform: "translate(-446.494 16.853)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6309",
    "data-name": "Caminho 6309",
    d: "M469.286,24.105h-.022a1,1,0,0,1-.474-.108,1.153,1.153,0,0,0-.905,0,1.166,1.166,0,0,1-.963,0,1.2,1.2,0,0,0-.892,0,.989.989,0,0,1-.477.111l-.028-.305a1.49,1.49,0,0,0,.494-.135,1.232,1.232,0,0,1,.931,0,1.07,1.07,0,0,0,.91.007,1.225,1.225,0,0,1,.947,0,.983.983,0,0,0,.456.1l.022.309Zm-2.8-.489a1.1,1.1,0,0,0-.456.089.964.964,0,0,1-.477.111l.022.264a1.46,1.46,0,0,0,.444-.127,1.158,1.158,0,0,1,.931,0,1.1,1.1,0,0,0,.91,0,1.167,1.167,0,0,1,.947,0,.981.981,0,0,0,.43.1v-.266a.741.741,0,0,1-.448-.081,1.153,1.153,0,0,0-.905,0,1.122,1.122,0,0,1-.963-.012,1,1,0,0,0-.436-.084",
    transform: "translate(-446.505 16.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6310",
    "data-name": "Caminho 6310",
    d: "M466.151,22.343a.482.482,0,0,1,.012.072.325.325,0,0,1-.336.317h2.736a.322.322,0,0,1-.336-.317.427.427,0,0,1,.012-.072.127.127,0,0,1-.053.007H466.2a.116.116,0,0,1-.048-.007",
    transform: "translate(-446.29 15.965)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6311",
    "data-name": "Caminho 6311",
    d: "M468.563,22.763h-2.734a.378.378,0,0,0,.31-.341h.06a.368.368,0,0,1-.354.341l2.533-.045a.352.352,0,0,1-.168-.3l-1.389-.029,1.365-.058c.065.255.2.381.377.381.012,0,.031.012.031.024s-.019.024-.031.024",
    transform: "translate(-446.29 15.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6312",
    "data-name": "Caminho 6312",
    d: "M466.1,22.237h1.987a.113.113,0,0,1,.125.1c0,.05-.053.089-.125.089H466.1c-.071,0-.125-.039-.125-.089a.113.113,0,0,1,.125-.1",
    transform: "translate(-446.187 15.89)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6313",
    "data-name": "Caminho 6313",
    d: "M468.091,22.456H466.1c-.084,0-.144-.048-.144-.113s.06-.115.144-.115h1.987c.084,0,.144.048.144.115s-.06.113-.144.113m-1.987-.189v.144h1.987c.053,0,.1-.033.1-.069Z",
    transform: "translate(-446.195 15.883)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_445",
    "data-name": "Ret\\xE2ngulo 445",
    width: 2.73,
    height: 0.694,
    transform: "translate(19.544 38.699)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6314",
    "data-name": "Caminho 6314",
    d: "M468.586,23.3h-2.747l-.019-.718,2.748-.024Zm-.048-.718-2.7.024.024.67,2.675-.024Z",
    transform: "translate(-446.295 16.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6315",
    "data-name": "Caminho 6315",
    d: "M465.888,20.8c-.274.159-.454.314-.43.394s.094.127.226.211c.192.134.305.37.211.483a.672.672,0,0,0,.268-.535.694.694,0,0,0-.274-.554",
    transform: "translate(-446.555 14.866)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6316",
    "data-name": "Caminho 6316",
    d: "M465.922,21.92l-.024-.036a.142.142,0,0,0,.019-.106.584.584,0,0,0-.235-.345c-.144-.087-.214-.144-.233-.219-.048-.118.288-.338.425-.423a.67.67,0,0,1,.324.576.715.715,0,0,1-.276.554m-.048-1.089c-.264.173-.395.314-.377.37s.077.111.2.187a.584.584,0,0,1,.269.382v.051a.641.641,0,0,0,.187-.456.663.663,0,0,0-.276-.535",
    transform: "translate(-446.564 14.856)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_446",
    "data-name": "Ret\\xE2ngulo 446",
    width: 1.939,
    height: 9.49,
    transform: "translate(19.933 28.53)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6317",
    "data-name": "Caminho 6317",
    d: "M467.11,26.113l-.048-9.469h.048Zm-.222,0-.036-9.469h.036Z",
    transform: "translate(-445.557 11.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6318",
    "data-name": "Caminho 6318",
    d: "M468.031,26.156h-1.963l-.024-9.507,1.963-.024Zm-.048-9.507-1.915.021.024,9.469,1.891-.027Z",
    transform: "translate(-446.135 11.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6319",
    "data-name": "Caminho 6319",
    d: "M470.551,19.306a6.2,6.2,0,0,0-1.963-.333,5.522,5.522,0,0,0-.928.087c-1.16.194-2.042.65-1.97,1.032v.033s-.43-.984-.437-1.017c-.082-.417.906-.938,2.187-1.147a5.82,5.82,0,0,1,1.142-.089,6.044,6.044,0,0,1,1.958.262Z",
    transform: "translate(-446.704 12.77)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6320",
    "data-name": "Caminho 6320",
    d: "M465.69,20.152l-.005-.007c-.065-.161-.437-.984-.449-1.017a.361.361,0,0,1,.084-.276,3.685,3.685,0,0,1,2.125-.9,6.758,6.758,0,0,1,3.131.183l.012,1.188a7.441,7.441,0,0,0-1.987-.312,5.5,5.5,0,0,0-.922.093,3.339,3.339,0,0,0-1.9.784.283.283,0,0,0-.053.223l-.007.012.007.009-.007.005a.012.012,0,0,1-.012.012Zm2.885-2.248a6.925,6.925,0,0,0-1.125.093,3.7,3.7,0,0,0-2.1.883.359.359,0,0,0-.059.237c.005.033.221.523.388.9a.311.311,0,0,1,.067-.158,3.314,3.314,0,0,1,1.927-.811,5.674,5.674,0,0,1,.928-.082,6.3,6.3,0,0,1,1.976.333l-.042-1.149a6.739,6.739,0,0,0-1.939-.245Z",
    transform: "translate(-446.715 12.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6321",
    "data-name": "Caminho 6321",
    d: "M466.454,19.8c-.545-.036-.91-.182-.946-.4-.035-.182.144-.382.468-.559a4.414,4.414,0,0,0,.478.036Z",
    transform: "translate(-446.521 13.462)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6322",
    "data-name": "Caminho 6322",
    d: "M466.487,19.836l-.029,0c-.569-.038-.928-.194-.963-.425-.036-.182.132-.389.479-.579.228.017.353.036.49.036l.024.948Zm-.418-.952c-.394.171-.562.357-.533.523.043.2.377.341.9.384v-.907a1.166,1.166,0,0,1-.371,0",
    transform: "translate(-446.531 13.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6323",
    "data-name": "Caminho 6323",
    d: "M467.195,18.98a1.641,1.641,0,0,1,.711.237l.012.021c.055.123-.238.386-.73.674Z",
    transform: "translate(-445.318 13.562)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6324",
    "data-name": "Caminho 6324",
    d: "M467.175,19.952V18.98a1.416,1.416,0,0,1,.754.218c.1.216-.407.552-.718.734ZM467.2,19l.024.868c.563-.341.718-.544.682-.626A1.5,1.5,0,0,0,467.2,19",
    transform: "translate(-445.327 13.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6325",
    "data-name": "Caminho 6325",
    d: "M465.354,21.439c-.05-.156.478-.466,1.213-.73.341-.125.618-.25.965-.406,1.027-.449,1.781-.976,1.7-1.164l-.014-.021a6.889,6.889,0,0,1,.139.986c.094.175-.6.682-1.55,1.138-.3.149-.939.379-1.24.487-.55.185-1.082.545-1.036.674Z",
    transform: "translate(-446.63 13.661)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6326",
    "data-name": "Caminho 6326",
    d: "M465.526,22.409l.007-.012-.007,0-.185-.97c-.065-.185.579-.511,1.232-.756.324-.117.6-.233.922-.384,1.094-.478,1.716-.941,1.729-1.125v-.015h-.005l.005,0v0c.006,0,.014.012.006.015a4.813,4.813,0,0,1,.162.924c-.072.315-.73.766-1.562,1.168-.3.144-.945.377-1.238.482-.533.189-1.031.521-1.024.634,0,.021-.024.021-.024.027h-.012V22.4l-.007.007m3.705-3.239c.036.245-.838.766-1.675,1.137-.372.165-.641.288-.963.4-.833.3-1.24.593-1.2.7l.168.874a2.5,2.5,0,0,1,1.011-.59c.305-.108.94-.346,1.245-.487a3.789,3.789,0,0,0,1.531-1.06c0-.067-.06-.766-.113-.979",
    transform: "translate(-446.641 13.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6327",
    "data-name": "Caminho 6327",
    d: "M466.126,18.644c.24-.084.4-.189.317-.37-.048-.123-.161-.144-.347-.079l-.329.117.293.725a.8.8,0,0,1,.1-.048.727.727,0,0,0,.1-.031Zm-.125-.35.072-.021a.14.14,0,0,1,.18.086.142.142,0,0,1-.06.189.393.393,0,0,1-.09.039Z",
    transform: "translate(-446.332 12.976)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6328",
    "data-name": "Caminho 6328",
    d: "M466.508,18.064a.552.552,0,0,1-.209.039l.173.751.521-.1a.077.077,0,0,1-.019-.05.305.305,0,0,0-.013-.045,2.763,2.763,0,0,1-.31.081Z",
    transform: "translate(-445.953 12.908)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6329",
    "data-name": "Caminho 6329",
    d: "M467.255,18.773c.1-.273.228-.533.341-.794l-.06,0h-.072c-.061.2-.137.384-.216.574a4.84,4.84,0,0,1-.281-.535c-.048.005-.095.012-.138.015s-.084,0-.12,0c.151.24.293.489.432.741a.476.476,0,0,1,.06-.01.258.258,0,0,1,.053,0",
    transform: "translate(-445.659 12.847)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6330",
    "data-name": "Caminho 6330",
    d: "M467.914,18.181a.506.506,0,0,1,.052-.1.57.57,0,0,0-.209-.079c-.22-.014-.341.079-.354.211-.029.262.4.242.372.422-.007.077-.091.1-.175.1a.18.18,0,0,1-.178-.141l-.031,0a.371.371,0,0,1-.06.134.537.537,0,0,0,.228.072c.216.021.377-.063.4-.206.024-.255-.414-.273-.389-.42,0-.072.053-.113.167-.1a.146.146,0,0,1,.143.111Z",
    transform: "translate(-445.215 12.859)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6331",
    "data-name": "Caminho 6331",
    d: "M477.516,15.564a.382.382,0,0,1-.156.1c-.06.012-.137-.057-.137-.057a.3.3,0,0,1-.132.079c-.072.01-.168-.087-.168-.087a.4.4,0,0,1-.13.125.22.22,0,0,1-.139-.027.151.151,0,0,1-.072.07c-.017.009-.053-.007-.053-.007l-.078-.045-.083-.089L476.3,15.6a1.071,1.071,0,0,1-.029-.122.419.419,0,0,1-.012-.063c-.019-.081.1-.171.27-.209a.516.516,0,0,1,.245,0,.628.628,0,0,1,.384-.1.641.641,0,0,1,.358.087.659.659,0,0,1,.365-.087.676.676,0,0,1,.382.1.513.513,0,0,1,.245,0c.168.038.288.129.264.209,0,0,0,.045,0,.063s-.036.122-.036.122l-.072.031-.083.089-.067.045a.1.1,0,0,1-.058.007.241.241,0,0,1-.084-.07.186.186,0,0,1-.132.027.429.429,0,0,1-.125-.125s-.1.1-.163.087a.289.289,0,0,1-.131-.079.241.241,0,0,1-.156.057c-.055-.009-.144-.1-.144-.1",
    transform: "translate(-438.838 10.789)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6332",
    "data-name": "Caminho 6332",
    d: "M478.466,15.788l-.013-.005-.083-.081-.1.045a.4.4,0,0,1-.173-.125.181.181,0,0,1-.139.086.333.333,0,0,1-.154-.084.151.151,0,0,1-.127.063.489.489,0,0,1-.173-.111.226.226,0,0,1-.137.111c-.065-.027-.138-.048-.156-.06a.163.163,0,0,1-.113.075h-.007a.275.275,0,0,1-.173-.079c.007.019-.053.1-.12.12l-.036-.012.031-.021a.184.184,0,0,0,.113-.111c.031,0,.108.075.168.075a.276.276,0,0,0,.132-.075h0c.024,0,.079.058.137.058a.39.39,0,0,0,.156-.1.676.676,0,0,0,.168.1,1.4,1.4,0,0,0,.132-.055c.024,0,.077.06.144.072a1.422,1.422,0,0,0,.149-.075c.029,0,.1.094.144.115l.017-.009.125-.012.079.084.286-.3c.023-.125-.084-.216-.246-.252a.468.468,0,0,0-.137-.017.477.477,0,0,0-.065-.015.5.5,0,0,1,.209,0c.173.043.305.135.286.225l-.06.2Zm-2.107-.161-.065-.005-.036-.144c-.031-.153.089-.245.269-.288a.62.62,0,0,1,.144-.017,1.274,1.274,0,0,1,.855,0,.859.859,0,0,1,.724,0,1.037,1.037,0,0,0-.724.027.873.873,0,0,0-.737.015.725.725,0,0,0-.257.005c-.173.036-.262.127-.257.183Z",
    transform: "translate(-438.841 10.786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6333",
    "data-name": "Caminho 6333",
    d: "M476.893,15.177c0-.137.077-.24.167-.24s.156.1.156.24-.066.228-.156.228-.167-.1-.167-.228",
    transform: "translate(-438.383 10.674)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6334",
    "data-name": "Caminho 6334",
    d: "M477.068,15.416c-.1,0-.185-.111-.185-.245a.182.182,0,1,1,.358,0c0,.134-.078.245-.174.245m0-.47c-.083,0-.156.1-.156.225a.152.152,0,1,0,.3,0c0-.125-.06-.225-.145-.225",
    transform: "translate(-438.391 10.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6335",
    "data-name": "Caminho 6335",
    d: "M476.949,15.167c0-.125.029-.216.072-.216s.084.091.084.216-.042.213-.084.213-.072-.1-.072-.213",
    transform: "translate(-438.343 10.684)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6336",
    "data-name": "Caminho 6336",
    d: "M476.523,15.737a.45.45,0,0,0-.066-.132,3.4,3.4,0,0,1,.916-.11,3.279,3.279,0,0,1,.909.11s-.022.045-.059.108l-.042.1a2.774,2.774,0,0,0-.808-.1,3.079,3.079,0,0,0-.82.1l-.029-.075",
    transform: "translate(-438.695 11.072)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6337",
    "data-name": "Caminho 6337",
    d: "M476.543,15.847l-.005-.027h.017l-.041-.072a.443.443,0,0,0-.06-.125,2.9,2.9,0,0,1,.921-.141,3.694,3.694,0,0,1,.922.12l-.06.134h-.023l.065-.129a4.766,4.766,0,0,0-.9-.089,3.85,3.85,0,0,0-.9.1.2.2,0,0,1,.072.113l.006.072a2.836,2.836,0,0,1,.825-.1,3.656,3.656,0,0,1,.581.041c-.18,0-.365-.012-.581-.012a2.654,2.654,0,0,0-.813.106Z",
    transform: "translate(-438.697 11.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6338",
    "data-name": "Caminho 6338",
    d: "M477.345,15.936a3.524,3.524,0,0,0,.724-.072c.084-.021.127-.06.115-.1,0-.015-.019-.033-.043-.043a2.9,2.9,0,0,0-.8-.1,2.99,2.99,0,0,0-.8.1.088.088,0,0,0-.048.043c0,.041.042.081.12.1a3.721,3.721,0,0,0,.73.072",
    transform: "translate(-438.668 11.163)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6339",
    "data-name": "Caminho 6339",
    d: "M477.351,15.962a3.318,3.318,0,0,1-.73-.079c-.1-.024-.137-.062-.132-.117a2.772,2.772,0,0,1,1.67-.051c.06.106.012.144-.078.168a3.323,3.323,0,0,1-.73.079m0-.312a2.977,2.977,0,0,0-.795.089c-.048.063,0,.1.072.117a5.674,5.674,0,0,0,1.447,0c.072-.021.108-.053.1-.082a2.245,2.245,0,0,0-.827-.123",
    transform: "translate(-438.673 11.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6340",
    "data-name": "Caminho 6340",
    d: "M477.4,15.155a.054.054,0,0,1,.108,0,.054.054,0,0,1-.108,0",
    transform: "translate(-438.021 10.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6341",
    "data-name": "Caminho 6341",
    d: "M477.9,15.559h-.012a.025.025,0,0,1,0-.021.557.557,0,0,0,.023-.127.328.328,0,0,0-.478-.283.169.169,0,0,1,.156-.075.356.356,0,0,1,.352.358.265.265,0,0,1-.029.135.011.011,0,0,1-.012.012",
    transform: "translate(-437.994 10.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6342",
    "data-name": "Caminho 6342",
    d: "M477.564,15.323l0-.069c0-.177-.281-.3-.483-.185.155-.223.52-.015.52.185Z",
    transform: "translate(-438.245 10.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6343",
    "data-name": "Caminho 6343",
    d: "M478.307,15.562l-.078-.057a.244.244,0,0,1-.151.026c-.084-.014-.108-.117-.108-.117a.289.289,0,0,1-.167.07.173.173,0,0,1-.132-.07.318.318,0,0,1-.156.055.229.229,0,0,1-.144-.1.348.348,0,0,1-.154.1.185.185,0,0,1-.132-.07.18.18,0,0,1-.126.091.216.216,0,0,1-.179-.072.281.281,0,0,1-.115.11.232.232,0,0,1-.154-.034.151.151,0,0,1-.019.05.066.066,0,0,1-.036.027l.024.051a3.445,3.445,0,0,1,.892-.1,3.547,3.547,0,0,1,.91.106Z",
    transform: "translate(-438.695 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6344",
    "data-name": "Caminho 6344",
    d: "M478.266,15.65a3.361,3.361,0,0,0-.9-.111,3.512,3.512,0,0,0-.892.108l.029-.129c0-.009,0,0,0,0l.012-.027.115.039h.024l-.007-.007c.072-.024.108-.1.12-.1s.077.069.156.069c.113-.021.138-.081.138-.081.017-.012.077.053.137.053a.261.261,0,0,0,.149-.1c.023,0,.091.087.163.1a.324.324,0,0,0,.148-.057c.019,0,.072.063.138.072a.341.341,0,0,0,.156-.069c.024,0,.048.1.125.11l.156-.024-.012.015.019.036a.679.679,0,0,0-.132.005.17.17,0,0,0-.3-.041.216.216,0,0,1-.149-.077.193.193,0,0,1-.144.057.268.268,0,0,1-.156-.1.2.2,0,0,1-.145.1.2.2,0,0,1-.137-.065c0,.021-.036.072-.12.087a.316.316,0,0,1-.185-.079c.005.019-.024.063-.072.091.221-.007.431-.019.67-.019a3.64,3.64,0,0,1,.9.1v0l.012,0v.012l-.012,0Z",
    transform: "translate(-438.684 10.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6345",
    "data-name": "Caminho 6345",
    d: "M476.513,15.155a.051.051,0,0,1,.053-.048.051.051,0,1,1,0,.1.052.052,0,0,1-.053-.053",
    transform: "translate(-438.654 10.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6346",
    "data-name": "Caminho 6346",
    d: "M476.282,15.558a.014.014,0,0,1-.007-.012.275.275,0,0,1-.034-.135.353.353,0,0,1,.519-.31c-.269-.007-.485.077-.485.31a.506.506,0,0,0,.019.127.017.017,0,0,1,0,.017Z",
    transform: "translate(-438.849 10.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6347",
    "data-name": "Caminho 6347",
    d: "M476.626,15.353l-.036-.108c0-.2.313-.338.534-.213-.246-.015-.5.036-.5.213Z",
    transform: "translate(-438.599 10.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6348",
    "data-name": "Caminho 6348",
    d: "M477.475,15.3l.036.014a.119.119,0,0,0,0,.043.125.125,0,0,0,.125.125.144.144,0,0,0,.132-.082s.012-.048.024-.048V15.4a.133.133,0,0,0,.13.106.129.129,0,0,0,.132-.125v-.019l.048-.039.012.055a.083.083,0,0,0-.012.057.131.131,0,0,0,.132.12.124.124,0,0,0,.1-.06l.031-.036-.007.043a.082.082,0,0,0,.06.089.159.159,0,0,0,.115-.048c.053-.048.094-.089.094-.089v.053a.356.356,0,0,1-.108.127.31.31,0,0,1-.118.036.12.12,0,0,1-.084-.072.163.163,0,0,1-.091.022.193.193,0,0,1-.173-.106.179.179,0,0,1-.132.065.192.192,0,0,1-.149-.067.22.22,0,0,1-.137.05.194.194,0,0,1-.156-.084.188.188,0,0,1-.156.084.2.2,0,0,1-.13-.05.208.208,0,0,1-.156.067.168.168,0,0,1-.132-.065.18.18,0,0,1-.173.106.194.194,0,0,1-.1-.022c-.019.029-.036.063-.079.072a.265.265,0,0,1-.113-.036.507.507,0,0,1-.125-.127l0-.053a1.22,1.22,0,0,0,.108.089.146.146,0,0,0,.108.048.082.082,0,0,0,.06-.089v-.043l.017.036a.137.137,0,0,0,.108.06.132.132,0,0,0,.132-.12.086.086,0,0,0-.012-.057l.024-.055.041.039v.019a.119.119,0,0,0,.12.125.141.141,0,0,0,.137-.106v-.048c.012,0,.025.048.025.048a.123.123,0,0,0,.119.082.134.134,0,0,0,.144-.125c0-.017-.007-.029-.007-.043Z",
    transform: "translate(-438.797 10.933)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6349",
    "data-name": "Caminho 6349",
    d: "M478.412,15.676l-.053-.029.042.017v-.017l.012.017.1-.045a.547.547,0,0,0,.115-.125c-.139.106-.192.106-.2.106h-.007l-.065-.1a.146.146,0,0,1-.257-.057c.06.063.1.089.144.089l.024-.034.12-.034.041.127.1-.058c.06-.05.1-.089.1-.089a.226.226,0,0,1-.1.2Zm-1.855,0-.118-.033c-.062-.031-.12-.129-.132-.135l.012-.029.017.015a.418.418,0,0,0,.12.125l.061-.027-.1-.041a.525.525,0,0,0-.058-.048l.178.084.043-.091.036.01a.1.1,0,0,1-.036.081l.072-.01c.149.024.221-.014.238-.07a.218.218,0,0,0,.293-.012c.126.065.228.057.288-.031a.225.225,0,0,0,.293.031c.108.074.221.082.281.009a.249.249,0,0,0,.185.1h.019c-.121.019-.18-.024-.2-.082-.024.094-.209.082-.288,0-.036.081-.214.062-.287-.036-.031.1-.2.117-.288.036-.029.086-.214.093-.287.005-.007.067-.079.108-.161.108a.829.829,0,0,0-.175.048m.168-.117-.108-.051.108.021a.109.109,0,0,0,.113-.1l.031-.12c.089.252.269.2.287.087l.019.009c-.019.137-.281.117-.281-.027-.024.127-.084.183-.168.183",
    transform: "translate(-438.802 10.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6350",
    "data-name": "Caminho 6350",
    d: "M477.389,15.52a3.262,3.262,0,0,0-.911.111.038.038,0,0,1-.041-.022c-.007-.012,0-.029.017-.038a3.857,3.857,0,0,1,1.869,0,.057.057,0,0,1,.024.038.043.043,0,0,1-.048.022,3.226,3.226,0,0,0-.91-.111",
    transform: "translate(-438.711 11.045)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6351",
    "data-name": "Caminho 6351",
    d: "M478.292,15.656h-.012a3.884,3.884,0,0,0-1.819,0,.479.479,0,0,1,.144-.087,4.727,4.727,0,0,1,1.687.057v.031Zm.012-.051a3.12,3.12,0,0,0-.935-.125,4.426,4.426,0,0,0-.687.057,2.306,2.306,0,0,1,.688-.087,3.36,3.36,0,0,1,.935.115Z",
    transform: "translate(-438.692 11.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6352",
    "data-name": "Caminho 6352",
    d: "M476.789,15.59a.053.053,0,0,1,.053-.051.059.059,0,0,1,.055.051c0,.024-.031.045-.055.045a.05.05,0,0,1-.053-.045",
    transform: "translate(-438.457 11.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6353",
    "data-name": "Caminho 6353",
    d: "M477.056,15.609h-.113a.039.039,0,0,1-.043-.036c0-.021.019-.033.043-.033h.233c.023,0,.036.012.036.033a.033.033,0,0,1-.036.036Z",
    transform: "translate(-438.378 11.104)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6354",
    "data-name": "Caminho 6354",
    d: "M476.717,15.64l-.083.009c-.024.007-.042-.009-.054-.029a.048.048,0,0,1,.036-.039l.083-.012.083-.015a.037.037,0,1,1,.013.072Z",
    transform: "translate(-438.607 11.114)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6355",
    "data-name": "Caminho 6355",
    d: "M476.46,15.663l.043-.06.07.012-.048.072Z",
    transform: "translate(-438.692 11.149)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6356",
    "data-name": "Caminho 6356",
    d: "M477.131,15.59a.055.055,0,0,1,.06-.051.049.049,0,0,1,.048.051.045.045,0,0,1-.048.045c-.036,0-.06-.021-.06-.045",
    transform: "translate(-438.213 11.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6357",
    "data-name": "Caminho 6357",
    d: "M477.376,15.64l.084.009a.03.03,0,0,0,.042-.029.031.031,0,0,0-.024-.039l-.089-.012-.084-.015c-.024,0-.036.015-.047.034a.045.045,0,0,0,.03.038Z",
    transform: "translate(-438.124 11.114)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6358",
    "data-name": "Caminho 6358",
    d: "M477.568,15.668l-.036-.065-.084.005.048.072Z",
    transform: "translate(-437.987 11.149)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6359",
    "data-name": "Caminho 6359",
    d: "M477.306,15.834a3.245,3.245,0,0,1-.754-.081,3.727,3.727,0,0,1,1.509,0,3.248,3.248,0,0,1-.754.081",
    transform: "translate(-438.628 11.202)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6360",
    "data-name": "Caminho 6360",
    d: "M477.308,15.859h0a2.932,2.932,0,0,1-.76-.081,2.9,2.9,0,0,1,1.514-.031,1.925,1.925,0,0,1-.754.111m0-.168a3.323,3.323,0,0,0-.754.087,6.7,6.7,0,0,0,.754.05,2.9,2.9,0,0,0,.747-.081,7.293,7.293,0,0,0-.747-.057",
    transform: "translate(-438.629 11.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6361",
    "data-name": "Caminho 6361",
    d: "M477.547,15.421a.041.041,0,0,0-.012-.051.052.052,0,0,0-.048.033c0,.024,0,.046.019.048a.03.03,0,0,0,.042-.029",
    transform: "translate(-437.959 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6362",
    "data-name": "Caminho 6362",
    d: "M477.212,15.355c0-.024-.007-.045-.024-.048a.04.04,0,0,0-.036.045c0,.024.007.043.024.043s.036-.019.036-.039",
    transform: "translate(-438.198 10.938)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6363",
    "data-name": "Caminho 6363",
    d: "M476.8,15.355a.039.039,0,0,1,.017-.048c.019,0,.036.015.043.045s-.013.043-.031.043-.029-.019-.029-.039",
    transform: "translate(-438.451 10.938)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6364",
    "data-name": "Caminho 6364",
    d: "M476.463,15.421a.036.036,0,0,1,.017-.051.059.059,0,0,1,.042.033c0,.024,0,.046-.016.048s-.036-.005-.043-.029",
    transform: "translate(-438.694 10.983)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6365",
    "data-name": "Caminho 6365",
    d: "M477.033,15.142l-.1.06.077.168.024.012.024-.012.078-.168Z",
    transform: "translate(-438.355 10.82)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6366",
    "data-name": "Caminho 6366",
    d: "M476.858,15.315l.043.069.166-.048.019-.026-.019-.019-.166-.048Z",
    transform: "translate(-438.408 10.892)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6367",
    "data-name": "Caminho 6367",
    d: "M477.219,15.315l-.053.069L477,15.335l-.012-.026.012-.019.163-.048Z",
    transform: "translate(-438.313 10.892)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6368",
    "data-name": "Caminho 6368",
    d: "M476.632,15.184l-.077.072.106.141.031.009.017-.021.036-.165Z",
    transform: "translate(-438.624 10.85)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6369",
    "data-name": "Caminho 6369",
    d: "M476.5,15.376l.06.06.156-.079v-.029l-.012-.021-.175-.015Z",
    transform: "translate(-438.662 10.927)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6370",
    "data-name": "Caminho 6370",
    d: "M476.851,15.318l-.031.075-.167-.019-.019-.021.012-.027.139-.072Z",
    transform: "translate(-438.567 10.901)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6371",
    "data-name": "Caminho 6371",
    d: "M476.5,15.376l-.012.077-.174.012-.023-.009,0-.024.127-.108Z",
    transform: "translate(-438.814 10.951)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6372",
    "data-name": "Caminho 6372",
    d: "M476.6,15.335a.063.063,0,0,1,.065-.053.055.055,0,0,1,.055.053.055.055,0,0,1-.055.06.062.062,0,0,1-.065-.06",
    transform: "translate(-438.594 10.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6373",
    "data-name": "Caminho 6373",
    d: "M477.429,15.184l.077.072-.1.141-.024.009-.024-.021-.041-.165Z",
    transform: "translate(-438.08 10.85)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6374",
    "data-name": "Caminho 6374",
    d: "M477.563,15.376l-.053.06-.156-.079v-.029l.012-.021.174-.015Z",
    transform: "translate(-438.053 10.927)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6375",
    "data-name": "Caminho 6375",
    d: "M477.222,15.318l.036.075.161-.019.019-.021-.007-.027-.149-.072Z",
    transform: "translate(-438.148 10.901)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6376",
    "data-name": "Caminho 6376",
    d: "M477.557,15.376l.019.077.161.012.029-.009-.012-.024-.12-.108Z",
    transform: "translate(-437.909 10.951)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6377",
    "data-name": "Caminho 6377",
    d: "M476.956,15.3a.059.059,0,0,1,.06-.053.061.061,0,0,1,.06.053.059.059,0,0,1-.06.06.062.062,0,0,1-.06-.06",
    transform: "translate(-438.338 10.897)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6378",
    "data-name": "Caminho 6378",
    d: "M477.316,15.335a.058.058,0,0,1,.065-.053.057.057,0,0,1,0,.113.058.058,0,0,1-.065-.06",
    transform: "translate(-438.081 10.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6379",
    "data-name": "Caminho 6379",
    d: "M476.928,14.962a.108.108,0,0,1,.216,0,.108.108,0,0,1-.216,0",
    transform: "translate(-438.358 10.616)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6380",
    "data-name": "Caminho 6380",
    d: "M477.12,15.018v.069h-.173v-.069h.048v-.156h-.067V14.8h.067v-.072h.078V14.8h.072v.065h-.072v.156Z",
    transform: "translate(-438.358 10.522)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6381",
    "data-name": "Caminho 6381",
    d: "M477.212,15.018v.069H476.9v-.069h.115v-.156h-.067V14.8h.067v-.072h.077V14.8h.072v.065h-.072v.156Z",
    transform: "translate(-438.378 10.522)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6382",
    "data-name": "Caminho 6382",
    d: "M477.046,15.089a.137.137,0,0,1-.132-.123.124.124,0,0,1,.1-.113l-.059.113c0,.1.186.1.186,0l-.061-.113a.116.116,0,0,1,.084.113.121.121,0,0,1-.12.123",
    transform: "translate(-438.368 10.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6383",
    "data-name": "Caminho 6383",
    d: "M476.341,15.474a.585.585,0,0,0-.074-.084.311.311,0,0,0-.083-.039.092.092,0,0,1,.077-.038.066.066,0,0,1,.055.029l.007-.024s.018,0,.029.036a.39.39,0,0,1,.01.087.1.1,0,0,1-.022.033",
    transform: "translate(-438.889 10.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6384",
    "data-name": "Caminho 6384",
    d: "M476.288,15.393a.048.048,0,0,1,.052,0c.024.024.031.053.012.065s-.034.012-.053-.009a.037.037,0,0,1-.011-.06",
    transform: "translate(-438.824 10.995)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6385",
    "data-name": "Caminho 6385",
    d: "M477.7,15.474s.048-.053.077-.084a.508.508,0,0,1,.084-.039.087.087,0,0,0-.065-.038.061.061,0,0,0-.061.029l-.012-.024a.051.051,0,0,0-.036.036.156.156,0,0,0,0,.087.063.063,0,0,0,.017.033",
    transform: "translate(-437.823 10.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6386",
    "data-name": "Caminho 6386",
    d: "M477.723,15.393c-.012-.009-.048-.009-.053,0-.024.024-.036.053-.024.065a.051.051,0,0,0,.065-.009.037.037,0,0,0,.012-.06",
    transform: "translate(-437.848 10.995)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_447",
    "data-name": "Ret\\xE2ngulo 447",
    width: 2.657,
    height: 0.698,
    transform: "translate(37.349 27.074)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6387",
    "data-name": "Caminho 6387",
    d: "M478.905,16.526h-2.682l-.019-.725,2.676-.024Zm-.048-.725-2.634.024.024.674,2.609-.019Z",
    transform: "translate(-438.875 11.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6388",
    "data-name": "Caminho 6388",
    d: "M478.481,16.6a.091.091,0,0,0-.048-.012h-1.994a.088.088,0,0,0-.053.012.167.167,0,0,0,.12-.158.179.179,0,0,0-.125-.159.473.473,0,0,0,.058.009h1.994a.2.2,0,0,0,.053-.005h-.012a.164.164,0,0,0,.007.314",
    transform: "translate(-438.749 11.637)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6389",
    "data-name": "Caminho 6389",
    d: "M476.4,16.628l0-.021c-.007-.012-.026-.015-.007-.024a.143.143,0,0,0,.1-.135.157.157,0,0,0-.106-.137l2.058-.033-1.963.045c.036.015.055.072.055.125a.236.236,0,0,1-.043.129H478.4a.155.155,0,0,1-.058-.129.185.185,0,0,1,.082-.158c0,.06-.034.108-.034.158a.143.143,0,0,0,.094.135l-2.04.036a.042.042,0,0,1-.029,0l-.019.009",
    transform: "translate(-438.753 11.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6390",
    "data-name": "Caminho 6390",
    d: "M476.465,16.463h1.993a.107.107,0,0,1,.115.1.1.1,0,0,1-.115.093h-1.993c-.065,0-.12-.036-.12-.093a.109.109,0,0,1,.12-.1",
    transform: "translate(-438.775 11.764)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6391",
    "data-name": "Caminho 6391",
    d: "M478.467,16.683h-1.992a.133.133,0,0,1-.144-.117c0-.065.06-.113.144-.113h1.992c.072,0,.144.048.144.113a.141.141,0,0,1-.144.117m-1.992-.189v.144h1.992c.05,0,.1-.031.1-.072Z",
    transform: "translate(-438.785 11.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6392",
    "data-name": "Caminho 6392",
    d: "M476.465,16.2h1.993c.062,0,.115.039.115.084s-.053.074-.115.074h-1.993c-.065,0-.12-.033-.12-.074s.055-.084.12-.084",
    transform: "translate(-438.775 11.575)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6393",
    "data-name": "Caminho 6393",
    d: "M478.469,16.389h-1.993c-.083,0-.148-.046-.148-.1s.065-.1.148-.1h1.993c.072,0,.144.041.144.1s-.065.1-.144.1m-1.993-.158,1.993.111c.055,0,.1-.026.1-.053Z",
    transform: "translate(-438.787 11.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6394",
    "data-name": "Caminho 6394",
    d: "M475.909,23.115a.983.983,0,0,0,.466-.1,1.055,1.055,0,0,1,.468-.1.981.981,0,0,1,.459.1,1.031,1.031,0,0,0,.468.1.969.969,0,0,0,.466-.108,1.122,1.122,0,0,1,.461-.093.949.949,0,0,1,.454.1,1.024,1.024,0,0,0,.466.1V23.4a1.1,1.1,0,0,1-.466-.1,1.037,1.037,0,0,0-.454-.1,1.152,1.152,0,0,0-.461.091.95.95,0,0,1-.466.108,1.1,1.1,0,0,1-.468-.1.981.981,0,0,0-.459-.1,1.105,1.105,0,0,0-.468.1.983.983,0,0,1-.466.1Z",
    transform: "translate(-439.086 16.373)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6395",
    "data-name": "Caminho 6395",
    d: "M479.651,23.437h-.024a1,1,0,0,1-.478-.111,1.169,1.169,0,0,0-.894,0,1.171,1.171,0,0,1-.951,0,1.162,1.162,0,0,0-.909,0,.929.929,0,0,1-.48.111l-.017-.314a1.582,1.582,0,0,0,.485-.123,1.185,1.185,0,0,1,.939,0,1.126,1.126,0,0,0,.921,0,1.169,1.169,0,0,1,.927,0,1.089,1.089,0,0,0,.456.1Zm-2.8-.494a1.01,1.01,0,0,0-.455.1,1,1,0,0,1-.48.1l.024.266a1.536,1.536,0,0,0,.444-.12,1.15,1.15,0,0,1,.939,0,1.14,1.14,0,0,0,.921-.005,1.142,1.142,0,0,1,.927.005,1.08,1.08,0,0,0,.438.1v-.266a.8.8,0,0,1-.459-.081,1.152,1.152,0,0,0-.894-.007,1.171,1.171,0,0,1-.951.007,1.006,1.006,0,0,0-.455-.1",
    transform: "translate(-439.094 16.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6396",
    "data-name": "Caminho 6396",
    d: "M475.909,23.281a1.026,1.026,0,0,0,.466-.1,1.105,1.105,0,0,1,.468-.1,1,1,0,0,1,.459.1,1.1,1.1,0,0,0,.468.1.931.931,0,0,0,.466-.108,1.183,1.183,0,0,1,.461-.089,1.037,1.037,0,0,1,.454.1,1.1,1.1,0,0,0,.466.1v.286a1.1,1.1,0,0,1-.466-.1.969.969,0,0,0-.454-.1,1,1,0,0,0-.461.1,1.061,1.061,0,0,1-.466.1,1.158,1.158,0,0,1-.468-.1.979.979,0,0,0-.459-.1,1.1,1.1,0,0,0-.468.1,1.027,1.027,0,0,1-.466.1Z",
    transform: "translate(-439.086 16.495)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6397",
    "data-name": "Caminho 6397",
    d: "M479.651,23.6h-.024a1.047,1.047,0,0,1-.478-.111,1.146,1.146,0,0,0-.894,0,1.158,1.158,0,0,1-.951.012,1.112,1.112,0,0,0-.909-.012.964.964,0,0,1-.48.111l-.017-.312a1.493,1.493,0,0,0,.485-.12,1.143,1.143,0,0,1,.939,0,1.147,1.147,0,0,0,.921-.005,1.135,1.135,0,0,1,.927.005,1.038,1.038,0,0,0,.456.1Zm-2.8-.489a1.157,1.157,0,0,0-.455.093.959.959,0,0,1-.48.111l.024.261a1.493,1.493,0,0,0,.444-.127,1.164,1.164,0,0,1,.939.007,1.155,1.155,0,0,0,.921-.007,1.163,1.163,0,0,1,.927,0,1.027,1.027,0,0,0,.438.1v-.266a.714.714,0,0,1-.459-.084,1.153,1.153,0,0,0-.894,0,1.171,1.171,0,0,1-.951,0,1.054,1.054,0,0,0-.455-.1",
    transform: "translate(-439.094 16.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6398",
    "data-name": "Caminho 6398",
    d: "M475.909,23.451a1.049,1.049,0,0,0,.466-.1,1.1,1.1,0,0,1,.468-.1,1,1,0,0,1,.459.1,1.13,1.13,0,0,0,.468.1,1.061,1.061,0,0,0,.466-.1.977.977,0,0,1,.461-.1.949.949,0,0,1,.454.1,1.1,1.1,0,0,0,.466.1v.288a1.071,1.071,0,0,1-.466-.1,1.037,1.037,0,0,0-.454-.1,1.122,1.122,0,0,0-.461.093.989.989,0,0,1-.466.108,1.009,1.009,0,0,1-.468-.1,1,1,0,0,0-.459-.1,1.079,1.079,0,0,0-.468.1.944.944,0,0,1-.466.1Z",
    transform: "translate(-439.086 16.611)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6399",
    "data-name": "Caminho 6399",
    d: "M479.651,23.77h-.024a1.046,1.046,0,0,1-.478-.11,1.177,1.177,0,0,0-.894,0,1.151,1.151,0,0,1-.951.009,1.119,1.119,0,0,0-.909,0,1.069,1.069,0,0,1-.48.1l-.017-.31a1.406,1.406,0,0,0,.485-.127,1.171,1.171,0,0,1,.939.007,1.155,1.155,0,0,0,.921-.007,1.17,1.17,0,0,1,.927,0,.994.994,0,0,0,.456.106Zm-2.8-.49a1.157,1.157,0,0,0-.455.093,1,1,0,0,1-.48.111l.024.262a1.655,1.655,0,0,0,.444-.12,1.157,1.157,0,0,1,.939,0,1.114,1.114,0,0,0,.921-.009,1.158,1.158,0,0,1,.922.007,1.022,1.022,0,0,0,.442.1V23.46a.774.774,0,0,1-.459-.087,1.146,1.146,0,0,0-.894,0,1.158,1.158,0,0,1-.951.012.984.984,0,0,0-.455-.1",
    transform: "translate(-439.094 16.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6400",
    "data-name": "Caminho 6400",
    d: "M475.909,23.9a.925.925,0,0,0,.466-.1,1.1,1.1,0,0,1,.468-.1,1.025,1.025,0,0,1,.459.1,1.053,1.053,0,0,0,.468.1.9.9,0,0,0,.466-.111,1.18,1.18,0,0,1,.461-.093,1.088,1.088,0,0,1,.454.1,1,1,0,0,0,.466.108v-.281a1.046,1.046,0,0,1-.466-.111,1.062,1.062,0,0,0-.454-.1,1.121,1.121,0,0,0-.461.094.989.989,0,0,1-.466.108,1.031,1.031,0,0,1-.468-.1,1,1,0,0,0-.459-.1,1.079,1.079,0,0,0-.468.1.983.983,0,0,1-.466.1Z",
    transform: "translate(-439.086 16.732)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6401",
    "data-name": "Caminho 6401",
    d: "M479.651,23.938h-.024a.966.966,0,0,1-.478-.111,1.185,1.185,0,0,0-.894-.005,1.107,1.107,0,0,1-.951.012,1.14,1.14,0,0,0-.909,0,1,1,0,0,1-.48.1l-.017-.31a1.692,1.692,0,0,0,.485-.12,1.15,1.15,0,0,1,.939,0,1.121,1.121,0,0,0,.921-.01,1.123,1.123,0,0,1,.922.007,1.052,1.052,0,0,0,.461.1Zm-2.8-.494a.982.982,0,0,0-.455.1,1.064,1.064,0,0,1-.48.1l.024.264a1.493,1.493,0,0,0,.444-.125,1.2,1.2,0,0,1,.939,0,1.076,1.076,0,0,0,.921-.007,1.2,1.2,0,0,1,.922,0,1,1,0,0,0,.442.108v-.261a.811.811,0,0,1-.459-.093,1.177,1.177,0,0,0-.894,0,1.151,1.151,0,0,1-.951.009,1.006,1.006,0,0,0-.455-.1",
    transform: "translate(-439.094 16.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6402",
    "data-name": "Caminho 6402",
    d: "M475.909,24.071a.963.963,0,0,0,.466-.1,1.16,1.16,0,0,1,.468-.1,1.075,1.075,0,0,1,.459.1,1.031,1.031,0,0,0,.468.1.9.9,0,0,0,.466-.111,1.249,1.249,0,0,1,.461-.089,1.213,1.213,0,0,1,.454.089.944.944,0,0,0,.466.111V23.79a1.024,1.024,0,0,1-.466-.113,1.064,1.064,0,0,0-.454-.091,1.154,1.154,0,0,0-.461.087.913.913,0,0,1-.466.11,1.053,1.053,0,0,1-.468-.1,1.029,1.029,0,0,0-.459-.093,1.106,1.106,0,0,0-.468.093.925.925,0,0,1-.466.1Z",
    transform: "translate(-439.086 16.853)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6403",
    "data-name": "Caminho 6403",
    d: "M479.651,24.105h-.024a1,1,0,0,1-.478-.111,1.2,1.2,0,0,0-.894,0,1.138,1.138,0,0,1-.951,0,1.177,1.177,0,0,0-.909,0,.964.964,0,0,1-.48.108l-.017-.312a1.448,1.448,0,0,0,.485-.125,1.207,1.207,0,0,1,.939,0,1.076,1.076,0,0,0,.921-.007,1.211,1.211,0,0,1,.922,0,1.009,1.009,0,0,0,.461.108Zm-2.8-.489a1.011,1.011,0,0,0-.455.1,1,1,0,0,1-.48.1l.024.264a1.6,1.6,0,0,0,.444-.123,1.164,1.164,0,0,1,.939,0,1.12,1.12,0,0,0,.921,0,1.137,1.137,0,0,1,.922,0,1.047,1.047,0,0,0,.442.1V23.8a.785.785,0,0,1-.459-.094,1.21,1.21,0,0,0-.894-.005,1.107,1.107,0,0,1-.951.012,1.006,1.006,0,0,0-.455-.1",
    transform: "translate(-439.094 16.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6404",
    "data-name": "Caminho 6404",
    d: "M478.613,22.343a.313.313,0,0,0-.012.072.32.32,0,0,0,.329.317H476.2a.331.331,0,0,0,.341-.317.345.345,0,0,0-.019-.072.149.149,0,0,0,.054.007h1.994a.114.114,0,0,0,.047-.007",
    transform: "translate(-438.881 15.965)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6405",
    "data-name": "Caminho 6405",
    d: "M478.931,22.763H476.2a.385.385,0,0,0,.311-.341h.06a.378.378,0,0,1-.353.341l2.538-.045a.338.338,0,0,1-.18-.3l-1.375-.029,1.371-.058c.053.249.191.381.365.381a.022.022,0,0,1,.024.024.021.021,0,0,1-.024.024",
    transform: "translate(-438.881 15.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6406",
    "data-name": "Caminho 6406",
    d: "M476.465,22.237h1.993a.109.109,0,0,1,.115.1.105.105,0,0,1-.115.089h-1.993c-.065,0-.12-.039-.12-.089a.112.112,0,0,1,.12-.1",
    transform: "translate(-438.775 15.89)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6407",
    "data-name": "Caminho 6407",
    d: "M478.467,22.456h-1.992c-.084,0-.144-.048-.144-.113s.06-.115.144-.115h1.992a.134.134,0,0,1,.144.115c0,.065-.072.113-.144.113m-1.992-.189v.144h1.992c.05,0,.1-.033.1-.069Z",
    transform: "translate(-438.785 15.883)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_448",
    "data-name": "Ret\\xE2ngulo 448",
    width: 2.73,
    height: 0.694,
    transform: "translate(37.32 38.699)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6408",
    "data-name": "Caminho 6408",
    d: "M478.958,23.3h-2.747l-.031-.718,2.76-.024Zm-.048-.718-2.7.024.024.67,2.675-.024Z",
    transform: "translate(-438.892 16.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6409",
    "data-name": "Caminho 6409",
    d: "M478.028,20.8c.265.159.455.314.418.394-.012.072-.094.127-.214.211-.2.134-.312.37-.228.483a.689.689,0,0,1-.252-.535.7.7,0,0,1,.276-.554",
    transform: "translate(-437.769 14.866)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6410",
    "data-name": "Caminho 6410",
    d: "M478,21.918a.719.719,0,0,1,.019-1.126c.173.086.509.3.461.423-.012.072-.1.129-.2.2a.607.607,0,0,0-.27.357L478,21.86c.012.005.019.017.031.024Zm.019-1.085a.733.733,0,0,0-.24.533.694.694,0,0,0,.18.454.122.122,0,0,1,.006-.051.567.567,0,0,1,.263-.37c.12-.084.2-.141.209-.2s-.121-.2-.418-.37",
    transform: "translate(-437.779 14.857)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_449",
    "data-name": "Ret\\xE2ngulo 449",
    width: 1.934,
    height: 9.49,
    transform: "translate(37.721 28.53)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6411",
    "data-name": "Caminho 6411",
    d: "M477.5,26.1l-.048-9.469h.048Zm-.209,0-.048-9.469h.048Z",
    transform: "translate(-438.136 11.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6412",
    "data-name": "Caminho 6412",
    d: "M478.4,26.156h-1.951l-.031-9.507,1.963-.024Zm-.043-9.507-1.908.021.022,9.469,1.886-.027Z",
    transform: "translate(-438.725 11.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6413",
    "data-name": "Caminho 6413",
    d: "M475.281,19.306a6.1,6.1,0,0,1,1.963-.333,5.527,5.527,0,0,1,.922.087c1.154.194,2.04.65,1.975,1.032,0,.009-.012.021-.012.033s.436-.984.442-1.017c.084-.417-.9-.938-2.184-1.147a5.821,5.821,0,0,0-1.139-.089,6.1,6.1,0,0,0-1.968.262Z",
    transform: "translate(-439.535 12.77)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6414",
    "data-name": "Caminho 6414",
    d: "M480.14,20.157h0c-.013-.007-.024-.015-.024-.024l.024,0-.019-.012c.006,0,.006-.009.006-.021a.288.288,0,0,0-.066-.221,3.23,3.23,0,0,0-1.892-.784,5.421,5.421,0,0,0-.915-.094,6.249,6.249,0,0,0-1.963.333l-.024-1.192a5.576,5.576,0,0,1,2.006-.286,6.735,6.735,0,0,1,1.125.087,3.759,3.759,0,0,1,2.136.9.343.343,0,0,1,.072.269c-.007.038-.37.862-.449,1.024a.015.015,0,0,1-.017.015m-2.886-1.2a5.926,5.926,0,0,1,.928.081,3.268,3.268,0,0,1,1.915.811.381.381,0,0,1,.072.159c.173-.377.384-.868.4-.9a.322.322,0,0,0-.072-.237,3.7,3.7,0,0,0-2.1-.883,6.707,6.707,0,0,0-3.095.177l.012,1.147a5.261,5.261,0,0,1,1.946-.353",
    transform: "translate(-439.545 12.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6415",
    "data-name": "Caminho 6415",
    d: "M477.56,19.8c.545-.036.9-.182.952-.4.029-.182-.145-.382-.473-.559a4.571,4.571,0,0,1-.479.036Z",
    transform: "translate(-437.906 13.462)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6416",
    "data-name": "Caminho 6416",
    d: "M477.551,19.833l0-.952c.154-.021.287-.039.414-.048.442.182.615.389.579.571-.041.231-.394.387-.963.425Zm.485-.964a3.948,3.948,0,0,1-.466.039l.029.88c.526-.043.855-.189.9-.384.024-.166-.132-.351-.461-.535",
    transform: "translate(-437.916 13.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6417",
    "data-name": "Caminho 6417",
    d: "M476.736,18.98a1.682,1.682,0,0,0-.718.237l-.012.021c-.06.123.24.386.737.674Z",
    transform: "translate(-439.022 13.562)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6418",
    "data-name": "Caminho 6418",
    d: "M476.774,19.962l-.035-.021c-.317-.182-.833-.526-.742-.706a1.493,1.493,0,0,1,.748-.269Zm-.053-.972a1.916,1.916,0,0,0-.675.252c-.048.089.118.3.675.64Z",
    transform: "translate(-439.03 13.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6419",
    "data-name": "Caminho 6419",
    d: "M479.932,21.439c.048-.156-.473-.466-1.209-.73-.341-.125-.617-.25-.97-.406-1.017-.449-1.784-.976-1.687-1.164l.005-.021a8,8,0,0,0-.137.986c-.1.175.605.682,1.55,1.138.305.149.946.379,1.244.487.534.185,1.079.545,1.024.674Z",
    transform: "translate(-439.075 13.661)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6420",
    "data-name": "Caminho 6420",
    d: "M479.77,22.419c-.012,0-.023-.009-.023-.009h.012l-.017-.015V22.39c0-.123-.49-.446-1.012-.634-.3-.1-.946-.338-1.251-.482a3.873,3.873,0,0,1-1.562-1.087,5.591,5.591,0,0,1,.151-1.08c.113.338.825.79,1.7,1.183.372.166.641.283.965.4.656.247,1.286.573,1.226.761l-.18.945c0,.015-.005.024-.013.024m-3.722-3.18c0,.065-.048.485-.077.874.065.281.718.727,1.531,1.118.3.142.939.381,1.244.489a2.578,2.578,0,0,1,1.012.59l.156-.868c.043-.115-.371-.4-1.19-.706-.331-.117-.6-.24-.929-.384a4.328,4.328,0,0,1-1.747-1.113",
    transform: "translate(-439.081 13.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6421",
    "data-name": "Caminho 6421",
    d: "M476.242,18.806c.072-.276.173-.545.257-.818a.446.446,0,0,0-.065.015h-.06a4.606,4.606,0,0,1-.173.593c-.108-.173-.24-.341-.336-.514-.041.005-.083.017-.12.024s-.084.009-.125.012c.173.233.341.463.5.706.017-.007.041-.01.065-.019Z",
    transform: "translate(-439.293 12.854)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6422",
    "data-name": "Caminho 6422",
    d: "M476.5,17.991a.539.539,0,0,1-.1.007.767.767,0,0,1-.1-.01l-.024.763.54.012c0-.014-.007-.029-.007-.045s.007-.036.007-.051a2.55,2.55,0,0,1-.317.01Z",
    transform: "translate(-438.825 12.854)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6423",
    "data-name": "Caminho 6423",
    d: "M477.094,18.113c.084.009.161.027.246.039v-.045a.157.157,0,0,1,.012-.055L476.628,18c0,.015.012.033,0,.045v.051c.065,0,.156,0,.25,0l-.059.691h.106c.036.005.072.009.1.014Z",
    transform: "translate(-438.573 12.859)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6424",
    "data-name": "Caminho 6424",
    d: "M477.075,18.816a.382.382,0,0,0,.1.017c.036.012.072.017.1.027l.091-.348h.012c.024.045.036.108.053.141l.113.267a.534.534,0,0,1,.127.026.473.473,0,0,1,.113.027l-.036-.084c-.048-.113-.113-.237-.168-.357.139.007.24-.038.264-.149a.166.166,0,0,0-.077-.185.736.736,0,0,0-.223-.069l-.293-.063Zm.365-.641c.089.012.192.027.192.123a.11.11,0,0,1-.007.053c-.024.117-.113.156-.25.113Z",
    transform: "translate(-438.253 12.91)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6425",
    "data-name": "Caminho 6425",
    d: "M478.132,18.863a1.81,1.81,0,0,1-.048.249l.113.051c.029.021.067.041.1.063l.072-.856a.306.306,0,0,1-.042-.027.093.093,0,0,1-.048-.024l-.759.482a.612.612,0,0,1,.058.024c.024.012.036.027.055.038a2.051,2.051,0,0,1,.209-.154Zm-.216-.194.245-.168-.024.285Z",
    transform: "translate(-437.934 13.091)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6426",
    "data-name": "Caminho 6426",
    d: "M470.331,14.332a.26.26,0,0,1-.269-.249c0-.276.521-.276.521,0a.253.253,0,0,1-.252.249m0-.494a.258.258,0,0,0-.264.245c0,.266.516.266.516,0a.253.253,0,0,0-.252-.245",
    transform: "translate(-443.264 9.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6427",
    "data-name": "Caminho 6427",
    d: "M474.246,12.747a5.583,5.583,0,0,1,1.951.305,3.919,3.919,0,0,0,.995.252,3.867,3.867,0,0,0,.819.029,3.112,3.112,0,0,1,1.262.3,3.424,3.424,0,0,1,.935.579l-.192.168-.053.477-.509.583-.25.216-.612.49-.305.017-.094.273-3.927-.461-3.933.461-.1-.273-.31-.017-.61-.49-.252-.216-.509-.583-.053-.477-.2-.168a3.713,3.713,0,0,1,.933-.579,3.19,3.19,0,0,1,1.269-.3,3.8,3.8,0,0,0,.814-.029,3.912,3.912,0,0,0,1-.252,5.371,5.371,0,0,1,1.927-.305",
    transform: "translate(-444.521 9.109)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6428",
    "data-name": "Caminho 6428",
    d: "M478.2,16.453h-.012l-3.921-.461-3.932.461-.108-.278-.3-.012-.868-.71-.521-.586-.053-.482-.185-.156a3.051,3.051,0,0,1,.933-.614,3.363,3.363,0,0,1,1.251-.3c.108.007.2.01.293.01a3.723,3.723,0,0,0,.538-.039,3.78,3.78,0,0,0,1.006-.254,6.629,6.629,0,0,1,3.878,0,3.915,3.915,0,0,0,.993.254,3.674,3.674,0,0,0,.821.029,3.339,3.339,0,0,1,1.274.3,3.3,3.3,0,0,1,.928.593l-.186.185-.041.465-.778.811-.61.487-.312.027Zm-7.691-3.1a3.4,3.4,0,0,0-1.264.293,3.592,3.592,0,0,0-.921.586l.192.141.053.489.766.79.6.487.305.015.113.281,3.915-.47,3.909.458.089-.255.33-.033.851-.7.514-.586.048-.465.192-.173a3.857,3.857,0,0,0-.928-.566,3.3,3.3,0,0,0-1.239-.293,3.513,3.513,0,0,1-.838-.027,3.8,3.8,0,0,1-1-.262,6.671,6.671,0,0,0-3.861,0,3.559,3.559,0,0,1-1,.262,3.392,3.392,0,0,1-.814.027",
    transform: "translate(-444.524 9.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6429",
    "data-name": "Caminho 6429",
    d: "M473.384,16.268a13.444,13.444,0,0,1-3.705-.461.124.124,0,0,1-.1-.142.141.141,0,0,1,.1-.139,15.225,15.225,0,0,1,7.411,0,.148.148,0,0,1,.1.139.135.135,0,0,1-.1.142,13.474,13.474,0,0,1-3.706.461",
    transform: "translate(-443.606 10.767)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6430",
    "data-name": "Caminho 6430",
    d: "M473.4,16.3h0a13.316,13.316,0,0,1-3.71-.456.164.164,0,0,1-.12-.17.182.182,0,0,1,.12-.168,15.356,15.356,0,0,1,7.416,0,.181.181,0,0,1,.125.168.17.17,0,0,1-.125.17,13.282,13.282,0,0,1-3.706.456m0-1.2a13.411,13.411,0,0,0-3.7.458.11.11,0,0,0-.084.117.122.122,0,0,0,.084.125,15.223,15.223,0,0,0,7.4,0,.127.127,0,0,0,.084-.125.123.123,0,0,0-.084-.117,13.444,13.444,0,0,0-3.7-.458",
    transform: "translate(-443.619 10.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6431",
    "data-name": "Caminho 6431",
    d: "M473.221,15.979a14.324,14.324,0,0,1-3.417-.389,15.491,15.491,0,0,1,6.841,0,14.448,14.448,0,0,1-3.424.389",
    transform: "translate(-443.449 10.866)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6432",
    "data-name": "Caminho 6432",
    d: "M471.183,15.935V15.22l.041.715Z",
    transform: "translate(-442.464 10.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6433",
    "data-name": "Caminho 6433",
    d: "M471.092,15.923v-.7l.053.7Z",
    transform: "translate(-442.529 10.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6434",
    "data-name": "Caminho 6434",
    d: "M473.486,15.357a13.211,13.211,0,0,0-3.746.478c.077-.045.077-.137-.019-.382-.12-.305-.3-.293-.3-.293a16.979,16.979,0,0,1,8.158,0s-.185-.012-.3.293c-.1.245-.108.338-.029.382a13.265,13.265,0,0,0-3.765-.478",
    transform: "translate(-443.72 10.478)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6435",
    "data-name": "Caminho 6435",
    d: "M477.241,15.864a13.536,13.536,0,0,0-3.76-.475,13.22,13.22,0,0,0-3.734.475c.036-.072.048-.132-.048-.394s-.263-.273-.263-.273h-.007a.049.049,0,0,1,.048-.024,13.638,13.638,0,0,1,4.011-.523,15.271,15.271,0,0,1,4.094.5c-.031.045-.187.053-.288.317s-.089.326-.036.355Zm-7.751-.691c.065.012.173.077.245.278.089.231.12.365.012.413a11.92,11.92,0,0,1,3.734-.523,14.133,14.133,0,0,1,3.693.454.67.67,0,0,1,.079-.345c.113-.285.281-.3.317-.3a16.966,16.966,0,0,0-4.082-.453,15.308,15.308,0,0,0-4,.473",
    transform: "translate(-443.715 10.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6436",
    "data-name": "Caminho 6436",
    d: "M473.565,14.769a15.247,15.247,0,0,0-4.071.5.125.125,0,0,1-.167-.072.134.134,0,0,1,.083-.156,16.785,16.785,0,0,1,8.314,0,.116.116,0,0,1,.084.156.125.125,0,0,1-.168.072,15.255,15.255,0,0,0-4.075-.5",
    transform: "translate(-443.793 10.372)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6437",
    "data-name": "Caminho 6437",
    d: "M477.694,15.311l-.053-.009a16.859,16.859,0,0,0-8.128,0c-.125,0-.18-.027-.2-.091l.1-.163v-.026a14.859,14.859,0,0,1,4.154-.52,15.089,15.089,0,0,1,4.167.52l.106.192a.157.157,0,0,1-.149.1m-4.124-.763a14.768,14.768,0,0,0-4.143.523l-.072.127.1.086.048-.026a14.84,14.84,0,0,1,4.07-.5,15,15,0,0,1,4.088.5l.036.005a.086.086,0,0,0,.1-.065l-.065-.127a15.074,15.074,0,0,0-4.154-.523",
    transform: "translate(-443.798 10.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6438",
    "data-name": "Caminho 6438",
    d: "M473.224,16.014h0a14.415,14.415,0,0,1-3.424-.393,12.193,12.193,0,0,1,3.424-.427,14.254,14.254,0,0,1,3.429.381,12.29,12.29,0,0,1-3.429.439m0-.775a14.372,14.372,0,0,0-3.417.382,17.057,17.057,0,0,0,3.417.339,14.128,14.128,0,0,0,3.424-.386,17.424,17.424,0,0,0-3.424-.336",
    transform: "translate(-443.451 10.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6439",
    "data-name": "Caminho 6439",
    d: "M471.134,14.93a.127.127,0,0,1,.125-.125.13.13,0,0,1,.132.125.128.128,0,0,1-.132.12.125.125,0,0,1-.125-.12",
    transform: "translate(-442.498 10.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6440",
    "data-name": "Caminho 6440",
    d: "M472.022,15.036h-.39a.141.141,0,0,1-.144-.123.134.134,0,0,1,.132-.122h.8a.126.126,0,0,1,.132.122.133.133,0,0,1-.144.123Z",
    transform: "translate(-442.244 10.569)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6441",
    "data-name": "Caminho 6441",
    d: "M472.418,15.067h-.778a.154.154,0,0,1-.161-.144.148.148,0,0,1,.149-.146h.8a.149.149,0,0,1,.156.146.156.156,0,0,1-.168.144m-.79-.245a.106.106,0,0,0-.1.1.1.1,0,0,0,.113.1h.778a.1.1,0,0,0,.113-.1.1.1,0,0,0-.1-.1Z",
    transform: "translate(-442.251 10.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6442",
    "data-name": "Caminho 6442",
    d: "M470.826,15.113l-.281.036a.139.139,0,0,1-.144-.111.121.121,0,0,1,.113-.137l.281-.033.3-.033a.124.124,0,1,1,.029.245Z",
    transform: "translate(-443.023 10.6)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6443",
    "data-name": "Caminho 6443",
    d: "M470.539,15.177a.145.145,0,0,1-.149-.129l.13-.137,0-.022.569-.069a.175.175,0,0,1,.185.129l-.144.141v.021Zm-.108-.132a.105.105,0,0,0,.108.084v.029l.012-.029.574-.065.113-.115-.024.007a.1.1,0,0,0-.1-.091l-.586.069-.121.115Z",
    transform: "translate(-443.03 10.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6444",
    "data-name": "Caminho 6444",
    d: "M469.985,15.06a.123.123,0,0,1,.125-.122.125.125,0,1,1,0,.25.125.125,0,0,1-.125-.129",
    transform: "translate(-443.319 10.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6445",
    "data-name": "Caminho 6445",
    d: "M469.472,15.219l.156-.185.4.048-.324.233Z",
    transform: "translate(-443.686 10.743)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6446",
    "data-name": "Caminho 6446",
    d: "M469.705,15.349l-.233-.1.137-.225.425.045Z",
    transform: "translate(-443.686 10.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6447",
    "data-name": "Caminho 6447",
    d: "M473.113,15.113l.281.036a.145.145,0,0,0,.156-.111.139.139,0,0,0-.12-.137l-.287-.033-.288-.033a.134.134,0,0,0-.144.1.131.131,0,0,0,.12.141Z",
    transform: "translate(-441.372 10.6)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6448",
    "data-name": "Caminho 6448",
    d: "M473.419,15.178l-.587-.067-.132-.161a.137.137,0,0,1,.144-.129l.6.069.132.159a.154.154,0,0,1-.156.129m-.558-.312a.117.117,0,0,0-.12.089l.1.108.582.067a.1.1,0,0,0,.106-.084l-.089-.111Z",
    transform: "translate(-441.378 10.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6449",
    "data-name": "Caminho 6449",
    d: "M472.313,14.93a.132.132,0,0,1,.264,0,.133.133,0,0,1-.264,0",
    transform: "translate(-441.656 10.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6450",
    "data-name": "Caminho 6450",
    d: "M473.462,15.06a.131.131,0,0,1,.137-.122.122.122,0,0,1,.121.122.124.124,0,0,1-.121.129.131.131,0,0,1-.137-.129",
    transform: "translate(-440.835 10.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6451",
    "data-name": "Caminho 6451",
    d: "M474.354,15.219l-.149-.185-.4.048.317.233Z",
    transform: "translate(-440.59 10.743)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6452",
    "data-name": "Caminho 6452",
    d: "M474.129,15.353l-.336-.24.42-.1.161.2Z",
    transform: "translate(-440.598 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6453",
    "data-name": "Caminho 6453",
    d: "M469.724,15.664l-.019-.048a15.476,15.476,0,0,1,7.177,0,16.791,16.791,0,0,0-3.59-.377,13.76,13.76,0,0,0-3.568.425",
    transform: "translate(-443.519 10.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6454",
    "data-name": "Caminho 6454",
    d: "M470.186,14.312l.161.129.252-.4a.925.925,0,0,1-.456-.775.358.358,0,0,1,.012-.111c.019-.519.653-.94,1.449-.94a1.857,1.857,0,0,1,1.054.291,2.1,2.1,0,0,1,.024-.219,2.18,2.18,0,0,0-1.079-.274c-.921,0-1.634.526-1.67,1.142a.911.911,0,0,0-.012.111,1.1,1.1,0,0,0,.389.832Z",
    transform: "translate(-443.364 8.583)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6455",
    "data-name": "Caminho 6455",
    d: "M470.367,14.484l-.192-.147.132-.242a1.054,1.054,0,0,1-.395-.823,1.532,1.532,0,0,1,1.7-1.272,2.311,2.311,0,0,1,1.1.273,1.281,1.281,0,0,1-.024.238,2.294,2.294,0,0,0-1.076-.269c-.778,0-1.406.408-1.43.919a.911.911,0,0,0,.436.862Zm1.245-2.436c-.875,0-1.617.5-1.646,1.113a1.1,1.1,0,0,0,.377.926l-.132.245.137.089.24-.386a.865.865,0,0,1-.461-.763c.036-.653.677-1.075,1.485-1.075a1.884,1.884,0,0,1,1.064.3.389.389,0,0,1,0-.2,2.394,2.394,0,0,0-1.06-.242",
    transform: "translate(-443.371 8.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6456",
    "data-name": "Caminho 6456",
    d: "M470.295,14.146a1.132,1.132,0,0,1-.509-.9,1.2,1.2,0,0,1,.67-1,1.034,1.034,0,0,0-.425.739.9.9,0,0,0-.012.11,1.107,1.107,0,0,0,.389.833Z",
    transform: "translate(-443.461 8.751)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6457",
    "data-name": "Caminho 6457",
    d: "M470.31,14.192l-.024-.014a1.152,1.152,0,0,1-.514-.919,1.242,1.242,0,0,1,.675-1.027,1.256,1.256,0,0,0-.382.763,1.117,1.117,0,0,0,.37.924Zm.137-1.96a1.325,1.325,0,0,0-.627,1.027,1.1,1.1,0,0,0,.472.861l.115-.19a1.057,1.057,0,0,1-.4-.823,1.13,1.13,0,0,1,.437-.874",
    transform: "translate(-443.471 8.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6458",
    "data-name": "Caminho 6458",
    d: "M468.586,14.468a1.1,1.1,0,0,1-.288-.727,1.071,1.071,0,0,1,.115-.477,2.2,2.2,0,0,1,1.993-.9,3.53,3.53,0,0,1,.737.077.954.954,0,0,0-.132.18,3.182,3.182,0,0,0-.6-.063,1.961,1.961,0,0,0-1.8.8.895.895,0,0,0,.245,1.072l-.317.513-.167-.13Z",
    transform: "translate(-444.524 8.838)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6459",
    "data-name": "Caminho 6459",
    d: "M468.551,15l-.185-.154.209-.375a1,1,0,0,1-.286-.715,1.13,1.13,0,0,1,.108-.487,2.232,2.232,0,0,1,2.016-.91,3.1,3.1,0,0,1,.743.084.879.879,0,0,1-.108.2c-.216-.015-.418-.036-.635-.036a2,2,0,0,0-1.783.775,1.018,1.018,0,0,0-.079.377.879.879,0,0,0,.324.674Zm1.862-2.594a2.186,2.186,0,0,0-1.97.892.92.92,0,0,0-.106.458,1.08,1.08,0,0,0,.269.713l-.209.37.149.089.3-.49a.808.808,0,0,1-.334-.682,1.108,1.108,0,0,1,.084-.394,2.012,2.012,0,0,1,1.819-.806,3.339,3.339,0,0,1,.61.057.571.571,0,0,1,.108-.165c-.216-.014-.455-.041-.719-.041",
    transform: "translate(-444.531 8.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6460",
    "data-name": "Caminho 6460",
    d: "M468.982,12.592a1.407,1.407,0,0,0-.49.514,1.094,1.094,0,0,0-.115.477,1.107,1.107,0,0,0,.288.727l-.192.309a1.326,1.326,0,0,1-.286-.8,1.488,1.488,0,0,1,.8-1.229",
    transform: "translate(-444.604 8.998)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6461",
    "data-name": "Caminho 6461",
    d: "M468.482,14.67l-.012-.031a1.307,1.307,0,0,1-.293-.809,1.5,1.5,0,0,1,.813-1.25,1.752,1.752,0,0,0-.466.554.921.921,0,0,0-.108.458,1.081,1.081,0,0,0,.269.71Zm.089-1.718a1.341,1.341,0,0,0-.353.878,1.284,1.284,0,0,0,.264.753l.173-.276a1.007,1.007,0,0,1-.288-.715,1.139,1.139,0,0,1,.108-.489,1.186,1.186,0,0,1,.1-.151",
    transform: "translate(-444.611 8.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6462",
    "data-name": "Caminho 6462",
    d: "M472.059,11.951a.439.439,0,0,1,.438.326,3.671,3.671,0,0,1,.053.55c0,.019,0,.043,0,.063a.375.375,0,0,1,0,.072,3.658,3.658,0,0,0,.151,1.015l-.642.616-.646-.616a3.445,3.445,0,0,0,.156-1.015v-.135a2.963,2.963,0,0,1,.06-.55.436.436,0,0,1,.43-.326",
    transform: "translate(-442.299 8.54)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6463",
    "data-name": "Caminho 6463",
    d: "M472.064,14.615l-.659-.633a3.737,3.737,0,0,0,.144-1.029l.024-.135h-.024a3.127,3.127,0,0,1,.053-.552.5.5,0,0,1,.922,0,3.19,3.19,0,0,1,.041.552l.012.135a3.489,3.489,0,0,0,.144,1.012Zm0-2.649a.431.431,0,0,0-.413.309,3.051,3.051,0,0,0-.048.544l-.005.141a3.407,3.407,0,0,1-.156,1.022l.623.566.629-.593a2.852,2.852,0,0,1-.163-.994l.024-.141-.029,0a2.708,2.708,0,0,0-.053-.55.4.4,0,0,0-.408-.305",
    transform: "translate(-442.303 8.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6464",
    "data-name": "Caminho 6464",
    d: "M471.965,12.066a.239.239,0,0,1,.228.168,2.934,2.934,0,0,1,.048.523v.129a2.963,2.963,0,0,0,.144.962l-.42.394-.419-.394a3.393,3.393,0,0,0,.144-.962v-.129a3.479,3.479,0,0,1,.046-.523.239.239,0,0,1,.229-.168",
    transform: "translate(-442.204 8.622)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6465",
    "data-name": "Caminho 6465",
    d: "M471.969,14.272l-.43-.411a3.7,3.7,0,0,0,.125-.976l.031-.13h-.024a4.608,4.608,0,0,1,.046-.526c.048-.209.449-.218.509,0a4.244,4.244,0,0,1,.036.526l.012.13a2.893,2.893,0,0,0,.137.948Zm0-2.181a.207.207,0,0,0-.2.149,3.253,3.253,0,0,0-.048.514l-.012.13a3,3,0,0,1-.137.964l.4.365.408-.387a2.71,2.71,0,0,1-.151-.941l.019-.13h-.019a4.469,4.469,0,0,0-.053-.52.208.208,0,0,0-.2-.144",
    transform: "translate(-442.209 8.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6466",
    "data-name": "Caminho 6466",
    d: "M474.549,14.312l-.168.129-.25-.4a.912.912,0,0,0,.455-.775.358.358,0,0,0-.012-.111c-.012-.519-.653-.94-1.449-.94a1.853,1.853,0,0,0-1.053.291c-.007-.081-.012-.147-.024-.219a2.187,2.187,0,0,1,1.077-.274c.916,0,1.641.526,1.677,1.142v.111a1.136,1.136,0,0,1-.384.832Z",
    transform: "translate(-441.845 8.583)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6467",
    "data-name": "Caminho 6467",
    d: "M474.379,14.484l-.25-.429a.966.966,0,0,0,.442-.784c-.031-.622-.658-1.03-1.437-1.03a1.816,1.816,0,0,0-1.036.293.77.77,0,0,1-.065-.238,2.083,2.083,0,0,1,1.1-.3c.916,0,1.665.509,1.694,1.161a1.171,1.171,0,0,1-.389.964l.144.183ZM473.135,12.2c.807,0,1.449.422,1.484.964a.981.981,0,0,1-.466.9l.246.353.149-.117-.144-.183a1.177,1.177,0,0,0,.389-.845c-.041-.737-.766-1.224-1.658-1.224a2.119,2.119,0,0,0-1.065.266.568.568,0,0,1,.036.2,1.578,1.578,0,0,1,1.029-.312",
    transform: "translate(-441.855 8.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6468",
    "data-name": "Caminho 6468",
    d: "M473.565,14.146a1.144,1.144,0,0,0,.5-.9,1.193,1.193,0,0,0-.659-1,1.065,1.065,0,0,1,.42.739v.11a1.137,1.137,0,0,1-.384.833Z",
    transform: "translate(-440.872 8.751)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6469",
    "data-name": "Caminho 6469",
    d: "M473.566,14.177l-.137-.249a1.148,1.148,0,0,0,.389-.838,1.1,1.1,0,0,0-.42-.835,1.121,1.121,0,0,1,.707.988,1.171,1.171,0,0,1-.514.919Zm-.149-1.91a.889.889,0,0,1,.438.712,1.174,1.174,0,0,1-.389.965l.113.163a1.088,1.088,0,0,0,.473-.864,1.171,1.171,0,0,0-.634-.976",
    transform: "translate(-440.88 8.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6470",
    "data-name": "Caminho 6470",
    d: "M476.173,14.468a1.052,1.052,0,0,0,.18-1.2,2.2,2.2,0,0,0-1.994-.9,3.6,3.6,0,0,0-.736.077.634.634,0,0,1,.125.18,3.293,3.293,0,0,1,.61-.063,1.958,1.958,0,0,1,1.795.8.814.814,0,0,1,.084.381.883.883,0,0,1-.322.691l.31.513.168-.13Z",
    transform: "translate(-440.72 8.838)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6471",
    "data-name": "Caminho 6471",
    d: "M476.222,15l-.322-.538a.98.98,0,0,0,.322-.706,1.026,1.026,0,0,0-.077-.377,1.973,1.973,0,0,0-1.778-.775,3.208,3.208,0,0,0-.6.057c-.072-.077-.1-.132-.156-.182a2.082,2.082,0,0,1,.754-.12,2.2,2.2,0,0,1,2.011.91,1,1,0,0,1,.113.487,1.114,1.114,0,0,1-.287.742l.215.317Zm-1.855-2.445a1.981,1.981,0,0,1,1.814.808.814.814,0,0,1,.1.393.929.929,0,0,1-.341.712l.3.461.156-.12-.221-.314a1.183,1.183,0,0,0,.281-.739,1,1,0,0,0-.115-.458,2.181,2.181,0,0,0-1.968-.892,3.228,3.228,0,0,0-.731.081.242.242,0,0,1,.138.125,2.976,2.976,0,0,1,.593-.057",
    transform: "translate(-440.728 8.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6472",
    "data-name": "Caminho 6472",
    d: "M474.925,12.592a1.335,1.335,0,0,1,.5.514,1.052,1.052,0,0,1-.18,1.2l.2.309a1.319,1.319,0,0,0,.288-.8,1.47,1.47,0,0,0-.8-1.229",
    transform: "translate(-439.789 8.998)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6473",
    "data-name": "Caminho 6473",
    d: "M475.443,14.653l-.209-.341a1.183,1.183,0,0,0,.281-.739.944.944,0,0,0-.113-.458,1.235,1.235,0,0,0-.485-.511,1.117,1.117,0,0,1,.312.194,1.242,1.242,0,0,1,.226,1.826Zm-.029-1.631a.163.163,0,0,1,.029.063,1.017,1.017,0,0,1,.115.487,1.12,1.12,0,0,1-.288.742l.173.252a1.211,1.211,0,0,0-.029-1.545",
    transform: "translate(-439.795 9.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6474",
    "data-name": "Caminho 6474",
    d: "M471.661,13.265a.216.216,0,0,1,.221-.209.214.214,0,1,1,0,.425.216.216,0,0,1-.221-.216",
    transform: "translate(-442.122 9.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6475",
    "data-name": "Caminho 6475",
    d: "M471.9,13.5a.252.252,0,0,1-.252-.243c0-.254.509-.254.509,0a.249.249,0,0,1-.257.243m0-.429a.2.2,0,0,0-.2.185c0,.216.408.216.408,0a.189.189,0,0,0-.2-.185",
    transform: "translate(-442.134 9.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6476",
    "data-name": "Caminho 6476",
    d: "M471.661,13.025a.218.218,0,0,1,.221-.216.226.226,0,0,1,.233.216.223.223,0,0,1-.233.213.215.215,0,0,1-.221-.213",
    transform: "translate(-442.122 9.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6477",
    "data-name": "Caminho 6477",
    d: "M471.9,13.255a.249.249,0,0,1-.252-.237c0-.264.509-.264.509,0a.247.247,0,0,1-.257.237m0-.429a.2.2,0,0,0-.2.192c0,.209.408.209.408,0a.192.192,0,0,0-.2-.192",
    transform: "translate(-442.134 9.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6478",
    "data-name": "Caminho 6478",
    d: "M471.685,12.742a.176.176,0,0,1,.18-.173.172.172,0,0,1,.178.173.17.17,0,0,1-.178.168.174.174,0,0,1-.18-.168",
    transform: "translate(-442.104 8.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6479",
    "data-name": "Caminho 6479",
    d: "M471.875,12.932a.2.2,0,0,1-.2-.194c0-.216.413-.216.413,0a.2.2,0,0,1-.209.194",
    transform: "translate(-442.114 8.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6480",
    "data-name": "Caminho 6480",
    d: "M471.713,12.484a.126.126,0,0,1,.132-.122.123.123,0,0,1,.132.122.128.128,0,0,1-.132.123.132.132,0,0,1-.132-.123",
    transform: "translate(-442.084 8.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6481",
    "data-name": "Caminho 6481",
    d: "M471.73,12.264a.107.107,0,0,1,.1-.1.1.1,0,0,1,.108.1.1.1,0,0,1-.108.1.1.1,0,0,1-.1-.1",
    transform: "translate(-442.072 8.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6482",
    "data-name": "Caminho 6482",
    d: "M473.923,13.935l.149.027a.663.663,0,0,0-.029.19.576.576,0,0,0,.592.554.6.6,0,0,0,.557-.379c.006.005.053-.2.072-.2s.024.216.029.209a.594.594,0,0,0,1.174-.084c0-.017-.006-.041-.006-.065l.173-.183.1.237a.619.619,0,0,0-.055.242.544.544,0,0,0,.563.526.58.58,0,0,0,.468-.233l.113-.149v.18c0,.185.072.351.257.379a.785.785,0,0,0,.48-.2,2.834,2.834,0,0,0,.418-.394l.029.214a1.723,1.723,0,0,1-.472.494.818.818,0,0,1-.5.132.508.508,0,0,1-.366-.327.731.731,0,0,1-.413.118.8.8,0,0,1-.759-.459.849.849,0,0,1-.616.269.881.881,0,0,1-.672-.305.817.817,0,0,1-.574.221.869.869,0,0,1-.712-.362.853.853,0,0,1-.7.362.883.883,0,0,0-1.252.084.861.861,0,0,1-.622-.269.8.8,0,0,1-.748.459.771.771,0,0,1-.425-.118.482.482,0,0,1-.353.327.851.851,0,0,1-.516-.132,2.016,2.016,0,0,1-.479-.494l.031-.214a3.572,3.572,0,0,0,.424.394.776.776,0,0,0,.48.2c.185-.027.257-.194.257-.379v-.18l.12.149a.56.56,0,0,0,.466.233.543.543,0,0,0,.558-.526.461.461,0,0,0-.055-.242l.1-.237.178.183v.065a.587.587,0,0,0,1.163.084c0,.007,0-.2.029-.209s.065.209.077.2a.582.582,0,0,0,.564.379.57.57,0,0,0,.58-.554.49.49,0,0,0-.029-.19Z",
    transform: "translate(-444.145 9.958)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6483",
    "data-name": "Caminho 6483",
    d: "M478.1,15.466l-.072,0a.51.51,0,0,1-.371-.341.827.827,0,0,1-1.173-.341.868.868,0,0,1-1.282-.026.894.894,0,0,1-1.292-.151,13.83,13.83,0,0,1-2.574.18.819.819,0,0,1-1.166.35.428.428,0,0,1-.341.329,1.192,1.192,0,0,1-.528-.137,1.747,1.747,0,0,1-.472-.5l.005-.231c.06-.029.2.165.466.377a.822.822,0,0,0,.468.2c.144-.026.238-.158.238-.358l-.012-.18.168.132a.532.532,0,0,0,.935-.506l.094-.252.223.173a.568.568,0,0,0,.563.614.547.547,0,0,0,.563-.449c.005-.2.017-.23.042-.23s.047.031.083.147a.581.581,0,0,0,1.126-.1.589.589,0,0,0-.031-.182l.168-.06.161.029a1.585,1.585,0,0,0-.017.213.565.565,0,0,0,1.1.161c.07-.177.077-.209.1-.209s.041.033.048.171a.552.552,0,0,0,.568.507.544.544,0,0,0,.557-.532l.036-.043a.588.588,0,0,1-.593.622.6.6,0,0,1-.61-.49c-.005-.077-.012-.144-.012-.173a.51.51,0,0,1-.024.1.623.623,0,0,1-1.209-.113.457.457,0,0,1,.031-.2l-.269.031c.041.034.041.1.041.17a.59.59,0,0,1-.6.581.611.611,0,0,1-.586-.4c-.024-.077-.041-.134-.053-.165v.106a.605.605,0,0,1-.61.555.6.6,0,0,1-.6-.58l-.18-.231-.058.228a.4.4,0,0,1,.058.23.61.61,0,0,1-1.065.305l-.12-.146.042.165a.373.373,0,0,1-.269.41.9.9,0,0,1-.5-.209,3.078,3.078,0,0,1-.431-.4l.019.2a1.879,1.879,0,0,0,.466.468.91.91,0,0,0,.43.137.483.483,0,0,0,.4-.314.86.86,0,0,0,1.167-.348.929.929,0,0,0,1.286-.033,5.709,5.709,0,0,1,2.585-.009.9.9,0,0,0,1.282.036.886.886,0,0,0,1.185.338.569.569,0,0,0,.37.329h.06a.994.994,0,0,0,.431-.137,1.719,1.719,0,0,0,.461-.485l-.017-.177a1.567,1.567,0,0,1-.4.389.86.86,0,0,1-.479.209.372.372,0,0,1-.3-.41v-.18l-.072.161a.589.589,0,0,1-.48.245.573.573,0,0,1-.586-.55.528.528,0,0,1,.06-.25l-.1-.213-.138.173.143-.2.144.24a.474.474,0,0,0-.06.25.564.564,0,0,0,.982.276l.12-.149.046.2c0,.2.083.333.228.358a.829.829,0,0,0,.466-.2,2.961,2.961,0,0,0,.42-.393l.06.228a1.567,1.567,0,0,1-.48.518.983.983,0,0,1-.454.141",
    transform: "translate(-444.147 9.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6484",
    "data-name": "Caminho 6484",
    d: "M474.266,14.452c.029-.1,0-.2-.065-.216s-.163.036-.2.135a.161.161,0,0,0,.072.218c.072.022.161-.041.192-.137",
    transform: "translate(-440.459 10.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6485",
    "data-name": "Caminho 6485",
    d: "M474.11,14.629h-.036c-.1-.122-.113-.192-.084-.254a.21.21,0,0,1,.185-.159l.108.069a.224.224,0,0,1,.007.189.208.208,0,0,1-.18.156",
    transform: "translate(-440.467 10.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6486",
    "data-name": "Caminho 6486",
    d: "M472.774,14.156c.012-.1-.036-.189-.108-.2s-.144.069-.161.168.041.2.108.2.149-.067.161-.171",
    transform: "translate(-441.519 9.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6487",
    "data-name": "Caminho 6487",
    d: "M472.629,14.359h0c-.084-.009-.139-.113-.132-.228s.089-.19.168-.19a.184.184,0,0,1,.149.226.193.193,0,0,1-.18.192",
    transform: "translate(-441.528 9.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6488",
    "data-name": "Caminho 6488",
    d: "M470.939,14.156c-.012-.1.036-.189.108-.2s.156.069.161.168-.036.2-.108.2-.144-.067-.161-.171",
    transform: "translate(-442.639 9.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6489",
    "data-name": "Caminho 6489",
    d: "M471.1,14.359a.221.221,0,0,1-.043-.418.2.2,0,0,1,.187.19.185.185,0,0,1-.132.228Z",
    transform: "translate(-442.649 9.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6490",
    "data-name": "Caminho 6490",
    d: "M469.46,14.452c-.036-.1,0-.2.072-.216s.149.036.185.135,0,.194-.072.218-.154-.041-.185-.137",
    transform: "translate(-443.705 10.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6491",
    "data-name": "Caminho 6491",
    d: "M470.254,13.368a.629.629,0,0,1,.269.358.2.2,0,0,1,.089-.065.282.282,0,0,1,.127-.041s-.019.117-.031.158a1.609,1.609,0,0,1-.035.273.757.757,0,0,1-.079.209.24.24,0,0,0-.186-.057.229.229,0,0,0-.156.111.832.832,0,0,1-.144-.163c-.065-.1-.113-.214-.137-.249s-.09-.137-.09-.137a.252.252,0,0,1,.143,0,.182.182,0,0,1,.1.036.61.61,0,0,1,.132-.43",
    transform: "translate(-443.391 9.552)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6492",
    "data-name": "Caminho 6492",
    d: "M470.264,14.355l-.017-.017a1.148,1.148,0,0,1-.151-.17,1.631,1.631,0,0,1-.094-.183l-.132-.2.166-.041.115.045a.452.452,0,0,1,.089-.429.57.57,0,0,1,.317.372c.12-.127.173-.127.192-.127.029.024,0,.144-.007.187-.012.129-.024.2-.029.274a1.2,1.2,0,0,1-.084.213.519.519,0,0,0-.173-.041.2.2,0,0,0-.173.1Zm-.293-.595-.065.036.1.1c.065.118.094.189.13.247s.1.111.12.141a.3.3,0,0,1,.168-.094.249.249,0,0,1,.186.048,1.8,1.8,0,0,1,.053-.183,1.142,1.142,0,0,0,.031-.2l.029-.213c0,.009-.041.017-.082.045l-.031.051-.1,0a.594.594,0,0,0-.262-.351.83.83,0,0,0-.091.408l.012.029Z",
    transform: "translate(-443.401 9.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6493",
    "data-name": "Caminho 6493",
    d: "M470.532,14.236a.215.215,0,0,1-.085-.122.191.191,0,0,1,.031-.154s-.115-.046-.221-.077a1.182,1.182,0,0,0-.288-.029h-.132a.436.436,0,0,0,.036.072.5.5,0,0,0,.067.082.559.559,0,0,0-.367.249.6.6,0,0,0,.426.115.661.661,0,0,0-.029.1v.072a.977.977,0,0,1,.125-.045,1.813,1.813,0,0,0,.252-.111,1.73,1.73,0,0,0,.187-.156",
    transform: "translate(-443.614 9.9)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6494",
    "data-name": "Caminho 6494",
    d: "M469.952,14.593v-.036l.012-.075a3.137,3.137,0,0,1-.4-.2A.548.548,0,0,1,469.92,14l.026.041a.553.553,0,0,0-.348.243,1.1,1.1,0,0,0,.354.077h.023l.029.129-.017.041.1-.041a.971.971,0,0,0,.252-.111,1.006,1.006,0,0,0,.173-.146c-.041,0-.072-.055-.084-.1a.2.2,0,0,1,.024-.156.977.977,0,0,1-.2-.06,1.913,1.913,0,0,0-.281-.017l-.132-.055h.132a1.458,1.458,0,0,1,.293.024,2.221,2.221,0,0,1,.228.089.34.34,0,0,0-.024.163.191.191,0,0,0,.084.117c0,.036-.091.12-.187.189a1.612,1.612,0,0,1-.262.113Z",
    transform: "translate(-443.621 9.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6495",
    "data-name": "Caminho 6495",
    d: "M470.352,14.29a.2.2,0,0,0,.024-.144.219.219,0,0,0-.077-.134,1.126,1.126,0,0,1,.173-.144,1.272,1.272,0,0,1,.25-.117c.049-.015.132-.048.132-.048s0,.024,0,.072-.024.1-.024.1a.661.661,0,0,1,.431.12.623.623,0,0,1-.365.245.4.4,0,0,1,.06.093l.036.069s-.1-.005-.137-.005a1.287,1.287,0,0,1-.281-.024,1.516,1.516,0,0,1-.216-.084",
    transform: "translate(-443.095 9.793)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6496",
    "data-name": "Caminho 6496",
    d: "M471,14.423h-.139a1.949,1.949,0,0,1-.293-.017c-.1-.033-.214-.089-.226-.089a.287.287,0,0,0,.024-.163.178.178,0,0,0-.079-.113c0-.041.091-.12.187-.192a1.548,1.548,0,0,1,.262-.113l.125-.045-.017.125,0-.039h-.091c-.041.022-.18.07-.25.115a1.365,1.365,0,0,0-.168.149c.041,0,.072.045.089.1a.232.232,0,0,1-.029.153.962.962,0,0,1,.192.06,1.208,1.208,0,0,0,.279.024l.127.029H471l-.024-.026H471l-.012.026Zm-.036-.053-.06-.137a.587.587,0,0,0,.341-.243,1.022,1.022,0,0,0-.354-.084l-.031.007-.005-.048a.725.725,0,0,1,.431.123.579.579,0,0,1-.382.286Z",
    transform: "translate(-443.105 9.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6497",
    "data-name": "Caminho 6497",
    d: "M470.065,14.085a.262.262,0,0,1,.264-.249.254.254,0,0,1,.25.249.246.246,0,0,1-.25.242.254.254,0,0,1-.264-.242",
    transform: "translate(-443.262 9.887)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6498",
    "data-name": "Caminho 6498",
    d: "M470.338,14.339a.28.28,0,0,1-.286-.266c0-.3.563-.3.563,0a.275.275,0,0,1-.276.266m0-.487a.233.233,0,0,0-.24.221c0,.242.473.242.473,0a.231.231,0,0,0-.233-.221",
    transform: "translate(-443.271 9.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6499",
    "data-name": "Caminho 6499",
    d: "M472,13.14a.745.745,0,0,1,.233.453.2.2,0,0,1,.1-.06.34.34,0,0,1,.156-.019,1.555,1.555,0,0,1-.065.171,2.324,2.324,0,0,1-.1.295,1.262,1.262,0,0,1-.119.214.266.266,0,0,0-.2-.091.285.285,0,0,0-.2.091.916.916,0,0,1-.132-.214c-.041-.115-.067-.257-.091-.295a1.747,1.747,0,0,0-.065-.171.289.289,0,0,1,.144.019.251.251,0,0,1,.113.06A.71.71,0,0,1,472,13.14",
    transform: "translate(-442.227 9.39)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6500",
    "data-name": "Caminho 6500",
    d: "M472.215,14.239l-.019-.022a.25.25,0,0,0-.365,0,.457.457,0,0,1-.167-.221c-.024-.069-.05-.149-.067-.213l-.1-.254h.06l.058.149a2.527,2.527,0,0,0,.091.3,1.076,1.076,0,0,0,.125.2c.036-.117.269-.125.377-.021a.717.717,0,0,0,.108-.183c.029-.074.053-.154.077-.214.036-.1.072-.207.084-.24l.048,0a1.544,1.544,0,0,1-.065.168,2.105,2.105,0,0,1-.1.3.74.74,0,0,1-.125.213Zm.113-.629-.108-.009a.7.7,0,0,0-.228-.441.885.885,0,0,0-.186.441l-.238-.072.1.009.012-.024a.334.334,0,0,1,.125.069.533.533,0,0,1,.186-.451.611.611,0,0,1,.271.425.2.2,0,0,1,.082-.043l.1.009Z",
    transform: "translate(-442.239 9.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6501",
    "data-name": "Caminho 6501",
    d: "M472.133,14.168a.262.262,0,0,1-.065-.161.208.208,0,0,1,.065-.153,1.5,1.5,0,0,0-.228-.137,1.929,1.929,0,0,0-.311-.082c-.048-.005-.151-.021-.151-.021a.218.218,0,0,0,.026.075,1.032,1.032,0,0,1,.041.11.727.727,0,0,0-.454.207.717.717,0,0,0,.454.214.822.822,0,0,1-.041.108.219.219,0,0,0-.026.079s.1-.022.151-.027a2.089,2.089,0,0,0,.311-.081,1.264,1.264,0,0,0,.228-.132",
    transform: "translate(-442.553 9.728)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6502",
    "data-name": "Caminho 6502",
    d: "M471.42,14.45l.029-.12c-.1-.089-.274-.17-.4-.3a.642.642,0,0,1,.454-.245l.012.043a.707.707,0,0,0-.437.2.886.886,0,0,0,.437.175l.041,0-.1.18.132-.024a1.656,1.656,0,0,0,.305-.075,2,2,0,0,0,.228-.13c-.053-.019-.072-.079-.072-.144a.254.254,0,0,1,.06-.165,1.524,1.524,0,0,1-.216-.1,1.66,1.66,0,0,0-.286-.072l-.163-.075.163.027a2.159,2.159,0,0,1,.305.077,1.415,1.415,0,0,1,.233.135.389.389,0,0,0-.048.177.241.241,0,0,0,.053.144.481.481,0,0,1-.238.17,1.274,1.274,0,0,1-.293.079Z",
    transform: "translate(-442.558 9.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6503",
    "data-name": "Caminho 6503",
    d: "M471.912,14.168a.228.228,0,0,0,.065-.161.184.184,0,0,0-.065-.153,1.528,1.528,0,0,1,.228-.137,1.734,1.734,0,0,1,.305-.082c.06-.005.155-.021.155-.021s-.005.021-.022.075a.663.663,0,0,1-.048.11.733.733,0,0,1,.455.207.723.723,0,0,1-.455.214.79.79,0,0,1,.048.108c.017.055.022.079.022.079a1.4,1.4,0,0,0-.155-.027,1.868,1.868,0,0,1-.305-.081,1.286,1.286,0,0,1-.228-.132",
    transform: "translate(-441.942 9.728)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6504",
    "data-name": "Caminho 6504",
    d: "M472.6,14.447l-.149-.036a1.266,1.266,0,0,1-.312-.081.87.87,0,0,1-.233-.135.425.425,0,0,0,.06-.178.224.224,0,0,0-.06-.144c.007-.036.108-.113.233-.168a2.507,2.507,0,0,1,.288-.077l.173-.027a.793.793,0,0,1-.041.221.545.545,0,0,1,.454.183.709.709,0,0,1-.479.25v-.048a.746.746,0,0,0,.443-.2.9.9,0,0,0-.443-.175H472.5l.06-.137-.108-.021a1.649,1.649,0,0,0-.305.075,1.478,1.478,0,0,0-.221.134c.053.012.072.075.072.135a.252.252,0,0,1-.06.166h0c.024,0,.108.063.2.108a1.551,1.551,0,0,0,.288.069l.154.057h.012l-.012-.026.012,0-.012.022Z",
    transform: "translate(-441.947 9.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6505",
    "data-name": "Caminho 6505",
    d: "M473.714,13.368a.673.673,0,0,0-.288.358s-.012-.033-.082-.065a.249.249,0,0,0-.127-.041s.024.117.031.158.017.165.036.273a1.788,1.788,0,0,0,.077.209.227.227,0,0,1,.185-.057.265.265,0,0,1,.168.111,1.279,1.279,0,0,0,.137-.163,2.008,2.008,0,0,0,.132-.249c.029-.038.089-.137.089-.137a.235.235,0,0,0-.137,0,.254.254,0,0,0-.108.036.625.625,0,0,0-.113-.43",
    transform: "translate(-441.009 9.552)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6506",
    "data-name": "Caminho 6506",
    d: "M473.716,14.36l-.017-.024a.187.187,0,0,0-.145-.1.26.26,0,0,0-.168.045c-.036-.009-.089-.1-.113-.214a1.379,1.379,0,0,1-.031-.2l-.036-.238a.153.153,0,0,1,.161.015l.091.081a.478.478,0,0,1,.245-.375.58.58,0,0,1,.156.456l.077-.033-.084.045a1.06,1.06,0,0,0-.154-.432.741.741,0,0,0-.235.357l-.012.031-.106-.084c-.091-.045-.072.053-.067.093.019.137.019.2.036.273a1.264,1.264,0,0,0,.079.2c.012-.045.059-.069.125-.069a.31.31,0,0,1,.2.1,1.244,1.244,0,0,0,.113-.141,1.64,1.64,0,0,0,.1-.177l.072-.122.007.074a1.834,1.834,0,0,1-.139.249,1.3,1.3,0,0,1-.142.17Z",
    transform: "translate(-441.017 9.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6507",
    "data-name": "Caminho 6507",
    d: "M473.472,14.236a.223.223,0,0,0,.084-.122.311.311,0,0,0-.024-.154,1.38,1.38,0,0,1,.209-.077,1.142,1.142,0,0,1,.281-.029h.144a.565.565,0,0,1-.036.072c-.036.046-.06.082-.06.082a.636.636,0,0,1,.365.249.639.639,0,0,1-.437.115s.012.045.024.1a.6.6,0,0,1,.007.072s-.091-.036-.127-.045-.179-.067-.257-.111c-.089-.072-.173-.156-.173-.156",
    transform: "translate(-440.827 9.9)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6508",
    "data-name": "Caminho 6508",
    d: "M474.031,14.585l-.121-.051a1.966,1.966,0,0,1-.274-.113c-.084-.069-.175-.156-.175-.156a.676.676,0,0,0,.079-.149.174.174,0,0,0-.024-.132.491.491,0,0,1,.228-.12,1.449,1.449,0,0,1,.287-.024h.144L474.09,14a.677.677,0,0,1,.372.257.6.6,0,0,1-.4.153l-.029.129h.012Zm-.527-.329a.932.932,0,0,1,.161.122,1.258,1.258,0,0,0,.257.111l.108.041L474,14.46l.017-.1a.743.743,0,0,0,.407-.113.841.841,0,0,0-.352-.207l-.036-.005.077-.12-.083-.021a1.95,1.95,0,0,0-.274.017,1.609,1.609,0,0,0-.211.079.1.1,0,0,1,.031.137.164.164,0,0,1-.072.129",
    transform: "translate(-440.835 9.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6509",
    "data-name": "Caminho 6509",
    d: "M473.656,14.29a.257.257,0,0,1-.036-.144.238.238,0,0,1,.089-.134,1.8,1.8,0,0,0-.186-.144,1.1,1.1,0,0,0-.25-.117c-.048-.015-.132-.048-.132-.048a.33.33,0,0,0,.012.072.561.561,0,0,0,.017.1.627.627,0,0,0-.425.12.61.61,0,0,0,.365.245.459.459,0,0,0-.06.093.288.288,0,0,0-.036.069s.084-.005.139-.005a1.3,1.3,0,0,0,.281-.024,1.725,1.725,0,0,0,.221-.084",
    transform: "translate(-441.346 9.793)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6510",
    "data-name": "Caminho 6510",
    d: "M472.993,14.43l.041-.1a4.21,4.21,0,0,1-.3-.312.555.555,0,0,1,.39-.153l.017-.12.036.168a.7.7,0,0,0-.413.117.83.83,0,0,0,.353.2l.031.005-.1.147.115,0a1.051,1.051,0,0,0,.269-.024,1.229,1.229,0,0,0,.216-.081.12.12,0,0,1-.036-.132.207.207,0,0,1,.077-.132c-.024-.009-.089-.07-.168-.122a1.92,1.92,0,0,0-.25-.115l-.126-.041.019-.045.132.045a2.126,2.126,0,0,1,.251.113c.1.072.18.151.187.156a.539.539,0,0,0-.079.151.181.181,0,0,0,.029.13.511.511,0,0,1-.238.12,1.211,1.211,0,0,1-.281.019Z",
    transform: "translate(-441.353 9.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6511",
    "data-name": "Caminho 6511",
    d: "M473.235,14.085a.257.257,0,0,1,.515,0,.258.258,0,0,1-.515,0",
    transform: "translate(-440.997 9.887)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6512",
    "data-name": "Caminho 6512",
    d: "M473.494,14.339a.272.272,0,0,1-.269-.266c0-.3.556-.3.556,0a.273.273,0,0,1-.287.266m0-.487a.23.23,0,0,0-.228.221c0,.242.468.242.468,0a.23.23,0,0,0-.24-.221",
    transform: "translate(-441.004 9.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6513",
    "data-name": "Caminho 6513",
    d: "M475.071,14.319c-.053-.072-.18-.053-.281.024a.193.193,0,0,0-.053.264c.053.065.188.05.281-.033s.118-.2.053-.255",
    transform: "translate(-439.947 10.2)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6514",
    "data-name": "Caminho 6514",
    d: "M474.831,14.677l-.12-.045c-.024-.177.012-.245.067-.3a.314.314,0,0,1,.2-.072l.113.051c.036.173,0,.24-.053.29a.294.294,0,0,1-.2.075",
    transform: "translate(-439.947 10.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6515",
    "data-name": "Caminho 6515",
    d: "M475.058,14.754a.242.242,0,0,1,.077-.132c.1-.077.228-.1.281-.024.012,0,.019.015.024.024a.961.961,0,0,1,.288-.334.913.913,0,0,1,.413-.057.349.349,0,0,0-.353-.348.342.342,0,0,0-.288.135l-.036-.127a.367.367,0,0,0-.238.209.859.859,0,0,0,.012.461.793.793,0,0,0-.1-.19.763.763,0,0,0-.293-.2,1.051,1.051,0,0,1-.161-.094.577.577,0,0,0-.012.069v.1a.9.9,0,0,0-.449.055.57.57,0,0,0,.305.278l-.1.089a.269.269,0,0,1-.054.06s.108.012.163.024.214.027.317.027c.077-.012.161-.024.209-.027",
    transform: "translate(-440.294 9.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6516",
    "data-name": "Caminho 6516",
    d: "M474.816,14.8a1.582,1.582,0,0,1-.264-.026l-.173-.015.144-.192a.433.433,0,0,1-.317-.245.706.706,0,0,1,.371-.1l.083-.141c.042-.015.12.033.2.074a1.034,1.034,0,0,1,.305.2.446.446,0,0,0,.036.051.606.606,0,0,1,.019-.305.41.41,0,0,1,.25-.233l.06.149a.271.271,0,0,1,.27-.149.369.369,0,0,1,.384.367,1.361,1.361,0,0,0-.437.082,1,1,0,0,0-.269.319l-.145-.057a.254.254,0,0,0-.168.067.206.206,0,0,0-.072.117.9.9,0,0,1-.233.038Zm-.209-.526a1.017,1.017,0,0,0-.377.055.848.848,0,0,0,.317.233l-.1.125.089.041a2.219,2.219,0,0,0,.276.031v.027l.036-.027a.949.949,0,0,0,.2-.031.208.208,0,0,1,.079-.122.58.58,0,0,1,.1-.057c-.036-.027-.061-.1-.108-.159a.735.735,0,0,0-.293-.194c-.077-.043-.161-.1-.161-.1l0,.173Zm.724.261.113.051a.844.844,0,0,1,.281-.305.751.751,0,0,1,.353-.072c.084-.245-.394-.374-.562-.171l-.065-.134c0,.024-.12.06-.18.214a.677.677,0,0,0,0,.425.121.121,0,0,1,.06-.009",
    transform: "translate(-440.303 9.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6517",
    "data-name": "Caminho 6517",
    d: "M469.353,14.754a.264.264,0,0,0-.09-.132.2.2,0,0,0-.276-.024c-.012,0-.017.015-.029.024a.855.855,0,0,0-.281-.334.935.935,0,0,0-.42-.057.351.351,0,0,1,.36-.348.4.4,0,0,1,.305.135l.017-.127a.357.357,0,0,1,.24.209.855.855,0,0,1-.012.461,1.126,1.126,0,0,1,.1-.19.938.938,0,0,1,.293-.2c.084-.041.173-.094.173-.094v.069a.4.4,0,0,1,0,.1.936.936,0,0,1,.456.055.558.558,0,0,1-.312.278.684.684,0,0,1,.1.089.439.439,0,0,1,.053.06s-.094.012-.149.024-.221.027-.317.027c-.072-.012-.156-.024-.209-.027",
    transform: "translate(-444.554 9.92)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6518",
    "data-name": "Caminho 6518",
    d: "M469.578,14.8h-.036a1.552,1.552,0,0,1-.214-.026.471.471,0,0,0-.1-.13.245.245,0,0,0-.156-.065l-.024.039-.132.017a.908.908,0,0,0-.274-.319.743.743,0,0,0-.329-.06.039.039,0,0,1-.007-.027.565.565,0,0,1,.36.051.977.977,0,0,1,.3.338c.017-.1.108-.1.192-.069V14.5a1.115,1.115,0,0,0-.024-.389.334.334,0,0,0-.221-.2v.11c-.235-.153-.545-.117-.629.087.012-.266.461-.305.629-.1l-.012-.123c.029-.017.2.024.281.216a1.038,1.038,0,0,1,.029.3c0-.015.007-.022.019-.043a1,1,0,0,1,.311-.2c.072-.041.156-.093.156-.093V14.1a.46.46,0,0,1-.144.1.855.855,0,0,0-.286.194.514.514,0,0,0-.084.171.229.229,0,0,1,.077.045.333.333,0,0,1,.1.141,1.216,1.216,0,0,1,.186.012l.036.027v-.027c.091,0,.2-.021.264-.024l.072-.012-.048.051a2.141,2.141,0,0,1-.288.026m.377-.125-.113-.072a.84.84,0,0,0,.311-.31c-.089,0-.214-.024-.322-.024l-.043.005-.1-.024.017-.069.012.048a1.133,1.133,0,0,1,.461.06.5.5,0,0,1-.305.317l.1.05Z",
    transform: "translate(-444.534 9.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6519",
    "data-name": "Caminho 6519",
    d: "M468.7,14.319a.2.2,0,0,1,.274.024c.1.077.127.2.06.264a.212.212,0,0,1-.281-.033.192.192,0,0,1-.053-.255",
    transform: "translate(-444.262 10.2)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6520",
    "data-name": "Caminho 6520",
    d: "M468.944,14.692a.289.289,0,0,1-.2-.075.245.245,0,0,1-.1-.185c.156-.314.246-.168.347-.084a.3.3,0,0,1,.1.187c-.066.142-.114.158-.156.158",
    transform: "translate(-444.272 10.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6521",
    "data-name": "Caminho 6521",
    d: "M471.647,13.944a.251.251,0,0,1,.264-.242.246.246,0,1,1-.264.242",
    transform: "translate(-442.131 9.791)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6522",
    "data-name": "Caminho 6522",
    d: "M471.917,14.2a.273.273,0,0,1-.281-.267c0-.293.555-.293.555,0a.271.271,0,0,1-.274.267m0-.485a.224.224,0,0,0-.233.218c0,.243.473.245.473,0a.23.23,0,0,0-.24-.218",
    transform: "translate(-442.139 9.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6523",
    "data-name": "Caminho 6523",
    d: "M471.486,11.881a.527.527,0,0,1,1.052,0,.527.527,0,0,1-1.052,0",
    transform: "translate(-442.247 8.137)",
    fill: "#3057bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6524",
    "data-name": "Caminho 6524",
    d: "M472.02,12.408a.518.518,0,1,1,.545-.518.53.53,0,0,1-.545.518m0-1a.5.5,0,0,0-.509.485.51.51,0,0,0,1.019,0,.5.5,0,0,0-.51-.485",
    transform: "translate(-442.255 8.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6525",
    "data-name": "Caminho 6525",
    d: "M471.875,10.86v.266h-.288V11.4h.288v.79H471.5c0,.024-.019.038-.019.065a.383.383,0,0,0,.041.2h.97a.426.426,0,0,0,.048-.2c0-.027-.029-.041-.036-.065h-.348V11.4h.288v-.276h-.288V10.86Z",
    transform: "translate(-442.247 7.76)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6526",
    "data-name": "Caminho 6526",
    d: "M472.5,12.482h-.964a.378.378,0,0,1-.065-.216l.036-.009a.457.457,0,0,0,.035.2l.952-.012a.509.509,0,0,0,.031-.18l-.36-.053-.018-.8.306-.015-.013-.259-.275.017-.018-.285-.269.009.012.259-.3.017.012.257.276-.015.012.806-.108,0,.1-.021-.019-.773-.269.015-.012-.29.3-.019-.019-.249.306-.021.012.288.276-.019.017.293-.3.015.012.775.336-.017c.048.154.036.226,0,.286Z",
    transform: "translate(-442.254 7.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6527",
    "data-name": "Caminho 6527",
    d: "M474.327,27.114a10.192,10.192,0,0,1-4.412-1.017,2.84,2.84,0,0,1-1.591-2.529V19.6h11.969v3.969a2.844,2.844,0,0,1-1.586,2.529,10.093,10.093,0,0,1-4.38,1.017",
    transform: "translate(-444.506 14.005)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6528",
    "data-name": "Caminho 6528",
    d: "M474.339,27.152a10.329,10.329,0,0,1-4.418-1.013,2.854,2.854,0,0,1-1.615-2.56V19.611l12-.027.029,3.995a2.849,2.849,0,0,1-1.61,2.56,10.08,10.08,0,0,1-4.386,1.013m5.931-7.54-11.935.031.043,3.937a2.781,2.781,0,0,0,1.567,2.5,10.2,10.2,0,0,0,8.756,0,2.767,2.767,0,0,0,1.569-2.5Z",
    transform: "translate(-444.519 13.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_450",
    "data-name": "Ret\\xE2ngulo 450",
    width: 6.003,
    height: 6.644,
    transform: "translate(29.785 26.954)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6529",
    "data-name": "Caminho 6529",
    d: "M477.846,22.4h-6.032l-.024-6.671,6.026-.027Zm-.065-6.671-5.966.033.036,6.611,5.931-.027Z",
    transform: "translate(-442.029 11.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6530",
    "data-name": "Caminho 6530",
    d: "M474.306,23.567a3,3,0,0,1-5.985,0V19.593h5.985Z",
    transform: "translate(-444.509 14)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6531",
    "data-name": "Caminho 6531",
    d: "M469.081,25.967a3.224,3.224,0,0,0,.724.333l-.012-6.788h-.711Z",
    transform: "translate(-443.965 13.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6532",
    "data-name": "Caminho 6532",
    d: "M469.845,26.352l-.036-.012a2.273,2.273,0,0,1-.6-.269l-.125-.065-.012-6.483.736-.027Zm-.084-6.829-.67.027.036,6.428.108.041a2.192,2.192,0,0,0,.55.249Z",
    transform: "translate(-443.975 13.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6533",
    "data-name": "Caminho 6533",
    d: "M468.316,23.557A3,3,0,0,0,469,25.424V19.531h-.677Z",
    transform: "translate(-444.512 13.956)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6534",
    "data-name": "Caminho 6534",
    d: "M469.011,25.47c-.012,0-.017-.007-.017-.015a2.951,2.951,0,0,1-.694-1.879l.007-4.031.7-.033.031,5.925a.028.028,0,0,1-.024.029Zm-.029-5.925-.646.033.023,3.993a3.044,3.044,0,0,0,.623,1.787Z",
    transform: "translate(-444.524 13.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6535",
    "data-name": "Caminho 6535",
    d: "M469.863,26.447a3.074,3.074,0,0,0,.7,0V19.513h-.7Z",
    transform: "translate(-443.406 13.943)",
    fill: "#c0b420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6536",
    "data-name": "Caminho 6536",
    d: "M470.225,26.512c-.108,0-.221-.01-.354-.022l-.029-6.966.736-.027.024,6.961a1.168,1.168,0,0,1-.377.055m.317-6.988-.666.027.031,6.906a2.145,2.145,0,0,1,.317-.012,3.229,3.229,0,0,0,.348-.017Z",
    transform: "translate(-443.421 13.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6537",
    "data-name": "Caminho 6537",
    d: "M470.631,26.3a2.272,2.272,0,0,0,.707-.314V19.512h-.694Z",
    transform: "translate(-442.857 13.942)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6538",
    "data-name": "Caminho 6538",
    d: "M470.61,26.349l.018-6.826.725-.027.042,6.5a2.115,2.115,0,0,1-.748.345Zm.724-6.826-.675.027.012,6.721a2.1,2.1,0,0,0,.67-.3Z",
    transform: "translate(-442.872 13.931)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_451",
    "data-name": "Ret\\xE2ngulo 451",
    width: 5.985,
    height: 6.644,
    transform: "translate(23.811 26.954)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6539",
    "data-name": "Caminho 6539",
    d: "M474.341,22.4h-6.009l-.029-6.671,6.015-.027Zm-.06-6.671-5.95.033.036,6.611,5.914-.027Z",
    transform: "translate(-444.521 11.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6540",
    "data-name": "Caminho 6540",
    d: "M471.44,25.375a2.689,2.689,0,0,0,.658-1.517l.017-4.345h-.7Z",
    transform: "translate(-442.296 13.943)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6541",
    "data-name": "Caminho 6541",
    d: "M471.411,25.454l-.012-5.931.73-.027.017,4.372a2.736,2.736,0,0,1-.675,1.541Zm.694-5.931-.676.027.053,5.763a2.845,2.845,0,0,0,.6-1.457Z",
    transform: "translate(-442.309 13.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6542",
    "data-name": "Caminho 6542",
    d: "M471.332,26.452a2.956,2.956,0,0,1-3.03-2.874V19.6l6.016-.027.029,4a2.953,2.953,0,0,1-3.016,2.874m2.956-6.848-5.956.033.038,3.942a2.963,2.963,0,0,0,5.918,0Z",
    transform: "translate(-444.522 13.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6543",
    "data-name": "Caminho 6543",
    d: "M477.813,19.593v3.974a3.006,3.006,0,0,1-6,0V19.593Z",
    transform: "translate(-442.014 14)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6544",
    "data-name": "Caminho 6544",
    d: "M474.822,26.452a2.957,2.957,0,0,1-3.029-2.874V19.6l6.034-.027.029,4a2.962,2.962,0,0,1-3.033,2.874m2.968-6.848-5.967.033.029,3.942a2.973,2.973,0,0,0,5.938,0Z",
    transform: "translate(-442.027 13.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6545",
    "data-name": "Caminho 6545",
    d: "M472.633,21.345a.111.111,0,0,1,.017.058.14.14,0,0,1-.144.134.134.134,0,0,1-.132-.134.094.094,0,0,1,.019-.055l-.2,0a.215.215,0,0,0-.005.058.311.311,0,0,0,.228.295v.48l.209,0V21.7a.3.3,0,0,0,.19-.194h.557v-.159Zm2.692,0V21.5l-.49,0c-.012.021-.024.038-.036.06l.576.646-.156.13-.569-.655a.05.05,0,0,1-.029.009v1.078h-.2V21.7c-.007,0-.012-.009-.024-.012l-.586.658-.161-.13.591-.657c0-.014-.017-.033-.024-.053h-.5v-.159Zm.331,0V21.5h.543a.336.336,0,0,0,.2.194v.482l.2,0V21.7a.3.3,0,0,0,.226-.295v-.058h-.2a.113.113,0,0,1,.011.058.132.132,0,0,1-.13.134.135.135,0,0,1-.139-.134.094.094,0,0,1,.019-.055Zm-.833,2.745a2.058,2.058,0,0,0,.456-.132l.1.171a2.291,2.291,0,0,1-.54.153.3.3,0,0,1-.311.242.317.317,0,0,1-.317-.24,2.365,2.365,0,0,1-.569-.154l.1-.171a2.068,2.068,0,0,0,.491.132.315.315,0,0,1,.185-.168v-.835h.2v.832a.314.314,0,0,1,.2.171m-1.365-.281-.1.17a1.814,1.814,0,0,1-.455-.386.33.33,0,0,1-.312-.053.323.323,0,0,1-.036-.441l.019-.015a1.772,1.772,0,0,1-.156-.595h.2a1.514,1.514,0,0,0,.137.513.368.368,0,0,1,.161.014l.521-.559.149.123-.5.562a.292.292,0,0,1-.012.338,1.453,1.453,0,0,0,.382.329m-.752-.595a.138.138,0,0,1,.19-.012.133.133,0,0,1,.019.19.167.167,0,0,1-.2.012.132.132,0,0,1,0-.19m-.259-.552-.222-.048-.024-.532.211-.069v.3a1.621,1.621,0,0,0,.035.346m.175-.66.2.05s.012.341.012.264c-.012-.093.012.264.012.264l-.2.07a1.574,1.574,0,0,1-.023-.334Zm.682,1.7a2.078,2.078,0,0,0,.6.321l.048-.2a1.694,1.694,0,0,1-.492-.254Zm-.1.177a2.156,2.156,0,0,0,.6.317l-.161.141a2.231,2.231,0,0,1-.485-.249Zm.274-1.169.192.081.366-.4-.113-.18Zm-.154-.125L473.2,22.4l.36-.4.209.081Zm2.237,1.229.1.17a1.943,1.943,0,0,0,.455-.386.312.312,0,0,0,.346-.494l-.017-.015a1.957,1.957,0,0,0,.149-.595h-.2a1.749,1.749,0,0,1-.137.513.432.432,0,0,0-.175.014l-.508-.559-.151.123.5.562a.274.274,0,0,0,.012.338,1.571,1.571,0,0,1-.384.329m.755-.595a.141.141,0,0,0-.192-.012.127.127,0,0,0-.017.19.157.157,0,0,0,.2.012.134.134,0,0,0,.012-.19m.257-.552.209-.048.031-.532-.209-.069v.3a1.621,1.621,0,0,1-.031.346M476.4,22l-.215.05v.264a2.565,2.565,0,0,0-.024.264l.216.07a2.139,2.139,0,0,0,.023-.334Zm-.682,1.7a2.073,2.073,0,0,1-.605.321l-.041-.2a1.747,1.747,0,0,0,.49-.254Zm.1.177a2.279,2.279,0,0,1-.6.317l.156.141a1.874,1.874,0,0,0,.479-.249Zm-.276-1.169-.2.081-.358-.4.113-.18Zm.156-.125.125-.175-.365-.4-.2.081Zm-2.49-1.072.053.2h.563l.06-.2Zm2.615,0-.053.2H475.2l-.053-.2Zm-1.437,2.711a.14.14,0,0,1,.139-.135.135.135,0,0,1,.137.135.142.142,0,0,1-.137.135.148.148,0,0,1-.139-.135m.235-.964.214-.057v-.537l-.214-.057Zm-.2,0-.209-.057v-.537l.209-.057Z",
    transform: "translate(-441.748 15.252)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6546",
    "data-name": "Caminho 6546",
    d: "M472.187,22.368a.32.32,0,0,1,.228-.233l-.007-.655h.2v.658a.3.3,0,0,1,.214.2h.545v.029h-.737a.153.153,0,0,0-.125-.074.127.127,0,0,0-.113.074Zm1.521,0v-.029h.5c0-.019.012-.031.024-.048l-.627-.694.154-.125.622.682c.007-.007.019-.01.024-.015l.007-.91h.2v.907l.031,0,.61-.682.143.12-.6.688a.788.788,0,0,1,.036.075h.49v.029Zm2.682,0a.147.147,0,0,1,.12-.074.128.128,0,0,1,.118.074h.2a.318.318,0,0,0-.226-.233V21.48h-.2v.658a.3.3,0,0,0-.2.2h-.543v.029Zm-3.748-1.852.754.844.156-.125-.76-.838c.017-.029.029-.048.042-.072h.545v-.194h-.545a.33.33,0,0,0-.311-.216.318.318,0,0,0-.329.309.3.3,0,0,0,.221.293l-.007.652h.2v-.646a.082.082,0,0,1,.035-.005m3.969,0,0,.652h-.2v-.652a.269.269,0,0,1-.043-.015l-.748.844-.144-.129.749-.856a.1.1,0,0,1-.012-.036h-.557v-.194h.55a.337.337,0,0,1,.312-.216.313.313,0,0,1,.322.309.293.293,0,0,1-.221.293m-2,0v.4h-.2v-.4a.323.323,0,0,1-.216-.2h-.491v-.194h.491a.32.32,0,0,1,.312-.216.329.329,0,0,1,.31.216h.5v.194h-.5a.334.334,0,0,1-.209.192m-2.2.487-.216.058V21.6l.216.051Zm.2,0,.2.058V21.6l-.2.051Zm3.782,0-.216.058V21.6l.216.051Zm.2,0,.209.058V21.6l-.209.051Zm-3.167.1.2-.081.365.406-.12.171Zm-.161.125-.108.177.358.408.2-.091Zm2.292-.137-.2-.084-.359.406.12.171Zm.154.125.12.175-.358.4-.2-.079Zm-2.519,1.123.053-.2h.563l.06.2Zm-.827-2.116a.142.142,0,0,1,.144-.132.134.134,0,0,1,.13.132.136.136,0,0,1-.13.137.144.144,0,0,1-.144-.137m1.5.1-.06.2h-.567l-.055-.2Zm0-.194-.06-.2h-.567l-.055.2Zm1.939,2.208-.054-.2H475.2l-.053.2Zm.55-2.116a.137.137,0,0,1,.139-.132.14.14,0,0,1,.137.132.142.142,0,0,1-.137.137.139.139,0,0,1-.139-.137m-2,0a.138.138,0,0,1,.276,0,.138.138,0,0,1-.276,0m.778.1.06.2h.562l.06-.2Zm0-.194.06-.2h.562l.06.2Zm-.736.619-.209.06v.535l.209.058Zm.2,0,.209.06v.535l-.209.058Z",
    transform: "translate(-441.746 14.23)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6547",
    "data-name": "Caminho 6547",
    d: "M474.532,25.554a.356.356,0,0,1-.341-.257,1.549,1.549,0,0,1-.382-.079l-.012-.005-.137.156-.006,0a2.48,2.48,0,0,1-.5-.257l.036-.216a2.516,2.516,0,0,1-.227-.2,2.073,2.073,0,0,1,.257.185,1.153,1.153,0,0,0,.137.1l.089-.151a.885.885,0,0,1-.142-.1,1.785,1.785,0,0,1-.24-.216.316.316,0,0,0,.018-.345l.5-.586-.149-.1-.491.566a.612.612,0,0,0-.139-.015c-.005-.007-.005-.019-.017-.031a.31.31,0,0,1,.156.019l.491-.566.173.125-.5.59a.266.266,0,0,1-.007.338c.072.067.144.135.228.2l.132-.141a2.081,2.081,0,0,0,.509.252l-.031.2a1.826,1.826,0,0,0,.305.063.281.281,0,0,1,.18-.165l-.007-.82.216-.019.012.85a.28.28,0,0,1,.2.165,2.3,2.3,0,0,0,.437-.144l.119.18a1.862,1.862,0,0,1-.543.18.314.314,0,0,1-.324.242m-.784-.393c.024.01.048.015.072.024a1.84,1.84,0,0,0,.395.093c.091.295.563.288.617.01a2.692,2.692,0,0,0,.551-.163l-.108-.153a1.2,1.2,0,0,1-.442.144.335.335,0,0,0-.209-.166l-.007-.85-.192.017.019.818a.35.35,0,0,0-.2.173,1.331,1.331,0,0,1-.317-.06l-.019,0c-.054-.017-.114-.038-.168-.06l-.065.147c.024.009.048.021.072.029m-.55-.262-.019.2a2.828,2.828,0,0,0,.474.233l.137-.12-.065-.029a.463.463,0,0,1-.077-.027c-.1-.045-.187-.093-.276-.144L473.359,25c-.053-.031-.108-.069-.161-.1m.281-.087a1.8,1.8,0,0,0,.281.141c.041.021.1.039.137.06l.048-.182a1.406,1.406,0,0,1-.491-.24l-.12.125c.043.027.089.06.144.1m-.677-.189a.3.3,0,0,1-.209-.062.291.291,0,0,1-.121-.223.366.366,0,0,1,.084-.238,3.1,3.1,0,0,1-.12-.417l-.2-.045-.036-.545.215-.084-.012-.3a.3.3,0,0,1-.227-.3.329.329,0,0,1,.238-.309l-.012-.638.215-.017.024.677a.273.273,0,0,1,.2.194l.534-.012.017.206-.574.015a.255.255,0,0,1-.192.189l.012.3.2.033.029.542-.2.084a1.523,1.523,0,0,0,.089.29.632.632,0,0,1-.12-.281v-.021a1.038,1.038,0,0,1-.029-.159l-.168.012a.489.489,0,0,1,.012.087c.005.024.012.041.017.069a1.406,1.406,0,0,0,.121.42.368.368,0,0,0-.1.242.312.312,0,0,0,.115.2.33.33,0,0,0,.209.069c0,.009.012.012.023.017Zm-.389-1.579-.2.065.036.518.18.027a1.136,1.136,0,0,1-.019-.151l-.012-.314.012-.125Zm.228.165V23.5a1.052,1.052,0,0,1,.024.141l.192-.067-.036-.511-.18-.031Zm-.036-1.74-.185.012.017.641a.322.322,0,0,0-.233.293.307.307,0,0,0,.221.285l.012.391.175.079v-.458a.326.326,0,0,0,.2-.2l.57-.012-.019-.175-.526.012a.377.377,0,0,0-.216-.2ZM474.64,23.8h-.216l-.005-.5.029.482.168-.009V22.712l.029.036Zm.6-.434-.246-.276.246.249.132-.129-.569-.626.067-.012.526.645Zm-1.418-.007-.173-.118.149-.177-.132.17.156.1.575-.658v.045Zm.365-.8-.468-.027-.017-.2.161-.005-.144.017.012.177.492-.014Zm1.024-.036.125-.021-.012-.175-.479.012.048-.07.442.041.012.206Zm-1.019-.24-.586-.691.161-.146.247.266-.252-.243-.137.123.634.677Zm.473-.141v-.048l.581-.664.179.125-.125.144.108-.144-.161-.1Zm-.228-.012-.034-.039.01-.876.211-.015.005.351-.024-.336-.18.015Zm-1.029-.766-.449-.494.449.456.144-.117L472.8,20.4l.084-.015.688.83Zm-.987-.194-.019-.662a.3.3,0,0,1-.222-.293c0-.322.575-.4.67-.1l.54-.009.017.211h-.132l.115-.017-.012-.177-.534.012c-.132-.29-.629-.206-.629.081a.3.3,0,0,0,.209.279l.012.66.18-.015-.012-.631.036.039v.607Z",
    transform: "translate(-441.755 14.239)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6548",
    "data-name": "Caminho 6548",
    d: "M475.372,25.372l-.173-.156a3.239,3.239,0,0,0,.438-.228l-.084-.149a1.868,1.868,0,0,1-.425.209l-.024.009-.048-.221a2,2,0,0,0,.5-.266l.168.129a2.468,2.468,0,0,0,.214-.213.277.277,0,0,1-.012-.341l-.5-.538.149-.153.533.571a.193.193,0,0,1,.125-.029.751.751,0,0,0,.127-.317l-.192-.072.012-.538.216-.06v-.293a.286.286,0,0,1-.2-.189l-.533.009-.017-.2.563-.017a.283.283,0,0,1,.2-.2l-.006-.454-.209-.055-.012-.547.228-.075.012.492.19-.015.019.67a.307.307,0,0,1,.233.293.334.334,0,0,1-.246.312l.012.307.2.043-.018.55-.215.057a1.488,1.488,0,0,1-.127.417.32.32,0,0,1,.1.238.356.356,0,0,1-.121.221.365.365,0,0,1-.226.079,2.36,2.36,0,0,0-.389.261l-.007.005.06.187a1.859,1.859,0,0,1-.5.274Zm.365-.41a.4.4,0,0,1-.065.045,2.5,2.5,0,0,1-.449.213l.149.117a2.054,2.054,0,0,0,.479-.252l-.042-.168a.655.655,0,0,1-.072.046m-.186-.372a1.384,1.384,0,0,1-.473.257l.048.168a2.125,2.125,0,0,0,.581-.31Zm.018-1.109-.125.125.5.538a.322.322,0,0,0,.012.345,1.423,1.423,0,0,1-.389.35l.1.135c.048-.031.089-.06.137-.1a1.978,1.978,0,0,0,.293-.276c.185.007.257-.017.312-.062a.249.249,0,0,0,.106-.2.286.286,0,0,0-.072-.214c.043-.171.084-.315.108-.453a1.5,1.5,0,0,0,.023-.17l-.166.014v.033l-.024.12a1.305,1.305,0,0,1-.115.353.6.6,0,0,0-.173.024Zm1.054-.288v.137c0,.06-.007.12-.007.177a1.154,1.154,0,0,1-.024.151l.192-.045.019-.52-.18-.041Zm-.425-.688a.379.379,0,0,0,.216.2l0,.478.168-.005v-.461a.327.327,0,0,0,.233-.3.291.291,0,0,0-.221-.278l-.012-.669-.173.012,0,.183,0-.009.012.471a.364.364,0,0,0-.216.2l-.557.009.019.177Zm-2.514,1.317-.216-.087.442-.518.144.173Zm.221-.588-.42.494.187.058.353-.4Zm-.593.384-.132-.185.372-.425.216.077Zm.24-.59-.341.4.114.137.432-.478Zm-.952-1.361v-.674l.233.048,0,.542Zm.005-.653.024.609.192-.055-.012-.514Zm-.173.653-.238-.067-.007-.547.221-.075Zm3.179-.309-.161-.134.245-.288-.228.281.144.1.736-.832.007.069Zm.791-.185v-.2l.024.182.179-.015-.012-.631a.325.325,0,0,0,.228-.293c0-.286-.515-.358-.6-.089l-.568.009.017.182.539-.017-.029.041-.526-.009-.012-.209.563-.019c.072-.274.658-.211.658.111a.332.332,0,0,1-.24.312l.007.628Zm-1.772-.252h-.215l-.012-.41a.288.288,0,0,1-.223-.189l-.472.012-.012-.209.5-.019c.065-.245.545-.25.634.01l.49-.01.012.213-.514.015a.3.3,0,0,1-.2.192l.012.379ZM474.2,20.3a.36.36,0,0,0,.216.2l.012.406.173-.009v-.386a.338.338,0,0,0,.2-.2l.521-.009-.017-.177-.485.012a.34.34,0,0,0-.61-.009l-.5.009.017.182Z",
    transform: "translate(-441.745 14.236)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6549",
    "data-name": "Caminho 6549",
    d: "M474.2,24.293v-.667l.228.043.012.55Zm.005-.646.019.605.192-.051-.012-.518Zm-.178.646-.233-.065-.007-.545.216-.072Zm.9-.466-.365-.413.113-.192.468.492Zm.37-.2-.466-.506.209-.113.37.41Zm.072-.885h-.582l-.065-.207.688-.021Zm.036-.213-.67.021.072.173.539-.012Zm-1.98.213h-.576l-.07-.207.692-.021Zm.029-.213-.659.021.072.173.533-.012Zm1.982-.177h-.7l.041-.219.581-.009Zm-.091-.209-.558.012-.041.185.652-.019Zm-1.85.209h-.7l.036-.219.582-.009Zm-.094-.209-.552.012-.041.185.646-.019Zm-.288-.312-.365-.413.108-.2.473.5Zm1.963-.015-.2-.089.437-.523.132.173Zm.221-.595-.406.5.18.051.353-.4Zm.88.454V21l.233.048.012.54Zm.012-.652.024.607.192-.053-.012-.514Zm-2.718.6-.454-.508.209-.108.372.406Zm1.252-.017-.137-.189.365-.422.209.077Zm.233-.586-.341.406.108.132.42-.482Zm.413-.485h-.569l-.077-.206.7-.022Zm.036-.216-.664.022.07.177.54-.012Zm-1.98.216h-.581l-.072-.209.7-.019Zm.029-.216-.664.022.07.177.541-.012Zm1.987-.177h-.7l.034-.218.588-.009Zm-.089-.206-.552.009-.041.189.646-.021Zm-1.862.206h-.7l.041-.218.582-.009Zm-.1-.206-.55.009-.041.189.651-.021Z",
    transform: "translate(-441.341 14.231)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6550",
    "data-name": "Caminho 6550",
    d: "M473.77,21.074v-.663l.233.045V21Zm.012-.653.018.612.192-.043-.012-.521Zm-.18.653-.233-.053-.019-.552.228-.077Z",
    transform: "translate(-440.915 14.571)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6551",
    "data-name": "Caminho 6551",
    d: "M473.357,21.512a.32.32,0,0,1,.33-.31.308.308,0,1,1,0,.616.322.322,0,0,1-.33-.305",
    transform: "translate(-440.909 15.15)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6552",
    "data-name": "Caminho 6552",
    d: "M474.03,16.854l.005-.072.012-.041a.988.988,0,0,1-.293-.015.741.741,0,0,1-.286-.147c-.1-.081-.132-.13-.2-.141a.507.507,0,0,0-.294.046.541.541,0,0,1,.223.158.521.521,0,0,0,.227.18,2.123,2.123,0,0,0,.389.009c.072.007.216.024.216.024",
    transform: "translate(-441.182 11.742)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6553",
    "data-name": "Caminho 6553",
    d: "M474.023,16.883s-.144-.017-.209-.021l-.228-.017v.021a.785.785,0,0,1-.167-.012.577.577,0,0,1-.245-.192.464.464,0,0,0-.2-.146c-.005-.043.1-.1.223-.1a.346.346,0,0,1,.226.089.827.827,0,0,0,.33.2.666.666,0,0,0,.168.015l.144.024Zm-.233-.065c.072,0,.168.012.216.017l.005-.048c-.161-.01-.227-.021-.27-.026a.825.825,0,0,1-.286-.156c-.115-.1-.151-.129-.187-.137a1.459,1.459,0,0,0-.245.026.424.424,0,0,1,.192.141.494.494,0,0,0,.221.175.624.624,0,0,0,.149.009Z",
    transform: "translate(-441.182 11.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6554",
    "data-name": "Caminho 6554",
    d: "M475.349,16.725a1.318,1.318,0,0,0,.012.17,1.856,1.856,0,0,1-.012.2c.012.039.024.074.036.108a.557.557,0,0,1,.029.11.319.319,0,0,1-.084-.06.762.762,0,0,0-.078-.057s.007.091.007.12a.352.352,0,0,0,.07.153.781.781,0,0,1,.115.159.419.419,0,0,1,.024.166.32.32,0,0,0-.108-.1.991.991,0,0,1-.145-.072.319.319,0,0,1,.1.183.618.618,0,0,1-.041.192.553.553,0,0,0-.1-.132.971.971,0,0,0-.125-.1.783.783,0,0,1,.053.226c0,.1-.017.3-.017.3a.738.738,0,0,0-.089-.117,1.228,1.228,0,0,1-.127-.089.327.327,0,0,1,.067.141,1.347,1.347,0,0,0,.221.554c.12.166.287.447.659.355s.238-.59.154-.823a2.283,2.283,0,0,1-.106-.583c0-.087.072-.35.06-.4a.809.809,0,0,1,.017-.389,1.951,1.951,0,0,1,.113-.293.817.817,0,0,0,.055-.159c.005-.05.005-.158.005-.158a1.25,1.25,0,0,1,.084.171.736.736,0,0,1,.019.177.284.284,0,0,1,.125-.2,1.852,1.852,0,0,0,.252-.168.158.158,0,0,0,.036-.06.767.767,0,0,1-.072.317c-.048.06-.216.249-.216.249a.856.856,0,0,1,.149-.039h.1a.821.821,0,0,0-.168.2,1.924,1.924,0,0,0-.125.266c-.072.108-.126.115-.216.187-.127.1-.055.518-.043.574s.247.571.252.691a.68.68,0,0,1-.192.578c-.144.113-.37.113-.418.146a.388.388,0,0,0-.156.345.308.308,0,0,0,.137.3c.055.053.139.024.156.062a.143.143,0,0,0,.055.087.1.1,0,0,1,.029.1,1.344,1.344,0,0,1-.144.221,1.293,1.293,0,0,0-.1.295.427.427,0,0,0,.024.165s.108.125.029.149c-.048.017-.09-.027-.114-.024-.06.015-.1.057-.113.05-.048,0-.048-.026-.055-.082s0-.087-.012-.087c-.029,0-.042.015-.042.051s-.012.108-.042.108-.07-.058-.095-.07-.1-.021-.108-.057a.166.166,0,0,1,.1-.113c.048-.012.089-.033.06-.06a.066.066,0,0,0-.1,0c-.024.027-.091,0-.091-.036s.019-.081.007-.1-.055-.06.012-.1.108.036.173.021a.154.154,0,0,0,.125-.075.177.177,0,0,0-.024-.185c-.042-.048-.095-.053-.106-.086a.6.6,0,0,1-.048-.118.766.766,0,0,1,.005.168.816.816,0,0,0-.005.1s-.048-.05-.084-.1a.665.665,0,0,1-.079-.161s0,.113,0,.159.048.089.036.1-.1-.081-.113-.1a.448.448,0,0,1-.127-.123,1,1,0,0,1-.06-.17.514.514,0,0,1-.012-.192c.019-.045.06-.129.06-.129h-.168c-.089,0-.154-.033-.19.029a.542.542,0,0,0,.024.345.9.9,0,0,1,.06.261.4.4,0,0,1-.1.113.2.2,0,0,1-.108-.005.273.273,0,0,0-.144-.033,1.431,1.431,0,0,1-.168,0,.423.423,0,0,0-.137-.043c-.036.015-.1.043-.077.091.023.074-.031.089-.061.084s-.06-.019-.115-.031c-.029-.012-.1,0-.094-.045a.23.23,0,0,1,.048-.093c.024-.036.029-.057.005-.063a.12.12,0,0,0-.077.015c-.031.015-.067.06-.1.041s-.048-.05-.048-.125-.083-.144,0-.141.173.057.185.021a.076.076,0,0,0-.029-.1c-.048-.036-.1-.05-.043-.093s.067-.041.084-.062.055-.1.089-.079c.072.036,0,.084.079.168a.237.237,0,0,0,.246.1c.12-.012.161-.027.161-.063a.848.848,0,0,0-.018-.125c0-.024.018-.115.018-.115s-.061.031-.072.069-.053.094-.053.094a.337.337,0,0,1-.007-.132c0-.031.007-.093.007-.1a.7.7,0,0,0-.019-.113.435.435,0,0,1-.036.113.764.764,0,0,0-.017.129.191.191,0,0,1-.06-.182c.019-.093-.017-.209.019-.249s.083-.2.239-.2.275,0,.336,0,.238-.034.238-.034-.347-.18-.425-.235a1,1,0,0,1-.25-.257.959.959,0,0,1-.079-.19.309.309,0,0,0-.119.033.6.6,0,0,0-.156.122,1.266,1.266,0,0,0-.084.127s.012-.118.012-.151v-.1a.491.491,0,0,1-.132.213c-.077.057-.166.137-.166.137s0-.082,0-.1.024-.117.024-.117a.266.266,0,0,1-.149.1c-.091.017-.216.015-.228.065s.024.132,0,.168a.143.143,0,0,1-.061.063.2.2,0,0,0-.089-.046.2.2,0,0,0-.091.026s-.034-.05-.024-.082.084-.081.072-.1-.077.005-.108.021-.106.036-.094-.021.024-.081.005-.123-.005-.065.019-.074.13.005.142-.021-.029-.058-.1-.075-.106-.053-.065-.089.048-.046.065-.084.024-.087.084-.055.048.1.12.12a.491.491,0,0,0,.257-.027c.036-.021.139-.1.18-.117s.185-.137.185-.137-.084-.063-.12-.093a.7.7,0,0,0-.119-.125,1.7,1.7,0,0,0-.228-.081,1.334,1.334,0,0,1-.209-.058.429.429,0,0,0,.1-.038.22.22,0,0,1,.1-.067l.029.007a1.228,1.228,0,0,1-.173-.019.938.938,0,0,0-.154-.06.926.926,0,0,0-.1.012.5.5,0,0,1,.166-.072.863.863,0,0,1,.132-.009s-.12-.033-.144-.069-.058-.1-.077-.123-.031-.065-.065-.069-.1.045-.144.043a.071.071,0,0,1-.067-.079c-.005-.06,0-.041-.017-.065s-.06-.1-.012-.113.168.012.168-.007c.017-.024-.055-.084-.1-.1s-.113-.063-.072-.1.072-.045.091-.072.048-.113.089-.087.1.153.137.144.031-.1.024-.137,0-.1.042-.1.061.051.113.055.132-.012.132.022a.355.355,0,0,1-.084.13.207.207,0,0,0-.023.177.524.524,0,0,0,.132.175,2.187,2.187,0,0,1,.221.108,2.425,2.425,0,0,0,.269.168.556.556,0,0,1,.1.036.435.435,0,0,1,.132-.024,1.3,1.3,0,0,0,.329-.015c.065-.026.156-.077.125-.137s-.18-.113-.161-.165.065-.051.156-.053.214.017.238-.115.031-.194-.1-.226-.221-.031-.24-.123-.048-.117-.017-.144a.353.353,0,0,1,.173-.041.89.89,0,0,0,.228-.027c.024-.017.036-.084.072-.111a.674.674,0,0,1,.178-.045,2.069,2.069,0,0,1,.336.2,1.567,1.567,0,0,1,.269.266Z",
    transform: "translate(-441.609 11.598)",
    fill: "#de6ba8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6555",
    "data-name": "Caminho 6555",
    d: "M475.486,21.176l-.077-.11-.138.048-.156-.1a.173.173,0,0,1,.113-.141l-.137-.075-.019-.165.067-.017.007.009-.007.149.168.048-.168.189.024,0,.132.072.132-.129.065.2,0-.022.156-.039a2.1,2.1,0,0,1-.005-.264,1.639,1.639,0,0,1,.1-.319c.019-.034.048-.075.077-.12l.055-.192-.019.024-.226-.173a.316.316,0,0,1-.127-.3.4.4,0,0,1,.175-.365,1.082,1.082,0,0,0,.406-.149.615.615,0,0,0,.185-.53,2.4,2.4,0,0,0-.185-.547,1.559,1.559,0,0,1-.06-.159c-.017-.057-.089-.489.048-.6.125-.087.168-.111.209-.189a1.675,1.675,0,0,1,.12-.264.962.962,0,0,1,.168-.185l.041.024a.833.833,0,0,0-.168.189c-.041.072-.053.108-.077.149l-.048.117a.347.347,0,0,1-.144.141c-.186.141-.13.533-.106.6,0,.022.029.079.058.153a3.407,3.407,0,0,1,.192.545.681.681,0,0,1-.2.595.848.848,0,0,1-.322.123.323.323,0,0,0-.24.35c0,.177.055.219.108.261l.007,0,.19.1.079.2a1.068,1.068,0,0,1-.072.113.831.831,0,0,0-.079.113,1.773,1.773,0,0,0-.1.283.3.3,0,0,0,.014.153.233.233,0,0,1,.06.146Zm-.178-.531-.15-.034.079-.024c.137.024.161-.021.173-.053a.14.14,0,0,0-.024-.149l-.113-.094v.058l-.006.038a1.018,1.018,0,0,1-.036-.225l.2.2a.178.178,0,0,1,.018.206.155.155,0,0,1-.138.082m-1.586-.079-.151-.041.048-.1-.005-.041-.156.029a.157.157,0,0,1-.065-.153l-.031-.144h.149l-.023-.009-.013-.12.235-.2.084.173a.209.209,0,0,0,.226.091c.12-.012.137-.027.137-.039l-.017-.125.065-.111-.012.125c.012.175-.065.187-.173.2a.258.258,0,0,1-.264-.108l-.046-.117-.12.06.012.009.012.2-.007.017h-.12l-.024.225.019-.021.156-.053v.122l.1.091v-.012l.2-.1-.067.144Zm.772-.075-.108-.005a.318.318,0,0,0-.145-.031l-.269-.05.079-.012.13.012a.449.449,0,0,1,.216.041.207.207,0,0,0,.168-.093.711.711,0,0,0-.036-.18c-.072-.262-.084-.367-.048-.43s.089-.053.149-.048h.233l-.042.171a.514.514,0,0,0,.012.166.908.908,0,0,0,.065.163.344.344,0,0,0,.115.122l.094.147h0l-.089-.081a.648.648,0,0,1-.156-.165.732.732,0,0,1-.067-.159.541.541,0,0,1,0-.216l.053-.134-.334.041.017.012a.586.586,0,0,0,.031.327c.053.2.072.245.06.274a.49.49,0,0,1-.108.125Zm-.419-.543c-.036-.007-.055-.079-.048-.141v-.127l-.036.127.005.005-.029.036a.23.23,0,0,1-.067-.206.406.406,0,0,0,0-.129l.019-.129c.048-.079.12-.2.262-.209.1,0,.18,0,.24,0a2.582,2.582,0,0,0,.312-.031,2.111,2.111,0,0,1-.42-.2,1.069,1.069,0,0,1-.257-.266.8.8,0,0,1-.072-.2.954.954,0,0,0-.24.168c-.022.036-.083.123-.083.123-.036-.022-.031-.115-.031-.153a.345.345,0,0,1-.089.113c-.083.06-.18.137-.18.137l-.029.033.012-.153V18.7a.163.163,0,0,1-.1.05c-.125.022-.2.031-.209.055l.012.177-.1.009.042-.1c.012-.141.089-.153.173-.168a.273.273,0,0,0,.2-.1l.043-.063-.019.194c-.041.087.043,0,.125-.053a.373.373,0,0,0,.115-.2.655.655,0,0,1,.041.189.162.162,0,0,1,.055-.07.4.4,0,0,1,.149-.13.314.314,0,0,1,.132-.033c.024.022.053.141.089.2a1.234,1.234,0,0,0,.245.249c.084.057.43.233.43.233-.012.046-.2.079-.25.084-.156-.005-.233-.005-.336-.005a.273.273,0,0,0-.209.168l-.017.125a.945.945,0,0,1-.007.141.192.192,0,0,0,.024.135.149.149,0,0,1,.012-.091l.055-.1v0l.012-.009.029.165a.761.761,0,0,0,0,.185l.007,0Zm1.615-.784a.676.676,0,0,1-.526-.363,1.624,1.624,0,0,1-.252-.59.325.325,0,0,0-.053-.13c.017-.015.042,0,.053.021l.1.039a.482.482,0,0,1,.07.086,1.689,1.689,0,0,1,0-.249.92.92,0,0,0-.053-.225c.031-.026.108.031.168.084a.552.552,0,0,1,.084.108c0-.036.012-.1.012-.149a.238.238,0,0,0-.091-.165c.031-.043.139.014.18.033s.055.043.077.065c-.01-.033-.017-.074-.022-.1a.5.5,0,0,0-.1-.132.357.357,0,0,1-.091-.18l0-.045.023-.077-.006-.007.006-.021.125.113L475.344,17v-.273h.041a1.268,1.268,0,0,0,.012.17l-.012.187.043.226h-.019v.021l-.12-.117.012.1a.408.408,0,0,0,.055.137.708.708,0,0,1,.125.168.82.82,0,0,1,.017.173c-.058-.017-.1-.072-.125-.077a.68.68,0,0,1-.072-.036.177.177,0,0,1,.043.12.5.5,0,0,1-.043.2c-.041-.009-.084-.072-.137-.127-.024-.026-.055-.046-.079-.069a.433.433,0,0,1,.043.177c0,.1-.019.3-.019.3-.041.015-.083-.063-.125-.1l-.036-.033a.105.105,0,0,1,.012.053,1.372,1.372,0,0,0,.228.552c.132.19.3.43.634.346a.3.3,0,0,0,.185-.135,1.1,1.1,0,0,0-.042-.66,2.082,2.082,0,0,1-.126-.59c0-.039.024-.117.036-.2a1.264,1.264,0,0,0,.031-.206,1.048,1.048,0,0,1,.017-.4,2.215,2.215,0,0,1,.084-.225l.077-.218a.647.647,0,0,0,.019-.159c.048-.009.108.12.125.159.007.017.007.041.019.07a.251.251,0,0,1,.089-.1c.144-.093.216-.141.24-.161a.032.032,0,0,1,.024-.007.359.359,0,0,1-.168.163c-.229.141-.18.233-.185.225s-.019-.01-.019-.019a.574.574,0,0,1-.041-.153.718.718,0,0,1-.048-.089.27.27,0,0,1-.007.077.429.429,0,0,1-.041.123c-.06.158-.089.225-.125.329a1.013,1.013,0,0,0-.012.379,1.214,1.214,0,0,1-.031.213,1.11,1.11,0,0,0-.029.192,1.659,1.659,0,0,0,.113.578.916.916,0,0,1,.031.694.282.282,0,0,1-.211.154.536.536,0,0,1-.137.026m-2.837-.151-.245-.137-.012-.161h.007l.1-.111-.12-.12.108-.122-.024-.007.12-.065.106.113a.429.429,0,0,0,.24-.024c.125-.077.168-.11.192-.122s.108-.075.167-.117a.379.379,0,0,1-.113-.075l-.113-.12a1.772,1.772,0,0,0-.216-.075,1.019,1.019,0,0,1-.221-.053l.1-.1.024-.014a.411.411,0,0,1-.06-.007l-.143-.06.1-.009a1.724,1.724,0,0,0,.185.033h.031l-.211.144c.048-.021.156.015.192.017a.91.91,0,0,1,.233.079l.132.129a.781.781,0,0,0,.113.1c-.012.05-.149.154-.19.173l-.18.12a.463.463,0,0,1-.275.026l-.125-.122-.113.129c.108.069.149.1.156.122v.019l-.1.057-.06.141c.048,0,.072,0,.113,0s.065,0,.077.017l-.059.123L472.9,19Zm-.048-1.437c.031-.021.055-.026.072-.041a.182.182,0,0,1-.107-.048l-.055-.135-.017.019-.192-.021a.123.123,0,0,1-.1-.1l-.048-.17.144-.036v-.007l-.144-.141.233-.206.12.135v-.007l.031-.209.154.063v-.027l.144.024a.252.252,0,0,1-.077.17.179.179,0,0,0-.019.156.507.507,0,0,0,.126.168,1.135,1.135,0,0,1,.222.1,1.781,1.781,0,0,0,.25.168.458.458,0,0,0,.229.012,1.341,1.341,0,0,0,.317-.012c.089-.036.113-.069.12-.084l-.019-.015-.143-.19c.005-.06.078-.063.173-.072.137,0,.2-.007.216-.091.029-.13.022-.182-.079-.2-.156-.036-.238-.051-.257-.146l-.017-.165a.329.329,0,0,1,.178-.048,1.312,1.312,0,0,0,.221-.024l.079-.115a1.852,1.852,0,0,1,.19-.05,1.719,1.719,0,0,1,.348.213,1.614,1.614,0,0,1,.281.269c-.041.024-.168-.129-.312-.237a2.677,2.677,0,0,0-.327-.2,1.3,1.3,0,0,0-.156.048l-.072.108a.472.472,0,0,1-.18.029c-.156.007-.2.019-.227.045.046.175.1.192.2.213.216.048.192.147.173.267s-.137.13-.221.13c-.132,0-.166.007-.178.039.106.081.154.108.167.144a.189.189,0,0,1-.143.168.909.909,0,0,1-.276.017.41.41,0,0,0-.18.021.934.934,0,0,1-.31-.149.868.868,0,0,0-.192-.111.555.555,0,0,1-.252-.237.218.218,0,0,1,.036-.206.26.26,0,0,0,.072-.117l-.192-.033c-.034.093-.029.2-.094.214l-.007.01-.084-.084-.173.06c.072.108.137.153.144.185l-.192.051.055.13.186.039.125.137a.235.235,0,0,0,.168.117c-.012.051-.066.046-.139.06m3.556-.76c-.024-.036.145-.221.18-.285a.521.521,0,0,0,.065-.254c.055.027.031.2-.017.281-.036.039-.115.129-.168.192a.3.3,0,0,1,.072-.012l.072.009c-.132.041-.2.069-.2.069",
    transform: "translate(-441.621 11.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6556",
    "data-name": "Caminho 6556",
    d: "M473.4,16.512a.355.355,0,0,1-.019-.075l-.017-.033s.108,0,.108.031-.036.038-.048.045a.193.193,0,0,1-.024.033",
    transform: "translate(-440.902 11.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6557",
    "data-name": "Caminho 6557",
    d: "M473.676,16.391l-.012-.051a.274.274,0,0,1,.137.036.35.35,0,0,1,.108.12c-.017.012-.065-.029-.108-.043a.194.194,0,0,1-.048.007.04.04,0,0,1-.041-.027.2.2,0,0,1,.007-.033Z",
    transform: "translate(-440.69 11.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6558",
    "data-name": "Caminho 6558",
    d: "M472.614,16.551a.311.311,0,0,0,.1.051l.1,0a.435.435,0,0,0,.019-.11.222.222,0,0,0-.163-.171s.042.087.024.123a.3.3,0,0,1-.077.1",
    transform: "translate(-441.44 11.664)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6559",
    "data-name": "Caminho 6559",
    d: "M472.6,16.568a.178.178,0,0,0-.163-.087.3.3,0,0,0-.178.1s.125-.007.156.024c.036.015.046.089.046.089a.282.282,0,0,0,.089-.06c.019-.026.049-.065.049-.065",
    transform: "translate(-441.695 11.776)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6560",
    "data-name": "Caminho 6560",
    d: "M472.451,16.746a.222.222,0,0,0-.132.075.264.264,0,0,0-.048.165.2.2,0,0,1,.12-.067.758.758,0,0,1,.132.021.381.381,0,0,1-.031-.1.33.33,0,0,0-.041-.1",
    transform: "translate(-441.686 11.966)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6561",
    "data-name": "Caminho 6561",
    d: "M472.259,16.994a.269.269,0,0,1,.051-.189.285.285,0,0,1,.151-.072h.026l.046.117c0,.015-.012.031-.012.043l-.06-.139.012.022a.247.247,0,0,0-.132.072.193.193,0,0,0-.036.094.275.275,0,0,1,.2-.021c-.022.039-.084.027-.108.027l-.042.041Z",
    transform: "translate(-441.696 11.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6562",
    "data-name": "Caminho 6562",
    d: "M473.392,16.768l.043-.065.041.057Z",
    transform: "translate(-440.885 11.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6563",
    "data-name": "Caminho 6563",
    d: "M473.448,16.76l.053-.06.055.057Z",
    transform: "translate(-440.845 11.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6564",
    "data-name": "Caminho 6564",
    d: "M473.423,16.51l.1.036-.084.039Z",
    transform: "translate(-440.862 11.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6565",
    "data-name": "Caminho 6565",
    d: "M473.493,16.528l.084.019-.06.058Z",
    transform: "translate(-440.812 11.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6566",
    "data-name": "Caminho 6566",
    d: "M473.564,17.989l-.024-.041s.113-.07.161-.093a.539.539,0,0,0,.127-.115.664.664,0,0,0-.024-.182.283.283,0,0,1-.012-.1.212.212,0,0,1-.066.063.461.461,0,0,1-.214.1.522.522,0,0,0-.115.038c-.036-.036.031-.13.031-.213v-.058l-.245.141c-.036.017-.079.093-.1.118l-.036-.024a.479.479,0,0,1,.115-.137l.162-.077-.012-.021.113-.01-.012-.062a.237.237,0,0,1,.048-.142.168.168,0,0,1-.1.027l-.156-.057,0,.021a.229.229,0,0,0-.168.036c-.042-.021-.042-.086,0-.158s.15-.084.15-.091L473.2,17a.259.259,0,0,0-.125.07c-.055.074-.012.045.072.045.012,0,.041.005.058.005l.156.06,0-.017c.036-.01.12-.034.156-.043,0,.06-.06.141-.055.185l.024.147a.95.95,0,0,1-.042.149c.012-.015.036-.015.06-.024a.7.7,0,0,0,.2-.093.615.615,0,0,0,.108-.113c.036.048.024.132.036.173a.633.633,0,0,1,.029.165.251.251,0,0,1,.067-.053l.12-.067-.024-.009.041-.063a.3.3,0,0,1,0-.048c.012,0,.017.015.024.031l.024-.036a.507.507,0,0,0,.041.149.55.55,0,0,1,.072.165.542.542,0,0,1,.041-.108c.055-.05.084-.093.084-.113.048.036.019.077-.048.144a.426.426,0,0,0-.06.141.511.511,0,0,1-.119-.2.171.171,0,0,1-.036-.072l-.019.036c-.017.036-.072.065-.1.084l-.1.048v.009l0,0h-.024c.012.043-.041.115-.12.156-.042.029-.161.093-.161.093",
    transform: "translate(-441.164 12.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6567",
    "data-name": "Caminho 6567",
    d: "M472.677,17.468a.156.156,0,0,0-.137-.039.268.268,0,0,0-.149.117.308.308,0,0,1,.118-.009.137.137,0,0,1,.079.055s.042-.039.053-.055l.036-.069",
    transform: "translate(-441.6 12.452)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6568",
    "data-name": "Caminho 6568",
    d: "M472.585,17.658a.172.172,0,0,0-.137.039.255.255,0,0,0-.072.149.177.177,0,0,1,.108-.045.3.3,0,0,1,.108.029s.012-.057.017-.074a.147.147,0,0,0-.024-.1",
    transform: "translate(-441.611 12.616)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6569",
    "data-name": "Caminho 6569",
    d: "M472.6,17.851a.255.255,0,0,0,.036.149.26.26,0,0,0,.144.072.284.284,0,0,1-.036-.093.1.1,0,0,1,.036-.089s-.048-.048-.083-.048a.623.623,0,0,0-.1.009",
    transform: "translate(-441.451 12.749)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6570",
    "data-name": "Caminho 6570",
    d: "M473.883,18.523c-.036-.031.084-.185.1-.3,0-.091-.168-.216-.228-.252l.024-.041c.024.014.257.161.252.293a.849.849,0,0,1-.144.3",
    transform: "translate(-440.628 12.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6571",
    "data-name": "Caminho 6571",
    d: "M473.238,18.364a.211.211,0,0,0-.144-.072.31.31,0,0,0-.166.084s.094-.012.125.024.053.081.053.081a.233.233,0,0,0,.072-.041.567.567,0,0,0,.06-.075",
    transform: "translate(-441.216 13.071)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6572",
    "data-name": "Caminho 6572",
    d: "M473.049,18.532a.218.218,0,0,0-.167.041.291.291,0,0,0-.048.159s.067-.069.127-.063a.414.414,0,0,1,.132.043.486.486,0,0,1-.019-.1c-.005-.027-.024-.084-.024-.084",
    transform: "translate(-441.284 13.241)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6573",
    "data-name": "Caminho 6573",
    d: "M473.112,18.737a.153.153,0,0,0-.019.141.358.358,0,0,0,.132.093.166.166,0,0,1-.018-.1c.005-.039.077-.093.077-.093Z",
    transform: "translate(-441.107 13.389)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6574",
    "data-name": "Caminho 6574",
    d: "M474.063,18.825a.2.2,0,0,0-.149.012c-.055.029-.1.168-.1.168s.084-.075.149-.069a.563.563,0,0,1,.108.041.231.231,0,0,0,0-.1.192.192,0,0,0-.012-.057",
    transform: "translate(-440.58 13.445)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6575",
    "data-name": "Caminho 6575",
    d: "M473.786,19.071l.024-.081c.007-.015.048-.141.113-.171h.187l-.019.063,0-.06-.072.012a.25.25,0,0,0-.127.1.246.246,0,0,1,.084-.027.261.261,0,0,1,.12.036l0,.043c-.156-.036-.216.012-.235.029Z",
    transform: "translate(-440.603 13.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6576",
    "data-name": "Caminho 6576",
    d: "M474.007,19.03s-.072.077-.043.137a.671.671,0,0,0,.072.135.282.282,0,0,1,.024-.123.292.292,0,0,1,.132-.045.79.79,0,0,0-.083-.065c-.018,0-.1-.039-.1-.039",
    transform: "translate(-440.481 13.598)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6577",
    "data-name": "Caminho 6577",
    d: "M474.206,19.111a.146.146,0,0,0,.036.156.3.3,0,0,0,.137.062.3.3,0,0,1-.041-.146.181.181,0,0,1,.072-.084.7.7,0,0,0-.108-.027c-.012.007-.1.039-.1.039",
    transform: "translate(-440.31 13.628)",
    fill: "#ca3e4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6578",
    "data-name": "Caminho 6578",
    d: "M472.369,23.042a.484.484,0,0,1,.371.482.563.563,0,0,1-.627.5.582.582,0,0,1-.647-.5.441.441,0,0,1,.366-.47.12.12,0,0,0-.024-.06c-.029-.024-.079-.077-.079-.077a.32.32,0,0,1,.151.005.213.213,0,0,1,.1.055.288.288,0,0,1,.053-.094.282.282,0,0,1,.09-.058.245.245,0,0,1,.066.074c.017.031.036.072.036.072a.426.426,0,0,1,.084-.057.4.4,0,0,1,.106-.033s-.018.05-.029.081a.26.26,0,0,0-.012.081",
    transform: "translate(-442.261 16.309)",
    fill: "#f7d591"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6579",
    "data-name": "Caminho 6579",
    d: "M472.124,24.059c-.382,0-.676-.228-.676-.526a.468.468,0,0,1,.394-.5l.007.062a.4.4,0,0,0-.336.441c0,.261.257.473.61.473s.6-.2.6-.473a.465.465,0,0,0-.353-.453l-.029-.009.029-.111-.042.027-.132,0-.053-.129-.019.036-.161.111-.144-.051.023.075-.113-.135.161.039.012-.033.24-.087.113.156.161-.111.012.127a.622.622,0,0,1,.353.55c0,.305-.281.526-.658.526",
    transform: "translate(-442.274 16.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6580",
    "data-name": "Caminho 6580",
    d: "M472.379,23.863a3.084,3.084,0,0,0-.682-.362,3.141,3.141,0,0,0-.682-.015s.149.108.221.173a1.271,1.271,0,0,0,.4.228,1.408,1.408,0,0,0,.742-.024",
    transform: "translate(-442.583 16.773)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6581",
    "data-name": "Caminho 6581",
    d: "M471.969,23.973a1.3,1.3,0,0,1-.324-.038,1.621,1.621,0,0,1-.43-.237,1.317,1.317,0,0,0-.209-.171l.161-.06.227-.012a1.808,1.808,0,0,1,.319.031,2.976,2.976,0,0,1,.693.369c-.018.057-.19.118-.436.118m-.875-.442a.577.577,0,0,1,.173.123,1.227,1.227,0,0,0,.389.225,1.81,1.81,0,0,0,.707-.024c-.084-.012-.485-.271-.67-.309a1.389,1.389,0,0,0-.3-.024Z",
    transform: "translate(-442.59 16.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6582",
    "data-name": "Caminho 6582",
    d: "M471.891,23.876a1.32,1.32,0,0,1,.617-.362,1.95,1.95,0,0,1,.777.069,2.092,2.092,0,0,0-.2.108.827.827,0,0,1-.485.189c-.257,0-.55-.027-.592-.015a.921.921,0,0,0-.12.012",
    transform: "translate(-441.957 16.792)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6583",
    "data-name": "Caminho 6583",
    d: "M472.576,23.92c-.136,0-.276,0-.387-.007l-.146-.009-.1.015-.015-.015.111-.065.146.009c.111,0,.251.017.387.017v.027l.036-.027a.823.823,0,0,0,.449-.17,1.673,1.673,0,0,1,.2-.117c.016.062-.085.11-.146.142a.781.781,0,0,1-.5.2Zm-.645-.015-.053-.033a1.337,1.337,0,0,1,.638-.375,1.762,1.762,0,0,1,.723.055c.007.005.007.015.014.021-.155.007-.3-.029-.5-.029a2.149,2.149,0,0,0-.228.014,1.229,1.229,0,0,0-.6.348",
    transform: "translate(-441.966 16.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6584",
    "data-name": "Caminho 6584",
    d: "M471.915,23.859a.608.608,0,0,1,0-.886.591.591,0,0,1,.2.444.605.605,0,0,1-.2.442",
    transform: "translate(-442.077 16.415)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6585",
    "data-name": "Caminho 6585",
    d: "M471.924,23.908l-.017-.012a.655.655,0,0,1,0-.936.552.552,0,0,1,.245.466.639.639,0,0,1-.2.47Zm-.017-.9a.752.752,0,0,0-.137.418.54.54,0,0,0,.154.4.53.53,0,0,0,.168-.4.567.567,0,0,0-.186-.418",
    transform: "translate(-442.087 16.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6586",
    "data-name": "Caminho 6586",
    d: "M471.769,24.118a1.113,1.113,0,0,0,.072-.338,1.362,1.362,0,0,0-.019-.261h.1a1.118,1.118,0,0,1,.041.261c0,.122-.017.281-.017.281a.432.432,0,0,0-.091.021c-.018.009-.089.036-.089.036",
    transform: "translate(-442.044 16.806)",
    fill: "#3d8e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6587",
    "data-name": "Caminho 6587",
    d: "M471.811,24.138l-.029-.009.017-.019-.017,0-.012-.019.012.019-.031,0a1.472,1.472,0,0,0,.079-.329,1.328,1.328,0,0,0-.019-.252l.127-.033a.541.541,0,0,1,.077.286c0,.123-.019.285-.019.285l-.178.036a.093.093,0,0,0-.007.027m.1-.6c-.036,0-.012.129-.018.254a1.434,1.434,0,0,1-.067.3l.031-.027c.054-.019.1-.153.1-.276a1.016,1.016,0,0,0-.042-.25Z",
    transform: "translate(-442.057 16.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6588",
    "data-name": "Caminho 6588",
    d: "M475.267,13.906a.123.123,0,0,1,.125-.122.129.129,0,0,1,.132.122.126.126,0,0,1-.132.123.12.12,0,0,1-.125-.123",
    transform: "translate(-439.545 9.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6589",
    "data-name": "Caminho 6589",
    d: "M475.364,13.723a.135.135,0,0,1,.144-.123.127.127,0,0,1,.125.123.121.121,0,0,1-.125.12.13.13,0,0,1-.144-.12",
    transform: "translate(-439.475 9.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6590",
    "data-name": "Caminho 6590",
    d: "M475.441,13.508a.123.123,0,0,1,.12-.123.13.13,0,0,1,.132.123.127.127,0,0,1-.132.125.121.121,0,0,1-.12-.125",
    transform: "translate(-439.42 9.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6591",
    "data-name": "Caminho 6591",
    d: "M475.448,13.278a.129.129,0,0,1,.257,0,.128.128,0,1,1-.257,0",
    transform: "translate(-439.415 9.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6592",
    "data-name": "Caminho 6592",
    d: "M475.389,13.06a.134.134,0,0,1,.137-.132.137.137,0,0,1,.127.132.131.131,0,0,1-.127.12.129.129,0,0,1-.137-.12",
    transform: "translate(-439.458 9.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6593",
    "data-name": "Caminho 6593",
    d: "M475.274,12.851a.122.122,0,0,1,.125-.125.123.123,0,0,1,.132.125.125.125,0,0,1-.132.122.123.123,0,0,1-.125-.122",
    transform: "translate(-439.54 9.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6594",
    "data-name": "Caminho 6594",
    d: "M475.117,12.681a.122.122,0,0,1,.125-.123.124.124,0,1,1,0,.245.121.121,0,0,1-.125-.122",
    transform: "translate(-439.652 8.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6595",
    "data-name": "Caminho 6595",
    d: "M474.932,12.547a.134.134,0,0,1,.137-.132.137.137,0,0,1,.132.132.132.132,0,0,1-.132.12.129.129,0,0,1-.137-.12",
    transform: "translate(-439.784 8.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6596",
    "data-name": "Caminho 6596",
    d: "M474.722,12.423a.119.119,0,0,1,.125-.12.128.128,0,0,1,.127.12.126.126,0,0,1-.127.125.119.119,0,0,1-.125-.125",
    transform: "translate(-439.934 8.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6597",
    "data-name": "Caminho 6597",
    d: "M474.5,12.347a.123.123,0,0,1,.125-.125.133.133,0,0,1,.132.125.128.128,0,0,1-.132.122.119.119,0,0,1-.125-.122",
    transform: "translate(-440.097 8.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6598",
    "data-name": "Caminho 6598",
    d: "M474.24,12.3a.129.129,0,0,1,.137-.125.121.121,0,0,1,.12.125.127.127,0,0,1-.12.127.135.135,0,0,1-.137-.127",
    transform: "translate(-440.279 8.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6599",
    "data-name": "Caminho 6599",
    d: "M474,12.289a.13.13,0,0,1,.132-.125.134.134,0,0,1,.132.125.132.132,0,0,1-.132.12.128.128,0,0,1-.132-.12",
    transform: "translate(-440.448 8.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6600",
    "data-name": "Caminho 6600",
    d: "M473.766,12.3a.131.131,0,1,1,.13.123.13.13,0,0,1-.13-.123",
    transform: "translate(-440.618 8.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6601",
    "data-name": "Caminho 6601",
    d: "M473.535,12.3a.119.119,0,0,1,.12-.125.131.131,0,0,1,.138.125.133.133,0,0,1-.138.123.121.121,0,0,1-.12-.123",
    transform: "translate(-440.782 8.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6602",
    "data-name": "Caminho 6602",
    d: "M473.65,12.5a.131.131,0,0,1,.125-.129.127.127,0,1,1,0,.254.131.131,0,0,1-.125-.125",
    transform: "translate(-440.7 8.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6603",
    "data-name": "Caminho 6603",
    d: "M473.7,12.718a.132.132,0,0,1,.132-.123.126.126,0,1,1,0,.252.13.13,0,0,1-.132-.129",
    transform: "translate(-440.667 9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6604",
    "data-name": "Caminho 6604",
    d: "M473.706,12.939a.131.131,0,0,1,.137-.122.126.126,0,0,1,.127.122.124.124,0,0,1-.127.12.13.13,0,0,1-.137-.12",
    transform: "translate(-440.66 9.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6605",
    "data-name": "Caminho 6605",
    d: "M473.636,13.139a.129.129,0,0,1,.132-.12.123.123,0,1,1,0,.245.128.128,0,0,1-.132-.125",
    transform: "translate(-440.711 9.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6606",
    "data-name": "Caminho 6606",
    d: "M473.511,13.328a.124.124,0,0,1,.125-.125.13.13,0,0,1,.132.125.132.132,0,0,1-.132.125.126.126,0,0,1-.125-.125",
    transform: "translate(-440.8 9.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6607",
    "data-name": "Caminho 6607",
    d: "M473.353,12.158a.13.13,0,0,1,.132-.125.135.135,0,0,1,.138.125.133.133,0,0,1-.138.12.128.128,0,0,1-.132-.12",
    transform: "translate(-440.913 8.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6608",
    "data-name": "Caminho 6608",
    d: "M473.148,12.041a.127.127,0,0,1,.132-.125.131.131,0,0,1,.125.125.125.125,0,0,1-.125.122.123.123,0,0,1-.132-.122",
    transform: "translate(-441.059 8.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6609",
    "data-name": "Caminho 6609",
    d: "M472.921,11.97a.126.126,0,0,1,.252,0,.126.126,0,0,1-.252,0",
    transform: "translate(-441.221 8.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6610",
    "data-name": "Caminho 6610",
    d: "M472.676,11.93a.139.139,0,0,1,.144-.125.135.135,0,0,1,.125.125.132.132,0,0,1-.125.125.137.137,0,0,1-.144-.125",
    transform: "translate(-441.396 8.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6611",
    "data-name": "Caminho 6611",
    d: "M472.446,11.934a.131.131,0,0,1,.132-.122.124.124,0,0,1,.125.122.129.129,0,0,1-.125.129.135.135,0,0,1-.132-.129",
    transform: "translate(-441.56 8.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6612",
    "data-name": "Caminho 6612",
    d: "M472.2,11.976a.131.131,0,0,1,.137-.122.127.127,0,0,1,.132.122.129.129,0,0,1-.132.12.134.134,0,0,1-.137-.12",
    transform: "translate(-441.738 8.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6613",
    "data-name": "Caminho 6613",
    d: "M471.975,12.052a.125.125,0,0,1,.137-.12.123.123,0,0,1,.132.12.126.126,0,0,1-.132.123.128.128,0,0,1-.137-.123",
    transform: "translate(-441.897 8.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6614",
    "data-name": "Caminho 6614",
    d: "M468.166,13.906a.129.129,0,0,1,.132-.122.127.127,0,0,1,.125.122.124.124,0,0,1-.125.123.126.126,0,0,1-.132-.123",
    transform: "translate(-444.619 9.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6615",
    "data-name": "Caminho 6615",
    d: "M468.061,13.723a.126.126,0,0,1,.252,0,.126.126,0,0,1-.252,0",
    transform: "translate(-444.694 9.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6616",
    "data-name": "Caminho 6616",
    d: "M467.988,13.508a.135.135,0,0,1,.27,0,.135.135,0,0,1-.27,0",
    transform: "translate(-444.746 9.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6617",
    "data-name": "Caminho 6617",
    d: "M467.984,13.278a.126.126,0,0,1,.252,0,.13.13,0,0,1-.132.132.131.131,0,0,1-.12-.132",
    transform: "translate(-444.749 9.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6618",
    "data-name": "Caminho 6618",
    d: "M468.037,13.06a.127.127,0,0,1,.125-.132.135.135,0,0,1,.139.132.13.13,0,0,1-.139.12.122.122,0,0,1-.125-.12",
    transform: "translate(-444.711 9.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6619",
    "data-name": "Caminho 6619",
    d: "M468.156,12.851a.128.128,0,0,1,.132-.125.126.126,0,0,1,.125.125.128.128,0,0,1-.125.122.129.129,0,0,1-.132-.122",
    transform: "translate(-444.625 9.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6620",
    "data-name": "Caminho 6620",
    d: "M468.309,12.681a.133.133,0,0,1,.137-.123.124.124,0,0,1,.127.123.123.123,0,0,1-.127.122.131.131,0,0,1-.137-.122",
    transform: "translate(-444.517 8.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6621",
    "data-name": "Caminho 6621",
    d: "M468.491,12.547a.138.138,0,0,1,.137-.132.139.139,0,0,1,.139.132.134.134,0,0,1-.139.12.133.133,0,0,1-.137-.12",
    transform: "translate(-444.387 8.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6622",
    "data-name": "Caminho 6622",
    d: "M468.707,12.423a.134.134,0,0,1,.137-.12.128.128,0,0,1,.127.12.126.126,0,0,1-.127.125.132.132,0,0,1-.137-.125",
    transform: "translate(-444.232 8.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6623",
    "data-name": "Caminho 6623",
    d: "M468.934,12.347a.132.132,0,0,1,.264,0,.133.133,0,0,1-.264,0",
    transform: "translate(-444.07 8.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6624",
    "data-name": "Caminho 6624",
    d: "M469.189,12.3a.12.12,0,0,1,.12-.125.129.129,0,0,1,.137.125.135.135,0,0,1-.137.127.126.126,0,0,1-.12-.127",
    transform: "translate(-443.888 8.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6625",
    "data-name": "Caminho 6625",
    d: "M469.43,12.289a.12.12,0,0,1,.125-.125.125.125,0,0,1,.132.125.123.123,0,0,1-.132.12.118.118,0,0,1-.125-.12",
    transform: "translate(-443.715 8.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6626",
    "data-name": "Caminho 6626",
    d: "M469.66,12.3a.13.13,0,0,1,.132-.125.134.134,0,0,1,.137.125.137.137,0,0,1-.137.123.132.132,0,0,1-.132-.123",
    transform: "translate(-443.551 8.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6627",
    "data-name": "Caminho 6627",
    d: "M469.894,12.3a.129.129,0,0,1,.132-.125.134.134,0,0,1,.132.125.137.137,0,0,1-.132.123.131.131,0,0,1-.132-.123",
    transform: "translate(-443.384 8.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6628",
    "data-name": "Caminho 6628",
    d: "M469.779,12.5a.126.126,0,0,1,.125-.129.127.127,0,1,1,0,.254.126.126,0,0,1-.125-.125",
    transform: "translate(-443.466 8.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6629",
    "data-name": "Caminho 6629",
    d: "M469.73,12.718a.13.13,0,0,1,.125-.123.126.126,0,1,1,0,.252.129.129,0,0,1-.125-.129",
    transform: "translate(-443.501 9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6630",
    "data-name": "Caminho 6630",
    d: "M469.723,12.939a.126.126,0,1,1,.132.12.121.121,0,0,1-.132-.12",
    transform: "translate(-443.506 9.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6631",
    "data-name": "Caminho 6631",
    d: "M469.789,13.139a.132.132,0,0,1,.132-.12.123.123,0,1,1,0,.245.131.131,0,0,1-.132-.125",
    transform: "translate(-443.459 9.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6632",
    "data-name": "Caminho 6632",
    d: "M469.919,13.328a.135.135,0,0,1,.137-.125.123.123,0,0,1,.12.125.125.125,0,0,1-.12.125.137.137,0,0,1-.137-.125",
    transform: "translate(-443.366 9.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6633",
    "data-name": "Caminho 6633",
    d: "M470.069,12.158a.134.134,0,0,1,.137-.125.13.13,0,0,1,.132.125.128.128,0,0,1-.132.12.133.133,0,0,1-.137-.12",
    transform: "translate(-443.259 8.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6634",
    "data-name": "Caminho 6634",
    d: "M470.282,12.041a.132.132,0,0,1,.132-.125.126.126,0,0,1,.125.125.121.121,0,0,1-.125.122.127.127,0,0,1-.132-.122",
    transform: "translate(-443.107 8.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6635",
    "data-name": "Caminho 6635",
    d: "M470.509,11.97a.126.126,0,0,1,.137-.12.124.124,0,0,1,.127.12.129.129,0,0,1-.127.125.13.13,0,0,1-.137-.125",
    transform: "translate(-442.944 8.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6636",
    "data-name": "Caminho 6636",
    d: "M470.753,11.93a.122.122,0,0,1,.121-.125.133.133,0,0,1,.137.125.131.131,0,0,1-.137.125.12.12,0,0,1-.121-.125",
    transform: "translate(-442.77 8.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6637",
    "data-name": "Caminho 6637",
    d: "M470.983,11.934a.128.128,0,0,1,.125-.122.13.13,0,0,1,.132.122.128.128,0,1,1-.257,0",
    transform: "translate(-442.606 8.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6638",
    "data-name": "Caminho 6638",
    d: "M471.224,11.976a.131.131,0,0,1,.137-.122.122.122,0,0,1,.127.122.124.124,0,0,1-.127.12.134.134,0,0,1-.137-.12",
    transform: "translate(-442.434 8.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6639",
    "data-name": "Caminho 6639",
    d: "M471.448,12.052a.128.128,0,0,1,.135-.12.124.124,0,0,1,.129.12.126.126,0,0,1-.129.123.13.13,0,0,1-.135-.123",
    transform: "translate(-442.274 8.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6640",
    "data-name": "Caminho 6640",
    d: "M469.856,16.949h-.113v-.113h-.18v.434h.18v.3h-.4v.864h.221v1.727h-.437v.895h3.323v-.895h-.437V18.43h.221v-.864h-.408v-.3h.187v-.434h-.187v.113h-.107v-.113h-.187v.113h-.137v-.113H471.2v.434h.192v.3h-.406v-.94h.214v-.437h-.214V16.3h-.108v-.113h-.192V16.3h-.1v-.113h-.221v.437h.221v.94h-.413v-.3h.192v-.434h-.192v.113h-.108v-.113h-.209Zm-.73,4.1h0Zm0-.221h0Zm0-.213h0Zm0-.221h0Zm0-.24h0Zm.437-.185h0Zm0-.218h0Zm0-.237h0Zm0-.225h0Zm0-.213h0Zm0-.218h0Zm0-.211h0Zm-.221-.221h0Zm0-.218h0Zm0-.213h0Zm0-.219h0Zm.4-.214h0Zm.844-.216h0Zm0-.213h0Zm0-.216h0Zm0-.221h0Zm-.221-.269h0Zm-.623.919h0Zm-.18-.269h0Zm0,3.971v0Zm0-.434v0Zm-.221,0v0Zm.4.213v0Zm.222.221v0Zm0-.434v0Zm0-.461v0Zm0-.4v0Zm-.222.643v0Zm-.4,0v0Zm.832-.24v0Zm.192,0v0Zm-.623-.4v0Zm.431,0v0Zm.413,0v0Zm-.221,0v0Zm.221-.461v0Zm0-.43v0Zm-.221-.211v0Zm.221-.221v0Zm-.413,0v0Zm-.431,0v0Zm-.18-.218v0Zm.4,0v0Zm.4,0v0Zm.221-.213v0Zm-.413,0v0Zm-.431,0v0Zm-.18-.219v0Zm.8,0v0Zm-.4-.43v0Zm1.86,0h0Zm.187-.269h0Zm0,3.971v0Zm0-.434v0Zm.221,0v0Zm-.408.213v0Zm-.214.221v0Zm0-.434v0Zm0-.461v0Zm0-.4v0Zm.214.643v0Zm.408,0v0Zm-.838-.24v0Zm-.192,0v0Zm.623-.4v0Zm-.431,0v0Zm-.406,0v0Zm.214,0v0Zm-.214-.461v0Zm0-.43v0Zm.214-.211v0Zm-.214-.221v0Zm.406,0v0Zm.431,0v0Zm.187-.218v0Zm-.4,0v0Zm-.409,0v0ZM470.988,18v0Zm.406,0v0Zm.431,0v0Zm.187-.219v0Zm-.81,0v0Zm.409-.43v0Zm-.839,2.4v0Zm0-.892v0Zm0,.43v0Zm0-.862v0Zm0-.43v0Zm0-.65v0Zm0-.429v0Zm-1.029.348h0Zm.844-.643h0Zm.808.643h0Z",
    transform: "translate(-443.933 11.568)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6641",
    "data-name": "Caminho 6641",
    d: "M469.138,21.09l-.029-.921.467-.024-.031-1.68-.19,0-.031-.892.432-.027-.023-.269-.156.027-.031-.461.24-.024v.139l.084.022h-.137v-.137l-.156.033,0,.183h.785l-.012-.216-.228.057.06-.081h.192l.029.458-.221.027.031.242h.382l-.031-.912-.19.029-.024-.466.274-.026-.06.141-.19-.087.017.189h.808l-.012-.216-.244.048.053-.074h.214l.038.463-.252.029.024.883h.382l-.029-.269-.163.027-.023-.461.24-.024v.139l.012-.007-.065.029v-.137l-.163.033.019.24.779-.053L472,16.846l-.221.057.06-.081h.186l.024.458-.209.027.024.269.382-.027.024.893-.245.026.024,1.677h.414l-.414,0v.021l.414-.024.023.919Zm2.9-.053h.42l-.013-.219-.18.024v-.024l-.406.012v.012l-1.9.012.043.183h1.6v-.2l.048.2H472v-.2Zm.228-.219h.18l-.006-.214-.4.005.007.021-.4-.014v.014l-1.915.019.048.17H471.8v-.189l.053.189h.413l-.055-.189h.055Zm-.228-.214h.4l-.005-.216h-.168v.021l-.406-.012v.012l-1.9.019L470,20.6h1.6v-.2l.048.2H472v-.2Zm-.178-.221h.352v-.2l-.19.012v-.05l-.377.01v.01l-.406-.007.012.007-1.036.014v.2h1.214l-.053-.213h.053v.213h.372v-.213Zm-.216-.237h.377v-.192l-.161.031v-.026l-.432.026v-.015l-.406.015v0l-.67.009.048.156h.789v-.161l.05.161h.358v-.161Zm.216-.192h.161l-.007-.216-.371.01v.017l-.406-.009.012.009-.624,0v.185h.389l-.042-.189h.048v.189h.394l-.041-.189h.053v.189h.425l-.053-.189h.06Zm-.216-.216h.371l0-.238-.988.029v-.012l-.269.012.053.209h.383v-.209l.05.209h.358v-.209Zm-.622-.242h.988v-.213l-1.384.029V19.5h.389l-.042-.192h.048Zm-1.437,0h1.029l-.048-.183-.988.019Zm1.221-.213h1.2L472,19.061l-.975.029v-.005l-.269.005Zm-1.228,0h1.175V19.09l-1.175.027Zm1.444-.221H472v-.219l-.747.031-.012-.012-.612.015v.185h.389l-.042-.189h.048Zm-1.444,0h1.036l-.048-.185-.993.026Zm1.672-.219H472v-.209l-.137.031v-.027l-.432.027v-.019l-.406.019v-.009l-.269.009.053.178h.433l-.05-.178h.062Zm-1.677,0h.826l-.048-.173-.778.019Zm2.287-.209H472v-.19l.048-.01-.007-.012-.395.022v-.019l-.394.019-.012-.01-.612.012v.189h.389l-.042-.19h.048v.19h.394l-.041-.19h.053v.19h.425l-.053-.19h.06Zm.185-.221h.2l-.012-.213-.37.024v-.017l-.432.017v-.012l-.406.012v0l-.269.012.053.18h.433l-.05-.189h.062v.189h.394l-.048-.189h.048v.189h.395L472,18.223h.048Zm-.185-.213h.37l-.007-.216-.178.027-.007-.024-.789.024-.012-.005-.612.012V18.2h.389l-.042-.189h.048V18.2h.394l-.041-.189h.053V18.2h.425l-.053-.189h.06Zm.185-.216h.178l0-.214-1.466.027.053.187h.433l-.05-.19h.062v.19h.789l-.042-.19h.048Zm-2.448,0h.8l-.048-.178-.754.012Zm-.245-.221h2.867l-.007-.185-.376.033v-.06l-.192.027v-.017l-.216,0v.015l-.43.033v-.036l-.814.036V17.6l-.431.014v-.026l-.4.026Zm2.052-.454.012.081.18-.021V17.36l.216-.017-.012-.063.221-.029-.007-.132h-.784l.019.161.154-.029h.432Zm-1.646.024h.408l-.006-.051.216-.029-.012-.185-.778.053.012.161.156-.029h.431l-.425.057Zm.838-.646h.377v-.048l.238-.029-.012-.189-.808.053.012.165.593-.029-.4.05Z",
    transform: "translate(-443.945 11.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6642",
    "data-name": "Caminho 6642",
    d: "M470.879,19.442v-.569c0-.106-.048-.43-.569-.43-.483,0-.538.324-.538.43v.569Z",
    transform: "translate(-443.471 13.178)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6643",
    "data-name": "Caminho 6643",
    d: "M470.914,19.483h-1.132l-.024-.595c0-.079.024-.465.563-.465.563,0,.593.386.593.465Zm-.593-1c-.485,0-.51.336-.51.4v.568l1.048-.026v-.542c0-.1-.036-.4-.538-.4",
    transform: "translate(-443.481 13.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6644",
    "data-name": "Caminho 6644",
    d: "M469.992,18.856l-.269-.027a.48.48,0,0,1,.108-.326l.245.192a.294.294,0,0,0-.084.161",
    transform: "translate(-443.506 13.222)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6645",
    "data-name": "Caminho 6645",
    d: "M470.027,18.9l-.3-.024a.391.391,0,0,1,.1-.381l.276.189a.892.892,0,0,0-.072.185Z",
    transform: "translate(-443.511 13.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6646",
    "data-name": "Caminho 6646",
    d: "M470.346,18.856l.264-.027c0-.106-.025-.271-.11-.326l-.24.192a.331.331,0,0,1,.085.161",
    transform: "translate(-443.123 13.222)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6647",
    "data-name": "Caminho 6647",
    d: "M470.324,18.9v-.031a.255.255,0,0,0-.077-.142l.25-.231c.12.058.149.225.149.348Z",
    transform: "translate(-443.132 13.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6648",
    "data-name": "Caminho 6648",
    d: "M470.284,18.68l.132-.245a.535.535,0,0,0-.24-.057.622.622,0,0,0-.216.057l.132.245Z",
    transform: "translate(-443.337 13.132)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6649",
    "data-name": "Caminho 6649",
    d: "M470.309,18.713H470.1l-.151-.254a.406.406,0,0,1,.485-.034Z",
    transform: "translate(-443.344 13.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6650",
    "data-name": "Caminho 6650",
    d: "M470.1,18.532V17.94a.284.284,0,0,0-.293-.3.289.289,0,0,0-.3.3v.592Z",
    transform: "translate(-443.661 12.605)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6651",
    "data-name": "Caminho 6651",
    d: "M470.14,18.552h-.622l-.029-.619c0-.382.651-.382.651,0Zm-.322-.888a.26.26,0,0,0-.276.269v.593l.54-.027v-.566a.25.25,0,0,0-.264-.269",
    transform: "translate(-443.673 12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6652",
    "data-name": "Caminho 6652",
    d: "M470.345,18.532V17.94a.283.283,0,0,1,.293-.3.278.278,0,0,1,.292.3v.592Z",
    transform: "translate(-443.062 12.605)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6653",
    "data-name": "Caminho 6653",
    d: "M470.976,18.553h-.616l-.036-.619c0-.386.651-.382.651,0Zm-.322-.888a.25.25,0,0,0-.264.269v.593l.533-.027v-.566a.254.254,0,0,0-.269-.269",
    transform: "translate(-443.077 12.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6654",
    "data-name": "Caminho 6654",
    d: "M470.879,17.536l.06-.538h-.521l.024.538Z",
    transform: "translate(-443.01 12.146)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6655",
    "data-name": "Caminho 6655",
    d: "M470.916,17.576h-.461l-.055-.568.552-.027Zm0-.571-.49.029.053.514.384-.029Z",
    transform: "translate(-443.022 12.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6656",
    "data-name": "Caminho 6656",
    d: "M469.988,17.536,469.939,17h.533l-.048.538Z",
    transform: "translate(-443.352 12.146)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6657",
    "data-name": "Caminho 6657",
    d: "M470.455,17.576H470l-.079-.562.563-.033Zm0-.571-.5.029.082.509.372-.024Z",
    transform: "translate(-443.364 12.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6658",
    "data-name": "Caminho 6658",
    d: "M469.95,17.534l.029-.538h-.515l.055.538Z",
    transform: "translate(-443.691 12.144)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6659",
    "data-name": "Caminho 6659",
    d: "M469.989,17.57h-.455l-.091-.559.551-.034Zm-.024-.562-.485.027.072.506.383-.019Z",
    transform: "translate(-443.705 12.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6660",
    "data-name": "Caminho 6660",
    d: "M470.617,19.362v-.49a.34.34,0,0,0-.384-.317.324.324,0,0,0-.354.317v.49Z",
    transform: "translate(-443.394 13.258)",
    fill: "#2f2aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6661",
    "data-name": "Caminho 6661",
    d: "M470.023,18.457v-.511a.241.241,0,0,0-.24-.273.249.249,0,0,0-.246.273v.511Z",
    transform: "translate(-443.638 12.628)",
    fill: "#2f2aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6662",
    "data-name": "Caminho 6662",
    d: "M470.372,18.457v-.511a.249.249,0,0,1,.245-.273.245.245,0,0,1,.24.273v.511Z",
    transform: "translate(-443.043 12.628)",
    fill: "#2f2aec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6663",
    "data-name": "Caminho 6663",
    d: "M470.687,20.489a1.95,1.95,0,1,1,3.872,0,1.95,1.95,0,1,1-3.872,0",
    transform: "translate(-442.817 13.082)",
    fill: "#9d0025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6664",
    "data-name": "Caminho 6664",
    d: "M472.639,22.722a2.108,2.108,0,0,1-1.97-2.219,1.986,1.986,0,1,1,3.945,0,2.112,2.112,0,0,1-1.975,2.219m0-4.367a2.036,2.036,0,0,0-1.9,2.148,1.915,1.915,0,1,0,3.8,0,2.04,2.04,0,0,0-1.9-2.148",
    transform: "translate(-442.83 13.067)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(28.449 31.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_787",
    "data-name": "Grupo 787",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6665",
    "data-name": "Caminho 6665",
    d: "M471.025,20.248a1.38,1.38,0,1,1,2.723,0,1.379,1.379,0,1,1-2.723,0",
    transform: "translate(-471.025 -18.642)",
    fill: "#3057bb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_790",
    "data-name": "Grupo 790",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_789",
    "data-name": "Grupo 789",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6666",
    "data-name": "Caminho 6666",
    d: "M472.4,21.893a1.537,1.537,0,0,1-1.4-1.631,1.418,1.418,0,1,1,2.8,0,1.534,1.534,0,0,1-1.4,1.631m0-3.2a1.466,1.466,0,0,0-1.329,1.565,1.343,1.343,0,1,0,2.65,0A1.456,1.456,0,0,0,472.4,18.7",
    transform: "translate(-442.593 13.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6667",
    "data-name": "Caminho 6667",
    d: "M471.631,18.936a.616.616,0,0,0-.161.338.762.762,0,0,0,.072.305.19.19,0,0,0-.175-.11.176.176,0,0,0-.185.166.333.333,0,0,0,.036.094l.06.117a.126.126,0,0,1,.24.05v.027h-.144v.129h.125l-.089.189.132-.048.089.111.1-.111.137.048-.1-.189h.125v-.129h-.137a.037.037,0,0,1-.007-.027.126.126,0,0,1,.24-.05l.06-.117a.318.318,0,0,0,.029-.094.17.17,0,0,0-.178-.166.185.185,0,0,0-.168.11.72.72,0,0,0,.077-.305.6.6,0,0,0-.173-.338",
    transform: "translate(-442.464 13.531)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6668",
    "data-name": "Caminho 6668",
    d: "M471.627,20.331h0c-.007,0-.012-.005-.019-.012l-.094-.1-.1.051.067-.219-.108.033a.522.522,0,0,1-.024-.149l.156-.015-.132.034.125.086-.077.221.108-.074.1.1.078-.093.155.043-.12-.163.144-.033-.137-.086a.14.14,0,0,1,.257-.111l.024-.113c.041-.281-.216-.273-.276-.149-.024-.063.024-.166.024-.295a.612.612,0,0,0-.162-.319c0,.024-.137.178-.137.319a.723.723,0,0,0,.065.276c-.149-.075-.341-.051-.341.087l.089.194c-.029-.108.247-.072.247.065l-.023.007a.137.137,0,0,0-.121-.108.466.466,0,0,1-.132.063v-.007l-.072-.117c-.029-.29.185-.333.3-.25a.53.53,0,0,1-.042-.211.669.669,0,0,1,.161-.353.5.5,0,0,1,.2.353.552.552,0,0,1-.036.213.2.2,0,0,1,.312.151l-.084.214-.132-.057a.106.106,0,0,0-.113.1l.125.007a.558.558,0,0,1,.017.149l-.143.021.113.163-.156-.022-.072.1-.017.012",
    transform: "translate(-442.46 13.525)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_454",
    "data-name": "Ret\\xE2ngulo 454",
    width: 0.514,
    height: 0.129,
    transform: "translate(28.91 33.456)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6669",
    "data-name": "Caminho 6669",
    d: "M471.837,19.671h-.558v-.149l.558-.022Z",
    transform: "translate(-442.394 13.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6670",
    "data-name": "Caminho 6670",
    d: "M472.363,18.936a.616.616,0,0,0-.161.338.72.72,0,0,0,.077.305.2.2,0,0,0-.18-.11.174.174,0,0,0-.173.166.6.6,0,0,0,.031.094l.053.117a.121.121,0,0,1,.12-.072.125.125,0,0,1,.125.122v.027h-.144v.129h.132l-.1.189.125-.048.1.111.1-.111.126.048-.1-.189h.137v-.129h-.149c0-.009-.007-.015-.007-.027a.124.124,0,0,1,.132-.122.131.131,0,0,1,.113.072l.055-.117a.214.214,0,0,0,.029-.094.174.174,0,0,0-.173-.166.18.18,0,0,0-.167.11.81.81,0,0,0,.066-.305.608.608,0,0,0-.168-.338",
    transform: "translate(-441.932 13.531)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6671",
    "data-name": "Caminho 6671",
    d: "M472.36,20.331h0a.012.012,0,0,1-.012-.012l-.1-.1-.108.051.072-.219-.108.033a.522.522,0,0,1-.024-.149l.156-.015-.132.034.132.086-.084.221.108-.074.089.1.091-.093.156.043-.12-.163.149-.033-.149-.086c-.048-.219.2-.219.257-.111l.017-.113c.048-.281-.2-.273-.269-.149a2.542,2.542,0,0,1,.024-.295.569.569,0,0,0-.161-.319.876.876,0,0,0-.125.319.907.907,0,0,0,.053.276c-.156-.077-.33-.051-.33.087l.077.194c-.029-.108.252-.075.252.065l-.024.007a.129.129,0,0,0-.125-.108.414.414,0,0,1-.132.063v-.007l-.06-.117c-.042-.29.173-.333.293-.25a.38.38,0,0,1-.048-.211.616.616,0,0,1,.168-.353.5.5,0,0,1,.2.353.74.74,0,0,1-.036.213c.1-.1.31,0,.31.151l-.1.214-.125-.057a.109.109,0,0,0-.113.1l.137.007a1.206,1.206,0,0,1,.017.149l-.154.021.12.163-.156-.022-.077.1-.019.012",
    transform: "translate(-441.929 13.525)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_455",
    "data-name": "Ret\\xE2ngulo 455",
    width: 0.521,
    height: 0.129,
    transform: "translate(30.179 33.456)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6672",
    "data-name": "Caminho 6672",
    d: "M472.583,19.671h-.562v-.149l.562-.022Z",
    transform: "translate(-441.865 13.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6673",
    "data-name": "Caminho 6673",
    d: "M471.993,19.572a.624.624,0,0,0-.156.341.7.7,0,0,0,.072.3.177.177,0,0,0-.173-.1.168.168,0,0,0-.18.163.273.273,0,0,0,.031.1l.053.113a.13.13,0,0,1,.125-.063.119.119,0,0,1,.127.12.054.054,0,0,1-.007.029h-.144v.127h.132l-.1.19.137-.053.084.113.1-.113.127.053-.1-.19h.138v-.127h-.149v-.029a.116.116,0,0,1,.12-.12.12.12,0,0,1,.118.063l.06-.113a.307.307,0,0,0,.031-.1.171.171,0,0,0-.18-.163.19.19,0,0,0-.173.1.7.7,0,0,0,.072-.3.609.609,0,0,0-.168-.341",
    transform: "translate(-442.197 13.985)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6674",
    "data-name": "Caminho 6674",
    d: "M471.989,20.966h0l-.012-.007-.1-.11-.108.057.072-.221-.108.033-.024-.146.163-.019-.139.039.024.1.108-.021-.083.214.108-.077.1.1.089-.1.151.046-.12-.163.149-.026-.024-.1-.125.021a.144.144,0,0,1,.262-.117l.019-.117c.048-.285-.2-.269-.276-.147-.018-.06.031-.168.031-.293a.6.6,0,0,0-.168-.326c.012.021-.125.178-.125.326a.566.566,0,0,0,.065.269c-.156-.072-.348-.05-.348.087l.091.2c-.036-.117.245-.075.245.065h-.023a.123.123,0,0,0-.121-.1.646.646,0,0,1-.137.057h-.005l-.05-.12c-.046-.29.168-.336.288-.254a.5.5,0,0,1-.041-.207.6.6,0,0,1,.161-.353.474.474,0,0,1,.2.353,1.031,1.031,0,0,1-.024.213c.084-.1.305,0,.305.144l-.084.221-.142-.053a.1.1,0,0,0-.108.1l.137.007.012.149-.149.021.113.161-.149-.029-.079.11-.012.007Z",
    transform: "translate(-442.192 13.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_456",
    "data-name": "Ret\\xE2ngulo 456",
    width: 0.521,
    height: 0.125,
    transform: "translate(29.545 34.551)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6675",
    "data-name": "Caminho 6675",
    d: "M472.207,20.307h-.534l-.023-.146.545-.024Z",
    transform: "translate(-442.13 14.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6676",
    "data-name": "Caminho 6676",
    d: "M474.307,16.335l-.031,0a.415.415,0,0,1-.029.048.1.1,0,0,1-.108.01.09.09,0,0,1-.017-.051.074.074,0,0,1-.055,0,.08.08,0,0,1-.024-.1c.012,0,.012-.012.024-.012l-.012-.046-.036.012-.017.017a.056.056,0,0,1-.084.022c-.005-.005-.017-.027-.005-.027l-.024.012c-.072.014-.1-.127-.1-.163l-.024.029a.421.421,0,0,1,.012.156.821.821,0,0,1-.036.142,1.128,1.128,0,0,1,.358.2,1.205,1.205,0,0,1,.282.288.8.8,0,0,1,.139-.06.95.95,0,0,1,.161-.024l.024-.022c-.031,0-.185.01-.185-.05,0-.017,0-.022,0-.022a.061.061,0,0,1-.029-.012c-.024-.012-.024-.048,0-.079l.024-.019v-.036l-.043.007-.024.012a.06.06,0,0,1-.089.005.054.054,0,0,1-.012-.053.072.072,0,0,1-.06-.007.067.067,0,0,1-.012-.1c.012-.015.029-.031.036-.039l-.012-.034Z",
    transform: "translate(-440.633 11.475)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6677",
    "data-name": "Caminho 6677",
    d: "M474.374,16.892l-.005-.012a1.067,1.067,0,0,0-.276-.288,1.2,1.2,0,0,0-.346-.192c-.012-.017.012-.089.024-.158a.675.675,0,0,0-.012-.153.03.03,0,0,1,.024.012c0-.015-.007-.033-.007-.041a.166.166,0,0,1,.019.05c.024.031.053.1.084.1l.125.005v-.026l.018.041-.106.021a.148.148,0,0,1-.115-.11.276.276,0,0,1,0,.11,1.262,1.262,0,0,1-.036.144.806.806,0,0,1,.348.173,1.057,1.057,0,0,1,.274.285.628.628,0,0,1,.127-.06.687.687,0,0,1,.125-.021.148.148,0,0,1-.113-.024l-.019-.077.149.077a.031.031,0,0,1,.007.024c.072-.009,0,0,0,0-.007.029-.079.033-.137.051a.767.767,0,0,0-.139.065Zm.132-.237-.012-.063-.125-.024-.012.012-.1-.108.055-.113-.121.063-.132-.1.012.024.007-.014.113.065.137-.06-.041.132.089.093.163-.015Z",
    transform: "translate(-440.634 11.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6678",
    "data-name": "Caminho 6678",
    d: "M473.92,16.27c0-.005.024-.005.029,0V16.3a.076.076,0,0,1-.029,0c0-.007-.007-.021,0-.027",
    transform: "translate(-440.509 11.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6679",
    "data-name": "Caminho 6679",
    d: "M474,16.353l-.036-.041s-.012-.01,0-.012a.01.01,0,0,1,.017,0l.042.029.042.031a.021.021,0,0,1,0,.024.018.018,0,0,1-.017-.007Z",
    transform: "translate(-440.482 11.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6680",
    "data-name": "Caminho 6680",
    d: "M473.88,16.258l-.031-.015c-.005,0-.017-.012-.005-.021s.005-.005.012,0l.036.017.029.012a.027.027,0,0,1,.012.022.022.022,0,0,1-.017.009Z",
    transform: "translate(-440.566 11.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6681",
    "data-name": "Caminho 6681",
    d: "M473.786,16.2a.027.027,0,0,1,.043.031c-.007,0-.024,0-.031-.01s-.012-.014-.012-.021",
    transform: "translate(-440.603 11.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6682",
    "data-name": "Caminho 6682",
    d: "M474.076,16.389a.046.046,0,0,0-.007-.027.029.029,0,0,0-.029,0,.02.02,0,0,0,.005.027.033.033,0,0,0,.031,0",
    transform: "translate(-440.424 11.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6683",
    "data-name": "Caminho 6683",
    d: "M474.116,16.44l.019.029c.012,0,.012.01.024,0v-.017l-.031-.024-.017-.029a.08.08,0,0,0-.031,0v.021Z",
    transform: "translate(-440.393 11.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6684",
    "data-name": "Caminho 6684",
    d: "M474.173,16.488c.007-.009,0-.017-.005-.024l-.024,0c-.007,0,0,.019.005.027a.016.016,0,0,0,.024,0",
    transform: "translate(-440.349 11.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6685",
    "data-name": "Caminho 6685",
    d: "M474,16.058l-.06,0-.012.1v.021h.019l.089-.065Z",
    transform: "translate(-440.503 11.475)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6686",
    "data-name": "Caminho 6686",
    d: "M473.86,16.1v.069l.113.012.019-.009-.007-.019-.065-.081Z",
    transform: "translate(-440.551 11.487)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6687",
    "data-name": "Caminho 6687",
    d: "M474.045,16.2l-.061.036-.065-.084v-.021l.024-.007.1.015Z",
    transform: "translate(-440.508 11.52)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6688",
    "data-name": "Caminho 6688",
    d: "M473.915,16.131a.029.029,0,0,1,.043-.015.034.034,0,0,1,0,.045.025.025,0,0,1-.036.012.026.026,0,0,1-.012-.041",
    transform: "translate(-440.516 11.513)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6689",
    "data-name": "Caminho 6689",
    d: "M473.79,16.118s-.014-.053-.024-.084a.406.406,0,0,0-.05-.053.114.114,0,0,1,.1.015c.043.038-.006.1-.006.1a.056.056,0,0,1-.022.017",
    transform: "translate(-440.654 11.415)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6690",
    "data-name": "Caminho 6690",
    d: "M473.88,16.107l-.041.041-.084-.069.005-.012v-.014l.113-.01Z",
    transform: "translate(-440.625 11.464)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6691",
    "data-name": "Caminho 6691",
    d: "M473.755,16.068c.007-.021.019-.031.036-.027s.012.021.012.043-.024.026-.036.021-.024-.021-.012-.036",
    transform: "translate(-440.631 11.461)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6692",
    "data-name": "Caminho 6692",
    d: "M474.166,16.166l-.06-.015-.036.1.007.015h.024l.1-.045Z",
    transform: "translate(-440.401 11.541)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6693",
    "data-name": "Caminho 6693",
    d: "M474.012,16.182l0,.069.106.031.019-.01v-.014l-.048-.1Z",
    transform: "translate(-440.445 11.548)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6694",
    "data-name": "Caminho 6694",
    d: "M474.177,16.3l-.053.029-.055-.1v-.015h.019l.1.027Z",
    transform: "translate(-440.401 11.588)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6695",
    "data-name": "Caminho 6695",
    d: "M474.062,16.218a.033.033,0,0,1,.048-.009c.024.017.024.033,0,.048s-.036.021-.053.005a.038.038,0,0,1,0-.045",
    transform: "translate(-440.411 11.578)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6696",
    "data-name": "Caminho 6696",
    d: "M474.318,16.293l.012.065-.108.039-.017-.009-.007-.019.048-.1Z",
    transform: "translate(-440.308 11.629)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6697",
    "data-name": "Caminho 6697",
    d: "M474.3,16.436l-.06.015-.048-.1.012-.019h.019l.1.039Z",
    transform: "translate(-440.314 11.674)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6698",
    "data-name": "Caminho 6698",
    d: "M474.16,16.293l-.024.065.108.043.012,0,.005-.017-.036-.1Z",
    transform: "translate(-440.353 11.632)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6699",
    "data-name": "Caminho 6699",
    d: "M474.24,16.377a.038.038,0,0,0,.005-.045c-.017-.012-.046-.012-.053,0a.032.032,0,0,0,0,.045c.007.015.029.015.048,0",
    transform: "translate(-440.32 11.664)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6700",
    "data-name": "Caminho 6700",
    d: "M474.306,16.505a.388.388,0,0,1,.1.014.187.187,0,0,1,.065.027s.012-.048-.043-.089-.1.017-.1.017a.1.1,0,0,1-.024.031",
    transform: "translate(-440.232 11.751)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6701",
    "data-name": "Caminho 6701",
    d: "M474.29,16.419l-.036.057.089.057.012-.009.012-.005-.012-.1Z",
    transform: "translate(-440.268 11.733)",
    fill: "#c1b020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6702",
    "data-name": "Caminho 6702",
    d: "M474.342,16.5c.005-.012.017-.031.005-.039a.06.06,0,0,0-.036,0,.031.031,0,0,0-.017.038c.012.012.024.012.048,0",
    transform: "translate(-440.242 11.764)",
    fill: "#c1b020"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEsp);
export default __webpack_public_path__ + "static/media/flag_ESP.8f7c1839649cb8c49eee6a7e36234d54.svg";
export { ForwardRef as ReactComponent };